/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router';

import { Route as rootRouteImport } from './routes/__root';
import { Route as LayoutAuthRouteRouteImport } from './routes/_layoutAuth/route';
import { Route as PrivateRouteRouteImport } from './routes/_private/route';
import { Route as EventsRouteRouteImport } from './routes/events/route';
import { Route as RegistrationRouteRouteImport } from './routes/registration.route';
import { Route as LayoutAuthGuestRouteRouteImport } from './routes/_layoutAuth/_guest/route';
import { Route as PrivateIndexRouteRouteImport } from './routes/_private/index.route';
import { Route as PrivateRouteRouteRouteImport } from './routes/_private/_route/route';
import { Route as EventsRsvpRouteRouteImport } from './routes/events/rsvp.route';
import { Route as LayoutAuthLogoutIndexRouteRouteImport } from './routes/_layoutAuth/logout/index.route';
import { Route as LayoutAuthMaintenanceIndexRouteRouteImport } from './routes/_layoutAuth/maintenance/index.route';
import { Route as PrivateAuthSetPasswordRouteRouteImport } from './routes/_private/_auth/set-password.route';
import { Route as PrivateRouteSplatRouteRouteImport } from './routes/_private/_route/$.route';
import { Route as PrivateRouteInternalRouteRouteImport } from './routes/_private/_route/_internal/route';
import { Route as PrivateRouteProfileRouteRouteImport } from './routes/_private/_route/profile/route';
import { Route as PrivateTeamsIndexRouteRouteImport } from './routes/_private/teams/index.route';
import { Route as LayoutAuthGuestEmailResponseIndexRouteRouteImport } from './routes/_layoutAuth/_guest/email-response/index.route';
import { Route as LayoutAuthGuestJoinIndexRouteRouteImport } from './routes/_layoutAuth/_guest/join/index.route';
import { Route as LayoutAuthGuestLoginIndexRouteRouteImport } from './routes/_layoutAuth/_guest/login/index.route';
import { Route as PrivateAuthSignupIndexRouteRouteImport } from './routes/_private/_auth/signup/index.route';
import { Route as PrivateRouteInternalAdminRouteRouteImport } from './routes/_private/_route/_internal/admin/route';
import { Route as PrivateRouteInternalEventsRouteRouteImport } from './routes/_private/_route/_internal/events/route';
import { Route as PrivateRouteInternalPipelinesRouteRouteImport } from './routes/_private/_route/_internal/pipelines/route';
import { Route as PrivateRouteInternalTasksRouteRouteImport } from './routes/_private/_route/_internal/tasks/route';
import { Route as PrivateRouteInternalTrendingRouteRouteImport } from './routes/_private/_route/_internal/trending/route';
import { Route as PrivateRouteProfileIndexRouteRouteImport } from './routes/_private/_route/profile/index.route';
import { Route as PrivateRouteTeamsTeamIdRouteRouteImport } from './routes/_private/_route/teams/$teamId/route';
import { Route as PrivateRouteUsersIndexRouteRouteImport } from './routes/_private/_route/users/index.route';
import { Route as PrivateRouteUsersUserIdRouteRouteImport } from './routes/_private/_route/users/$userId/route';
import { Route as PrivateTeamsTeamIdIndexRouteRouteImport } from './routes/_private/teams/$teamId.index.route';
import { Route as PrivateRouteInternalCandidatesCandidateIdRouteRouteImport } from './routes/_private/_route/_internal/candidates/$candidateId/route';
import { Route as PrivateRouteInternalCompaniesIndexRouteRouteImport } from './routes/_private/_route/_internal/companies/index.route';
import { Route as PrivateRouteInternalEventsIndexRouteRouteImport } from './routes/_private/_route/_internal/events/index.route';
import { Route as PrivateRouteInternalEventsEventIdRouteRouteImport } from './routes/_private/_route/_internal/events/$eventId/route';
import { Route as PrivateRouteInternalExperimentsIndexRouteRouteImport } from './routes/_private/_route/_internal/experiments/index.route';
import { Route as PrivateRouteInternalHomeIndexRouteRouteImport } from './routes/_private/_route/_internal/home/index.route';
import { Route as PrivateRouteInternalIntroductionsIndexRouteRouteImport } from './routes/_private/_route/_internal/introductions/index.route';
import { Route as PrivateRouteInternalPeersIndexRouteRouteImport } from './routes/_private/_route/_internal/peers/index.route';
import { Route as PrivateRouteInternalPeopleIndexRouteRouteImport } from './routes/_private/_route/_internal/people/index.route';
import { Route as PrivateRouteInternalPeopleIdentityIdRouteRouteImport } from './routes/_private/_route/_internal/people/$identityId/route';
import { Route as PrivateRouteInternalPerformanceIndexRouteRouteImport } from './routes/_private/_route/_internal/performance/index.route';
import { Route as PrivateRouteInternalPipelineSubmissionsIndexRouteRouteImport } from './routes/_private/_route/_internal/pipeline-submissions/index.route';
import { Route as PrivateRouteInternalPipelinesIndexRouteRouteImport } from './routes/_private/_route/_internal/pipelines/index/route';
import { Route as PrivateRouteInternalPipelinesNewRouteRouteImport } from './routes/_private/_route/_internal/pipelines_/new/route';
import { Route as PrivateRouteInternalSearchSubmissionsIndexRouteRouteImport } from './routes/_private/_route/_internal/search-submissions/index.route';
import { Route as PrivateRouteInternalSearchesIndexRouteRouteImport } from './routes/_private/_route/_internal/searches/index.route';
import { Route as PrivateRouteInternalTasksIndexRouteRouteImport } from './routes/_private/_route/_internal/tasks/index.route';
import { Route as PrivateRouteInternalToolsIndexRouteRouteImport } from './routes/_private/_route/_internal/tools/index.route';
import { Route as PrivateRouteInternalTrendingIndexRouteRouteImport } from './routes/_private/_route/_internal/trending/index.route';
import { Route as PrivateRouteProfileTeamsIndexRouteRouteImport } from './routes/_private/_route/profile/teams/index.route';
import { Route as PrivateRouteTeamsTeamIdCandidatesRouteRouteImport } from './routes/_private/_route/teams/$teamId/candidates/route';
import { Route as PrivateRouteTeamsTeamIdNetworkRouteRouteImport } from './routes/_private/_route/teams/$teamId/network/route';
import { Route as PrivateRouteUsersUserIdIndexRouteRouteImport } from './routes/_private/_route/users/$userId/index.route';
import { Route as PrivateRouteUsersUserIdPeopleRouteRouteImport } from './routes/_private/_route/users/$userId/people/route';
import { Route as PrivateRouteUsersUserIdTrendingRouteRouteImport } from './routes/_private/_route/users/$userId/trending/route';
import { Route as PrivateRouteUsersNewIndexRouteRouteImport } from './routes/_private/_route/users/new/index.route';
import { Route as PrivateRouteInternalAdminUsersIndexRouteRouteImport } from './routes/_private/_route/_internal/admin/users/index.route';
import { Route as PrivateRouteInternalAdminUsersUserIdRouteRouteImport } from './routes/_private/_route/_internal/admin/users/$userId/route';
import { Route as PrivateRouteInternalCandidatesCandidateIdIndexRouteRouteImport } from './routes/_private/_route/_internal/candidates/$candidateId/index.route';
import { Route as PrivateRouteInternalCandidatesCandidateIdTasksRouteRouteImport } from './routes/_private/_route/_internal/candidates/$candidateId/tasks/route';
import { Route as PrivateRouteInternalCandidatesNewIndexRouteRouteImport } from './routes/_private/_route/_internal/candidates/new/index.route';
import { Route as PrivateRouteInternalEventsEventIdIndexRouteRouteImport } from './routes/_private/_route/_internal/events/$eventId/index.route';
import { Route as PrivateRouteInternalEventsEventIdParticipantsRouteRouteImport } from './routes/_private/_route/_internal/events/$eventId/participants/route';
import { Route as PrivateRouteInternalEventsEventsIndexRouteRouteImport } from './routes/_private/_route/_internal/events/events/index.route';
import { Route as PrivateRouteInternalEventsNewIndexRouteRouteImport } from './routes/_private/_route/_internal/events/new/index.route';
import { Route as PrivateRouteInternalEventsParticipantsIndexRouteRouteImport } from './routes/_private/_route/_internal/events/participants/index.route';
import { Route as PrivateRouteInternalEventsParticipantsParticipantIdRouteRouteImport } from './routes/_private/_route/_internal/events/participants/$participantId/route';
import { Route as PrivateRouteInternalEventsSettingsIndexRouteRouteImport } from './routes/_private/_route/_internal/events/settings/index.route';
import { Route as PrivateRouteInternalIntroductionSubmissionsSubmissionIdIndexRouteRouteImport } from './routes/_private/_route/_internal/introduction-submissions/$submissionId/index.route';
import { Route as PrivateRouteInternalPeersNewIndexRouteRouteImport } from './routes/_private/_route/_internal/peers/new/index.route';
import { Route as PrivateRouteInternalPeopleIdentityIdIndexRouteRouteImport } from './routes/_private/_route/_internal/people/$identityId/index.route';
import { Route as PrivateRouteInternalPeopleIdentityIdCandidateRouteRouteImport } from './routes/_private/_route/_internal/people/$identityId/_candidate/route';
import { Route as PrivateRouteInternalPipelineSubmissionsSubmissionIdIndexRouteRouteImport } from './routes/_private/_route/_internal/pipeline-submissions/$submissionId/index.route';
import { Route as PrivateRouteInternalTasksExecutiveServicesIndexRouteRouteImport } from './routes/_private/_route/_internal/tasks/executive-services/index.route';
import { Route as PrivateRouteInternalTasksMeIndexRouteRouteImport } from './routes/_private/_route/_internal/tasks/me/index.route';
import { Route as PrivateRouteInternalToolsAiCandidateDiscoveryIndexRouteRouteImport } from './routes/_private/_route/_internal/tools/ai-candidate-discovery/index.route';
import { Route as PrivateRouteInternalToolsEmailTemplatesIndexRouteRouteImport } from './routes/_private/_route/_internal/tools/email-templates/index.route';
import { Route as PrivateRouteInternalToolsMarketSearchesIndexRouteRouteImport } from './routes/_private/_route/_internal/tools/market-searches/index.route';
import { Route as PrivateRouteInternalToolsMergePeopleIndexRouteRouteImport } from './routes/_private/_route/_internal/tools/merge-people/index.route';
import { Route as PrivateRouteInternalToolsMoveTeamIndexRouteRouteImport } from './routes/_private/_route/_internal/tools/move-team/index.route';
import { Route as PrivateRouteInternalToolsPathwayActivityDefaultsIndexRouteRouteImport } from './routes/_private/_route/_internal/tools/pathway-activity-defaults/index.route';
import { Route as PrivateRouteInternalTrendingSubmissionIdIndexRouteRouteImport } from './routes/_private/_route/_internal/trending/$submissionId/index.route';
import { Route as PrivateRouteInternalTrendingCampaignsIndexRouteRouteImport } from './routes/_private/_route/_internal/trending/campaigns/index.route';
import { Route as PrivateRouteInternalTrendingNewIndexRouteRouteImport } from './routes/_private/_route/_internal/trending/new/index.route';
import { Route as PrivateRouteInternalTrendingPeopleIndexRouteRouteImport } from './routes/_private/_route/_internal/trending/people/index.route';
import { Route as PrivateRouteTeamsTeamIdCandidatesCandidateIdRouteRouteImport } from './routes/_private/_route/teams/$teamId/candidates/$candidateId/route';
import { Route as PrivateRouteTeamsTeamIdHomeIndexRouteRouteImport } from './routes/_private/_route/teams/$teamId/home/index.route';
import { Route as PrivateRouteTeamsTeamIdIntroductionsIndexRouteRouteImport } from './routes/_private/_route/teams/$teamId/introductions/index.route';
import { Route as PrivateRouteTeamsTeamIdPipelinesIndexRouteRouteImport } from './routes/_private/_route/teams/$teamId/pipelines/index.route';
import { Route as PrivateRouteTeamsTeamIdPipelinesNewRouteRouteImport } from './routes/_private/_route/teams/$teamId/pipelines/new.route';
import { Route as PrivateRouteTeamsTeamIdSearchesIndexRouteRouteImport } from './routes/_private/_route/teams/$teamId/searches/index.route';
import { Route as PrivateRouteTeamsTeamIdSettingsIndexRouteRouteImport } from './routes/_private/_route/teams/$teamId/settings/index.route';
import { Route as PrivateRouteTeamsTeamIdTrendingIndexRouteImport } from './routes/_private/_route/teams/$teamId/trending/index';
import { Route as PrivateRouteUsersUserIdEventsIndexRouteRouteImport } from './routes/_private/_route/users/$userId/events/index.route';
import { Route as PrivateRouteUsersUserIdPeopleCandidateIdRouteRouteImport } from './routes/_private/_route/users/$userId/people/$candidateId/route';
import { Route as PrivateRouteUsersUserIdPipelinesIndexRouteRouteImport } from './routes/_private/_route/users/$userId/pipelines/index.route';
import { Route as PrivateRouteUsersUserIdPipelinesNewRouteRouteImport } from './routes/_private/_route/users/$userId/pipelines/new.route';
import { Route as PrivateRouteUsersUserIdSettingsIndexRouteRouteImport } from './routes/_private/_route/users/$userId/settings/index.route';
import { Route as PrivateRouteUsersUserIdTrendingIndexRouteImport } from './routes/_private/_route/users/$userId/trending/index';
import { Route as PrivateRouteInternalAdminUsersNewIndexRouteRouteImport } from './routes/_private/_route/_internal/admin/users/new/index.route';
import { Route as PrivateRouteInternalCandidatesCandidateIdAboutIndexRouteRouteImport } from './routes/_private/_route/_internal/candidates/$candidateId/about/index.route';
import { Route as PrivateRouteInternalCandidatesCandidateIdAccountsIndexRouteRouteImport } from './routes/_private/_route/_internal/candidates/$candidateId/accounts/index.route';
import { Route as PrivateRouteInternalCandidatesCandidateIdCompareIndexRouteRouteImport } from './routes/_private/_route/_internal/candidates/$candidateId/compare/index.route';
import { Route as PrivateRouteInternalCandidatesCandidateIdFeedbackIndexRouteRouteImport } from './routes/_private/_route/_internal/candidates/$candidateId/feedback/index.route';
import { Route as PrivateRouteInternalCandidatesCandidateIdPerformanceIndexRouteRouteImport } from './routes/_private/_route/_internal/candidates/$candidateId/performance/index.route';
import { Route as PrivateRouteInternalCandidatesCandidateIdProfileIndexRouteRouteImport } from './routes/_private/_route/_internal/candidates/$candidateId/profile/index.route';
import { Route as PrivateRouteInternalCandidatesCandidateIdRecommendationsIndexRouteRouteImport } from './routes/_private/_route/_internal/candidates/$candidateId/recommendations.index.route';
import { Route as PrivateRouteInternalCandidatesCandidateIdSuggestedPipelinesIndexRouteRouteImport } from './routes/_private/_route/_internal/candidates/$candidateId/suggested-pipelines/index.route';
import { Route as PrivateRouteInternalCompaniesCompanyIdPeopleIndexRouteRouteImport } from './routes/_private/_route/_internal/companies/$companyId/people/index.route';
import { Route as PrivateRouteInternalCompaniesCompanyIdSettingsIndexRouteRouteImport } from './routes/_private/_route/_internal/companies/$companyId/settings/index.route';
import { Route as PrivateRouteInternalEventsEventIdDetailsIndexRouteRouteImport } from './routes/_private/_route/_internal/events/$eventId/details/index.route';
import { Route as PrivateRouteInternalEventsEventIdEmailSettingsIndexRouteRouteImport } from './routes/_private/_route/_internal/events/$eventId/email-settings/index.route';
import { Route as PrivateRouteInternalEventsEventIdEmailsIndexRouteRouteImport } from './routes/_private/_route/_internal/events/$eventId/emails/index.route';
import { Route as PrivateRouteInternalEventsParticipantsParticipantIdIndexRouteRouteImport } from './routes/_private/_route/_internal/events/participants/$participantId/index.route';
import { Route as PrivateRouteInternalPeopleIdentityIdCandidateTasksRouteRouteImport } from './routes/_private/_route/_internal/people/$identityId/_candidate/tasks/route';
import { Route as PrivateRouteInternalPeopleIdentityIdAccountsIndexRouteRouteImport } from './routes/_private/_route/_internal/people/$identityId/accounts/index.route';
import { Route as PrivateRouteInternalPeopleIdentityIdEmailsIndexRouteRouteImport } from './routes/_private/_route/_internal/people/$identityId/emails/index.route';
import { Route as PrivateRouteInternalTrendingSubmissionIdEditIndexRouteRouteImport } from './routes/_private/_route/_internal/trending/$submissionId/edit/index.route';
import { Route as PrivateRouteTeamsTeamIdCandidatesCandidateIdIndexRouteRouteImport } from './routes/_private/_route/teams/$teamId/candidates/$candidateId/index.route';
import { Route as PrivateRouteTeamsTeamIdCandidatesCandidateIdTabIdRouteRouteImport } from './routes/_private/_route/teams/$teamId/candidates/$candidateId/$tabId.route';
import { Route as PrivateRouteTeamsTeamIdIntroductionsCandidateIdIndexRouteRouteImport } from './routes/_private/_route/teams/$teamId/introductions/$candidateId/index.route';
import { Route as PrivateRouteTeamsTeamIdPipelinesPipelineIdEditRouteRouteImport } from './routes/_private/_route/teams/$teamId/pipelines_/$pipelineId/edit.route';
import { Route as PrivateRouteTeamsTeamIdSearchesSearchIdIndexRouteRouteImport } from './routes/_private/_route/teams/$teamId/searches/$searchId/index.route';
import { Route as PrivateRouteTeamsTeamIdTrendingRecommendationIdIndexRouteRouteImport } from './routes/_private/_route/teams/$teamId/trending/$recommendationId/index.route';
import { Route as PrivateRouteUsersUserIdEventsEventIdIndexRouteRouteImport } from './routes/_private/_route/users/$userId/events/$eventId/index.route';
import { Route as PrivateRouteUsersUserIdPipelinesPipelineIdIndexRouteRouteImport } from './routes/_private/_route/users/$userId/pipelines/$pipelineId/index.route';
import { Route as PrivateRouteUsersUserIdPipelinesPipelineIdEditRouteRouteImport } from './routes/_private/_route/users/$userId/pipelines/$pipelineId/edit.route';
import { Route as PrivateRouteUsersUserIdTrendingRecommendationIdIndexRouteRouteImport } from './routes/_private/_route/users/$userId/trending/$recommendationId/index.route';
import { Route as PrivateRouteInternalAdminUsersUserIdSettingsIndexRouteRouteImport } from './routes/_private/_route/_internal/admin/users/$userId/settings/index.route';
import { Route as PrivateRouteInternalEventsEventIdParticipantsNewIndexRouteRouteImport } from './routes/_private/_route/_internal/events/$eventId/participants/new/index.route';
import { Route as PrivateRouteInternalPeopleIdentityIdCandidateAboutIndexRouteRouteImport } from './routes/_private/_route/_internal/people/$identityId/_candidate/about/index.route';
import { Route as PrivateRouteInternalPeopleIdentityIdCandidateCompareIndexRouteRouteImport } from './routes/_private/_route/_internal/people/$identityId/_candidate/compare/index.route';
import { Route as PrivateRouteInternalPeopleIdentityIdCandidateFeedbackIndexRouteRouteImport } from './routes/_private/_route/_internal/people/$identityId/_candidate/feedback/index.route';
import { Route as PrivateRouteInternalPeopleIdentityIdCandidatePerformanceIndexRouteRouteImport } from './routes/_private/_route/_internal/people/$identityId/_candidate/performance/index.route';
import { Route as PrivateRouteInternalPeopleIdentityIdCandidateProfileIndexRouteRouteImport } from './routes/_private/_route/_internal/people/$identityId/_candidate/profile/index.route';
import { Route as PrivateRouteInternalPeopleIdentityIdCandidateRecommendationsIndexRouteRouteImport } from './routes/_private/_route/_internal/people/$identityId/_candidate/recommendations.index.route';
import { Route as PrivateRouteInternalPeopleIdentityIdCandidateSuggestedPipelinesIndexRouteRouteImport } from './routes/_private/_route/_internal/people/$identityId/_candidate/suggested-pipelines/index.route';
import { Route as PrivateRouteTeamsTeamIdCandidatesCandidateIdActivityIndexRouteRouteImport } from './routes/_private/_route/teams/$teamId/candidates/$candidateId/activity/index.route';
import { Route as PrivateRouteTeamsTeamIdCandidatesCandidateIdPipelinesIndexRouteRouteImport } from './routes/_private/_route/teams/$teamId/candidates/$candidateId/pipelines/index.route';
import { Route as PrivateRouteTeamsTeamIdPipelinesPipelineIdInternalIndexRouteRouteImport } from './routes/_private/_route/teams/$teamId/pipelines/$pipelineId/_internal/index/route';
import { Route as PrivateRouteTeamsTeamIdPipelinesPipelineIdInternalRecommendationsRouteRouteImport } from './routes/_private/_route/teams/$teamId/pipelines/$pipelineId/_internal/recommendations/route';
import { Route as PrivateRouteTeamsTeamIdPipelinesPipelineIdRecommendationsNewRouteRouteImport } from './routes/_private/_route/teams/$teamId/pipelines/$pipelineId_/recommendations/new/route';
import { Route as PrivateRouteUsersUserIdPipelinesPipelineIdRecommendationsNewRouteRouteImport } from './routes/_private/_route/users/$userId/pipelines/$pipelineId_/recommendations/new/route';
import { Route as PrivateRouteInternalCandidatesCandidateIdTasksGoalsGoalIdIndexRouteRouteImport } from './routes/_private/_route/_internal/candidates/$candidateId/tasks/goals/$goalId/index.route';
import { Route as PrivateRouteTeamsTeamIdPipelinesPipelineIdInternalRecommendationsIndexRouteRouteImport } from './routes/_private/_route/teams/$teamId/pipelines/$pipelineId/_internal/recommendations/index.route';
import { Route as PrivateRouteTeamsTeamIdPipelinesPipelineIdIntroductionsCandidateIdIndexRouteRouteImport } from './routes/_private/_route/teams/$teamId/pipelines/$pipelineId/introductions.$candidateId.index.route';
import { Route as PrivateRouteTeamsTeamIdPipelinesPipelineIdSubmissionsSubmissionIdIndexRouteRouteImport } from './routes/_private/_route/teams/$teamId/pipelines/$pipelineId_/submissions.$submissionId.index.route';
import { Route as PrivateRouteTeamsTeamIdSearchesSearchIdCandidatesCandidateIdIndexRouteRouteImport } from './routes/_private/_route/teams/$teamId/searches/$searchId/candidates/$candidateId/index.route';
import { Route as PrivateRouteUsersUserIdPipelinesPipelineIdRecommendationsRecommendationIdIndexRouteRouteImport } from './routes/_private/_route/users/$userId/pipelines/$pipelineId/recommendations.$recommendationId.index.route';
import { Route as PrivateRouteInternalPeopleIdentityIdCandidateTasksGoalsGoalIdIndexRouteRouteImport } from './routes/_private/_route/_internal/people/$identityId/_candidate/tasks/goals/$goalId/index.route';
import { Route as PrivateRouteInternalTeamsTeamIdSearchesSearchIdSubmissionsSubmissionIdIndexRouteRouteImport } from './routes/_private/_route/_internal/teams/$teamId/searches/$searchId/submissions/$submissionId/index.route';
import { Route as PrivateRouteTeamsTeamIdPipelinesPipelineIdInternalRecommendationsRecommendationIdIndexRouteRouteImport } from './routes/_private/_route/teams/$teamId/pipelines/$pipelineId/_internal/recommendations/$recommendationId/index.route';

const PrivateAuthLazyRouteImport = createFileRoute('/_private/_auth')();
const PrivateRouteTeamsTeamIdTrendingLazyRouteImport = createFileRoute(
  '/_private/_route/teams/$teamId/trending',
)();
const PrivateRouteTeamsTeamIdPipelinesPipelineIdLazyRouteImport =
  createFileRoute('/_private/_route/teams/$teamId/pipelines/$pipelineId')();
const PrivateRouteTeamsTeamIdPipelinesPipelineIdInternalLazyRouteImport =
  createFileRoute(
    '/_private/_route/teams/$teamId/pipelines/$pipelineId/_internal',
  )();
const PrivateRouteInternalPeopleIdentityIdCandidateTasksIndexLazyRouteImport =
  createFileRoute(
    '/_private/_route/_internal/people/$identityId/_candidate/tasks/',
  )();

const LayoutAuthRouteRoute = LayoutAuthRouteRouteImport.update({
  id: '/_layoutAuth',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/_layoutAuth/lazy').then((d) => d.Route));
const PrivateRouteRoute = PrivateRouteRouteImport.update({
  id: '/_private',
  getParentRoute: () => rootRouteImport,
} as any);
const EventsRouteRoute = EventsRouteRouteImport.update({
  id: '/events',
  path: '/events',
  getParentRoute: () => rootRouteImport,
} as any);
const RegistrationRouteRoute = RegistrationRouteRouteImport.update({
  id: '/registration',
  path: '/registration',
  getParentRoute: () => rootRouteImport,
} as any);
const LayoutAuthGuestRouteRoute = LayoutAuthGuestRouteRouteImport.update({
  id: '/_guest',
  getParentRoute: () => LayoutAuthRouteRoute,
} as any);
const PrivateIndexRouteRoute = PrivateIndexRouteRouteImport.update({
  id: '/',
  path: '',
  getParentRoute: () => PrivateRouteRoute,
} as any);
const PrivateAuthLazyRoute = PrivateAuthLazyRouteImport.update({
  id: '/_auth',
  getParentRoute: () => PrivateRouteRoute,
} as any).lazy(() =>
  import('./routes/_private/_auth/lazy').then((d) => d.Route),
);
const PrivateRouteRouteRoute = PrivateRouteRouteRouteImport.update({
  id: '/_route',
  getParentRoute: () => PrivateRouteRoute,
} as any).lazy(() =>
  import('./routes/_private/_route/lazy').then((d) => d.Route),
);
const EventsRsvpRouteRoute = EventsRsvpRouteRouteImport.update({
  id: '/rsvp',
  path: '/rsvp',
  getParentRoute: () => EventsRouteRoute,
} as any).lazy(() => import('./routes/events/rsvp.lazy').then((d) => d.Route));
const LayoutAuthLogoutIndexRouteRoute =
  LayoutAuthLogoutIndexRouteRouteImport.update({
    id: '/logout/',
    path: '/logout',
    getParentRoute: () => LayoutAuthRouteRoute,
  } as any).lazy(() =>
    import('./routes/_layoutAuth/logout/index.lazy').then((d) => d.Route),
  );
const LayoutAuthMaintenanceIndexRouteRoute =
  LayoutAuthMaintenanceIndexRouteRouteImport.update({
    id: '/maintenance/',
    path: '/maintenance',
    getParentRoute: () => LayoutAuthRouteRoute,
  } as any).lazy(() =>
    import('./routes/_layoutAuth/maintenance/index.lazy').then((d) => d.Route),
  );
const PrivateAuthSetPasswordRouteRoute =
  PrivateAuthSetPasswordRouteRouteImport.update({
    id: '/set-password',
    path: '/set-password',
    getParentRoute: () => PrivateAuthLazyRoute,
  } as any);
const PrivateRouteSplatRouteRoute = PrivateRouteSplatRouteRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => PrivateRouteRouteRoute,
} as any).lazy(() =>
  import('./routes/_private/_route/$.lazy').then((d) => d.Route),
);
const PrivateRouteInternalRouteRoute =
  PrivateRouteInternalRouteRouteImport.update({
    id: '/_internal',
    getParentRoute: () => PrivateRouteRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/_internal/lazy').then((d) => d.Route),
  );
const PrivateRouteProfileRouteRoute =
  PrivateRouteProfileRouteRouteImport.update({
    id: '/profile',
    path: '/profile',
    getParentRoute: () => PrivateRouteRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/profile/lazy').then((d) => d.Route),
  );
const PrivateTeamsIndexRouteRoute = PrivateTeamsIndexRouteRouteImport.update({
  id: '/teams/',
  path: '/teams',
  getParentRoute: () => PrivateRouteRoute,
} as any);
const LayoutAuthGuestEmailResponseIndexRouteRoute =
  LayoutAuthGuestEmailResponseIndexRouteRouteImport.update({
    id: '/email-response/',
    path: '/email-response',
    getParentRoute: () => LayoutAuthGuestRouteRoute,
  } as any).lazy(() =>
    import('./routes/_layoutAuth/_guest/email-response/index.lazy').then(
      (d) => d.Route,
    ),
  );
const LayoutAuthGuestJoinIndexRouteRoute =
  LayoutAuthGuestJoinIndexRouteRouteImport.update({
    id: '/join/',
    path: '/join',
    getParentRoute: () => LayoutAuthGuestRouteRoute,
  } as any).lazy(() =>
    import('./routes/_layoutAuth/_guest/join/index.lazy').then((d) => d.Route),
  );
const LayoutAuthGuestLoginIndexRouteRoute =
  LayoutAuthGuestLoginIndexRouteRouteImport.update({
    id: '/login/',
    path: '/login',
    getParentRoute: () => LayoutAuthGuestRouteRoute,
  } as any).lazy(() =>
    import('./routes/_layoutAuth/_guest/login/index.lazy').then((d) => d.Route),
  );
const PrivateAuthSignupIndexRouteRoute =
  PrivateAuthSignupIndexRouteRouteImport.update({
    id: '/signup/',
    path: '/signup',
    getParentRoute: () => PrivateAuthLazyRoute,
  } as any).lazy(() =>
    import('./routes/_private/_auth/signup/index.lazy').then((d) => d.Route),
  );
const PrivateRouteInternalAdminRouteRoute =
  PrivateRouteInternalAdminRouteRouteImport.update({
    id: '/admin',
    path: '/admin',
    getParentRoute: () => PrivateRouteInternalRouteRoute,
  } as any);
const PrivateRouteInternalEventsRouteRoute =
  PrivateRouteInternalEventsRouteRouteImport.update({
    id: '/events',
    path: '/events',
    getParentRoute: () => PrivateRouteInternalRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/_internal/events/lazy').then(
      (d) => d.Route,
    ),
  );
const PrivateRouteInternalPipelinesRouteRoute =
  PrivateRouteInternalPipelinesRouteRouteImport.update({
    id: '/pipelines',
    path: '/pipelines',
    getParentRoute: () => PrivateRouteInternalRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/_internal/pipelines/lazy').then(
      (d) => d.Route,
    ),
  );
const PrivateRouteInternalTasksRouteRoute =
  PrivateRouteInternalTasksRouteRouteImport.update({
    id: '/tasks',
    path: '/tasks',
    getParentRoute: () => PrivateRouteInternalRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/_internal/tasks/lazy').then(
      (d) => d.Route,
    ),
  );
const PrivateRouteInternalTrendingRouteRoute =
  PrivateRouteInternalTrendingRouteRouteImport.update({
    id: '/trending',
    path: '/trending',
    getParentRoute: () => PrivateRouteInternalRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/_internal/trending/lazy').then(
      (d) => d.Route,
    ),
  );
const PrivateRouteProfileIndexRouteRoute =
  PrivateRouteProfileIndexRouteRouteImport.update({
    id: '/',
    path: '',
    getParentRoute: () => PrivateRouteProfileRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/profile/index.lazy').then((d) => d.Route),
  );
const PrivateRouteTeamsTeamIdRouteRoute =
  PrivateRouteTeamsTeamIdRouteRouteImport.update({
    id: '/teams/$teamId',
    path: '/teams/$teamId',
    getParentRoute: () => PrivateRouteRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/teams/$teamId/lazy').then((d) => d.Route),
  );
const PrivateRouteUsersIndexRouteRoute =
  PrivateRouteUsersIndexRouteRouteImport.update({
    id: '/users/',
    path: '/users',
    getParentRoute: () => PrivateRouteRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/users/index.lazy').then((d) => d.Route),
  );
const PrivateRouteUsersUserIdRouteRoute =
  PrivateRouteUsersUserIdRouteRouteImport.update({
    id: '/users/$userId',
    path: '/users/$userId',
    getParentRoute: () => PrivateRouteRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/users/$userId/lazy').then((d) => d.Route),
  );
const PrivateTeamsTeamIdIndexRouteRoute =
  PrivateTeamsTeamIdIndexRouteRouteImport.update({
    id: '/teams/$teamId/',
    path: '/teams/$teamId',
    getParentRoute: () => PrivateRouteRoute,
  } as any);
const PrivateRouteInternalCandidatesCandidateIdRouteRoute =
  PrivateRouteInternalCandidatesCandidateIdRouteRouteImport.update({
    id: '/candidates/$candidateId',
    path: '/candidates/$candidateId',
    getParentRoute: () => PrivateRouteInternalRouteRoute,
  } as any);
const PrivateRouteInternalCompaniesIndexRouteRoute =
  PrivateRouteInternalCompaniesIndexRouteRouteImport.update({
    id: '/companies/',
    path: '/companies',
    getParentRoute: () => PrivateRouteInternalRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/_internal/companies/index.lazy').then(
      (d) => d.Route,
    ),
  );
const PrivateRouteInternalEventsIndexRouteRoute =
  PrivateRouteInternalEventsIndexRouteRouteImport.update({
    id: '/',
    path: '',
    getParentRoute: () => PrivateRouteInternalEventsRouteRoute,
  } as any);
const PrivateRouteInternalEventsEventIdRouteRoute =
  PrivateRouteInternalEventsEventIdRouteRouteImport.update({
    id: '/$eventId',
    path: '/$eventId',
    getParentRoute: () => PrivateRouteInternalEventsRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/_internal/events/$eventId/lazy').then(
      (d) => d.Route,
    ),
  );
const PrivateRouteInternalExperimentsIndexRouteRoute =
  PrivateRouteInternalExperimentsIndexRouteRouteImport.update({
    id: '/experiments/',
    path: '/experiments',
    getParentRoute: () => PrivateRouteInternalRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/_internal/experiments/index.lazy').then(
      (d) => d.Route,
    ),
  );
const PrivateRouteInternalHomeIndexRouteRoute =
  PrivateRouteInternalHomeIndexRouteRouteImport.update({
    id: '/home/',
    path: '/home',
    getParentRoute: () => PrivateRouteInternalRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/_internal/home/index.lazy').then(
      (d) => d.Route,
    ),
  );
const PrivateRouteInternalIntroductionsIndexRouteRoute =
  PrivateRouteInternalIntroductionsIndexRouteRouteImport.update({
    id: '/introductions/',
    path: '/introductions',
    getParentRoute: () => PrivateRouteInternalRouteRoute,
  } as any);
const PrivateRouteInternalPeersIndexRouteRoute =
  PrivateRouteInternalPeersIndexRouteRouteImport.update({
    id: '/peers/',
    path: '/peers',
    getParentRoute: () => PrivateRouteInternalRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/_internal/peers/index.lazy').then(
      (d) => d.Route,
    ),
  );
const PrivateRouteInternalPeopleIndexRouteRoute =
  PrivateRouteInternalPeopleIndexRouteRouteImport.update({
    id: '/people/',
    path: '/people',
    getParentRoute: () => PrivateRouteInternalRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/_internal/people/index.lazy').then(
      (d) => d.Route,
    ),
  );
const PrivateRouteInternalPeopleIdentityIdRouteRoute =
  PrivateRouteInternalPeopleIdentityIdRouteRouteImport.update({
    id: '/people/$identityId',
    path: '/people/$identityId',
    getParentRoute: () => PrivateRouteInternalRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/_internal/people/$identityId/lazy').then(
      (d) => d.Route,
    ),
  );
const PrivateRouteInternalPerformanceIndexRouteRoute =
  PrivateRouteInternalPerformanceIndexRouteRouteImport.update({
    id: '/performance/',
    path: '/performance',
    getParentRoute: () => PrivateRouteInternalRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/_internal/performance/index.lazy').then(
      (d) => d.Route,
    ),
  );
const PrivateRouteInternalPipelineSubmissionsIndexRouteRoute =
  PrivateRouteInternalPipelineSubmissionsIndexRouteRouteImport.update({
    id: '/pipeline-submissions/',
    path: '/pipeline-submissions',
    getParentRoute: () => PrivateRouteInternalRouteRoute,
  } as any);
const PrivateRouteInternalPipelinesIndexRouteRoute =
  PrivateRouteInternalPipelinesIndexRouteRouteImport.update({
    id: '/',
    path: '',
    getParentRoute: () => PrivateRouteInternalPipelinesRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/_internal/pipelines/index/lazy').then(
      (d) => d.Route,
    ),
  );
const PrivateRouteInternalPipelinesNewRouteRoute =
  PrivateRouteInternalPipelinesNewRouteRouteImport.update({
    id: '/pipelines_/new',
    path: '/pipelines/new',
    getParentRoute: () => PrivateRouteInternalRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/_internal/pipelines_/new/lazy').then(
      (d) => d.Route,
    ),
  );
const PrivateRouteInternalSearchSubmissionsIndexRouteRoute =
  PrivateRouteInternalSearchSubmissionsIndexRouteRouteImport.update({
    id: '/search-submissions/',
    path: '/search-submissions',
    getParentRoute: () => PrivateRouteInternalRouteRoute,
  } as any);
const PrivateRouteInternalSearchesIndexRouteRoute =
  PrivateRouteInternalSearchesIndexRouteRouteImport.update({
    id: '/searches/',
    path: '/searches',
    getParentRoute: () => PrivateRouteInternalRouteRoute,
  } as any);
const PrivateRouteInternalTasksIndexRouteRoute =
  PrivateRouteInternalTasksIndexRouteRouteImport.update({
    id: '/',
    path: '',
    getParentRoute: () => PrivateRouteInternalTasksRouteRoute,
  } as any);
const PrivateRouteInternalToolsIndexRouteRoute =
  PrivateRouteInternalToolsIndexRouteRouteImport.update({
    id: '/tools/',
    path: '/tools',
    getParentRoute: () => PrivateRouteInternalRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/_internal/tools/index.lazy').then(
      (d) => d.Route,
    ),
  );
const PrivateRouteInternalTrendingIndexRouteRoute =
  PrivateRouteInternalTrendingIndexRouteRouteImport.update({
    id: '/',
    path: '',
    getParentRoute: () => PrivateRouteInternalTrendingRouteRoute,
  } as any);
const PrivateRouteProfileTeamsIndexRouteRoute =
  PrivateRouteProfileTeamsIndexRouteRouteImport.update({
    id: '/teams/',
    path: '/teams',
    getParentRoute: () => PrivateRouteProfileRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/profile/teams/index.lazy').then(
      (d) => d.Route,
    ),
  );
const PrivateRouteTeamsTeamIdCandidatesRouteRoute =
  PrivateRouteTeamsTeamIdCandidatesRouteRouteImport.update({
    id: '/candidates',
    path: '/candidates',
    getParentRoute: () => PrivateRouteTeamsTeamIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/teams/$teamId/candidates/lazy').then(
      (d) => d.Route,
    ),
  );
const PrivateRouteTeamsTeamIdNetworkRouteRoute =
  PrivateRouteTeamsTeamIdNetworkRouteRouteImport.update({
    id: '/network',
    path: '/network',
    getParentRoute: () => PrivateRouteTeamsTeamIdRouteRoute,
  } as any);
const PrivateRouteTeamsTeamIdTrendingLazyRoute =
  PrivateRouteTeamsTeamIdTrendingLazyRouteImport.update({
    id: '/trending',
    path: '/trending',
    getParentRoute: () => PrivateRouteTeamsTeamIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/teams/$teamId/trending/lazy').then(
      (d) => d.Route,
    ),
  );
const PrivateRouteUsersUserIdIndexRouteRoute =
  PrivateRouteUsersUserIdIndexRouteRouteImport.update({
    id: '/',
    path: '',
    getParentRoute: () => PrivateRouteUsersUserIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/users/$userId/index.lazy').then(
      (d) => d.Route,
    ),
  );
const PrivateRouteUsersUserIdPeopleRouteRoute =
  PrivateRouteUsersUserIdPeopleRouteRouteImport.update({
    id: '/people',
    path: '/people',
    getParentRoute: () => PrivateRouteUsersUserIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/users/$userId/people/lazy').then(
      (d) => d.Route,
    ),
  );
const PrivateRouteUsersUserIdTrendingRouteRoute =
  PrivateRouteUsersUserIdTrendingRouteRouteImport.update({
    id: '/trending',
    path: '/trending',
    getParentRoute: () => PrivateRouteUsersUserIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/users/$userId/trending/lazy').then(
      (d) => d.Route,
    ),
  );
const PrivateRouteUsersNewIndexRouteRoute =
  PrivateRouteUsersNewIndexRouteRouteImport.update({
    id: '/users/new/',
    path: '/users/new',
    getParentRoute: () => PrivateRouteRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/users/new/index.lazy').then(
      (d) => d.Route,
    ),
  );
const PrivateRouteInternalAdminUsersIndexRouteRoute =
  PrivateRouteInternalAdminUsersIndexRouteRouteImport.update({
    id: '/users/',
    path: '/users',
    getParentRoute: () => PrivateRouteInternalAdminRouteRoute,
  } as any);
const PrivateRouteInternalAdminUsersUserIdRouteRoute =
  PrivateRouteInternalAdminUsersUserIdRouteRouteImport.update({
    id: '/users/$userId',
    path: '/users/$userId',
    getParentRoute: () => PrivateRouteInternalAdminRouteRoute,
  } as any);
const PrivateRouteInternalCandidatesCandidateIdIndexRouteRoute =
  PrivateRouteInternalCandidatesCandidateIdIndexRouteRouteImport.update({
    id: '/',
    path: '',
    getParentRoute: () => PrivateRouteInternalCandidatesCandidateIdRouteRoute,
  } as any);
const PrivateRouteInternalCandidatesCandidateIdTasksRouteRoute =
  PrivateRouteInternalCandidatesCandidateIdTasksRouteRouteImport.update({
    id: '/tasks',
    path: '/tasks',
    getParentRoute: () => PrivateRouteInternalCandidatesCandidateIdRouteRoute,
  } as any);
const PrivateRouteInternalCandidatesNewIndexRouteRoute =
  PrivateRouteInternalCandidatesNewIndexRouteRouteImport.update({
    id: '/candidates/new/',
    path: '/candidates/new',
    getParentRoute: () => PrivateRouteInternalRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/_internal/candidates/new/index.lazy').then(
      (d) => d.Route,
    ),
  );
const PrivateRouteInternalEventsEventIdIndexRouteRoute =
  PrivateRouteInternalEventsEventIdIndexRouteRouteImport.update({
    id: '/',
    path: '',
    getParentRoute: () => PrivateRouteInternalEventsEventIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/_internal/events/$eventId/index.lazy').then(
      (d) => d.Route,
    ),
  );
const PrivateRouteInternalEventsEventIdParticipantsRouteRoute =
  PrivateRouteInternalEventsEventIdParticipantsRouteRouteImport.update({
    id: '/participants',
    path: '/participants',
    getParentRoute: () => PrivateRouteInternalEventsEventIdRouteRoute,
  } as any);
const PrivateRouteInternalEventsEventsIndexRouteRoute =
  PrivateRouteInternalEventsEventsIndexRouteRouteImport.update({
    id: '/events/',
    path: '/events',
    getParentRoute: () => PrivateRouteInternalEventsRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/_internal/events/events/index.lazy').then(
      (d) => d.Route,
    ),
  );
const PrivateRouteInternalEventsNewIndexRouteRoute =
  PrivateRouteInternalEventsNewIndexRouteRouteImport.update({
    id: '/new/',
    path: '/new',
    getParentRoute: () => PrivateRouteInternalEventsRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/_internal/events/new/index.lazy').then(
      (d) => d.Route,
    ),
  );
const PrivateRouteInternalEventsParticipantsIndexRouteRoute =
  PrivateRouteInternalEventsParticipantsIndexRouteRouteImport.update({
    id: '/participants/',
    path: '/participants',
    getParentRoute: () => PrivateRouteInternalEventsRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/_internal/events/participants/index.lazy').then(
      (d) => d.Route,
    ),
  );
const PrivateRouteInternalEventsParticipantsParticipantIdRouteRoute =
  PrivateRouteInternalEventsParticipantsParticipantIdRouteRouteImport.update({
    id: '/participants/$participantId',
    path: '/participants/$participantId',
    getParentRoute: () => PrivateRouteInternalEventsRouteRoute,
  } as any);
const PrivateRouteInternalEventsSettingsIndexRouteRoute =
  PrivateRouteInternalEventsSettingsIndexRouteRouteImport.update({
    id: '/settings/',
    path: '/settings',
    getParentRoute: () => PrivateRouteInternalEventsRouteRoute,
  } as any);
const PrivateRouteInternalIntroductionSubmissionsSubmissionIdIndexRouteRoute =
  PrivateRouteInternalIntroductionSubmissionsSubmissionIdIndexRouteRouteImport.update(
    {
      id: '/introduction-submissions/$submissionId/',
      path: '/introduction-submissions/$submissionId',
      getParentRoute: () => PrivateRouteInternalRouteRoute,
    } as any,
  );
const PrivateRouteInternalPeersNewIndexRouteRoute =
  PrivateRouteInternalPeersNewIndexRouteRouteImport.update({
    id: '/peers/new/',
    path: '/peers/new',
    getParentRoute: () => PrivateRouteInternalRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/_internal/peers/new/index.lazy').then(
      (d) => d.Route,
    ),
  );
const PrivateRouteInternalPeopleIdentityIdIndexRouteRoute =
  PrivateRouteInternalPeopleIdentityIdIndexRouteRouteImport.update({
    id: '/',
    path: '',
    getParentRoute: () => PrivateRouteInternalPeopleIdentityIdRouteRoute,
  } as any);
const PrivateRouteInternalPeopleIdentityIdCandidateRouteRoute =
  PrivateRouteInternalPeopleIdentityIdCandidateRouteRouteImport.update({
    id: '/_candidate',
    getParentRoute: () => PrivateRouteInternalPeopleIdentityIdRouteRoute,
  } as any);
const PrivateRouteInternalPipelineSubmissionsSubmissionIdIndexRouteRoute =
  PrivateRouteInternalPipelineSubmissionsSubmissionIdIndexRouteRouteImport.update(
    {
      id: '/pipeline-submissions/$submissionId/',
      path: '/pipeline-submissions/$submissionId',
      getParentRoute: () => PrivateRouteInternalRouteRoute,
    } as any,
  );
const PrivateRouteInternalTasksExecutiveServicesIndexRouteRoute =
  PrivateRouteInternalTasksExecutiveServicesIndexRouteRouteImport.update({
    id: '/executive-services/',
    path: '/executive-services',
    getParentRoute: () => PrivateRouteInternalTasksRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/_internal/tasks/executive-services/index.lazy').then(
      (d) => d.Route,
    ),
  );
const PrivateRouteInternalTasksMeIndexRouteRoute =
  PrivateRouteInternalTasksMeIndexRouteRouteImport.update({
    id: '/me/',
    path: '/me',
    getParentRoute: () => PrivateRouteInternalTasksRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/_internal/tasks/me/index.lazy').then(
      (d) => d.Route,
    ),
  );
const PrivateRouteInternalToolsAiCandidateDiscoveryIndexRouteRoute =
  PrivateRouteInternalToolsAiCandidateDiscoveryIndexRouteRouteImport.update({
    id: '/tools/ai-candidate-discovery/',
    path: '/tools/ai-candidate-discovery',
    getParentRoute: () => PrivateRouteInternalRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/_internal/tools/ai-candidate-discovery/index.lazy').then(
      (d) => d.Route,
    ),
  );
const PrivateRouteInternalToolsEmailTemplatesIndexRouteRoute =
  PrivateRouteInternalToolsEmailTemplatesIndexRouteRouteImport.update({
    id: '/tools/email-templates/',
    path: '/tools/email-templates',
    getParentRoute: () => PrivateRouteInternalRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/_internal/tools/email-templates/index.lazy').then(
      (d) => d.Route,
    ),
  );
const PrivateRouteInternalToolsMarketSearchesIndexRouteRoute =
  PrivateRouteInternalToolsMarketSearchesIndexRouteRouteImport.update({
    id: '/tools/market-searches/',
    path: '/tools/market-searches',
    getParentRoute: () => PrivateRouteInternalRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/_internal/tools/market-searches/index.lazy').then(
      (d) => d.Route,
    ),
  );
const PrivateRouteInternalToolsMergePeopleIndexRouteRoute =
  PrivateRouteInternalToolsMergePeopleIndexRouteRouteImport.update({
    id: '/tools/merge-people/',
    path: '/tools/merge-people',
    getParentRoute: () => PrivateRouteInternalRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/_internal/tools/merge-people/index.lazy').then(
      (d) => d.Route,
    ),
  );
const PrivateRouteInternalToolsMoveTeamIndexRouteRoute =
  PrivateRouteInternalToolsMoveTeamIndexRouteRouteImport.update({
    id: '/tools/move-team/',
    path: '/tools/move-team',
    getParentRoute: () => PrivateRouteInternalRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/_internal/tools/move-team/index.lazy').then(
      (d) => d.Route,
    ),
  );
const PrivateRouteInternalToolsPathwayActivityDefaultsIndexRouteRoute =
  PrivateRouteInternalToolsPathwayActivityDefaultsIndexRouteRouteImport.update({
    id: '/tools/pathway-activity-defaults/',
    path: '/tools/pathway-activity-defaults',
    getParentRoute: () => PrivateRouteInternalRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/_internal/tools/pathway-activity-defaults/index.lazy').then(
      (d) => d.Route,
    ),
  );
const PrivateRouteInternalTrendingSubmissionIdIndexRouteRoute =
  PrivateRouteInternalTrendingSubmissionIdIndexRouteRouteImport.update({
    id: '/$submissionId/',
    path: '/$submissionId',
    getParentRoute: () => PrivateRouteInternalTrendingRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/_internal/trending/$submissionId/index.lazy').then(
      (d) => d.Route,
    ),
  );
const PrivateRouteInternalTrendingCampaignsIndexRouteRoute =
  PrivateRouteInternalTrendingCampaignsIndexRouteRouteImport.update({
    id: '/campaigns/',
    path: '/campaigns',
    getParentRoute: () => PrivateRouteInternalTrendingRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/_internal/trending/campaigns/index.lazy').then(
      (d) => d.Route,
    ),
  );
const PrivateRouteInternalTrendingNewIndexRouteRoute =
  PrivateRouteInternalTrendingNewIndexRouteRouteImport.update({
    id: '/new/',
    path: '/new',
    getParentRoute: () => PrivateRouteInternalTrendingRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/_internal/trending/new/index.lazy').then(
      (d) => d.Route,
    ),
  );
const PrivateRouteInternalTrendingPeopleIndexRouteRoute =
  PrivateRouteInternalTrendingPeopleIndexRouteRouteImport.update({
    id: '/people/',
    path: '/people',
    getParentRoute: () => PrivateRouteInternalTrendingRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/_internal/trending/people/index.lazy').then(
      (d) => d.Route,
    ),
  );
const PrivateRouteTeamsTeamIdCandidatesCandidateIdRouteRoute =
  PrivateRouteTeamsTeamIdCandidatesCandidateIdRouteRouteImport.update({
    id: '/$candidateId',
    path: '/$candidateId',
    getParentRoute: () => PrivateRouteTeamsTeamIdCandidatesRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/teams/$teamId/candidates/$candidateId/lazy').then(
      (d) => d.Route,
    ),
  );
const PrivateRouteTeamsTeamIdHomeIndexRouteRoute =
  PrivateRouteTeamsTeamIdHomeIndexRouteRouteImport.update({
    id: '/home/',
    path: '/home',
    getParentRoute: () => PrivateRouteTeamsTeamIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/teams/$teamId/home/index.lazy').then(
      (d) => d.Route,
    ),
  );
const PrivateRouteTeamsTeamIdIntroductionsIndexRouteRoute =
  PrivateRouteTeamsTeamIdIntroductionsIndexRouteRouteImport.update({
    id: '/introductions/',
    path: '/introductions',
    getParentRoute: () => PrivateRouteTeamsTeamIdRouteRoute,
  } as any);
const PrivateRouteTeamsTeamIdPipelinesIndexRouteRoute =
  PrivateRouteTeamsTeamIdPipelinesIndexRouteRouteImport.update({
    id: '/pipelines/',
    path: '/pipelines',
    getParentRoute: () => PrivateRouteTeamsTeamIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/teams/$teamId/pipelines/index.lazy').then(
      (d) => d.Route,
    ),
  );
const PrivateRouteTeamsTeamIdPipelinesPipelineIdLazyRoute =
  PrivateRouteTeamsTeamIdPipelinesPipelineIdLazyRouteImport.update({
    id: '/pipelines/$pipelineId',
    path: '/pipelines/$pipelineId',
    getParentRoute: () => PrivateRouteTeamsTeamIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/teams/$teamId/pipelines/$pipelineId/lazy').then(
      (d) => d.Route,
    ),
  );
const PrivateRouteTeamsTeamIdPipelinesNewRouteRoute =
  PrivateRouteTeamsTeamIdPipelinesNewRouteRouteImport.update({
    id: '/pipelines/new',
    path: '/pipelines/new',
    getParentRoute: () => PrivateRouteTeamsTeamIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/teams/$teamId/pipelines/new.lazy').then(
      (d) => d.Route,
    ),
  );
const PrivateRouteTeamsTeamIdSearchesIndexRouteRoute =
  PrivateRouteTeamsTeamIdSearchesIndexRouteRouteImport.update({
    id: '/searches/',
    path: '/searches',
    getParentRoute: () => PrivateRouteTeamsTeamIdRouteRoute,
  } as any);
const PrivateRouteTeamsTeamIdSettingsIndexRouteRoute =
  PrivateRouteTeamsTeamIdSettingsIndexRouteRouteImport.update({
    id: '/settings/',
    path: '/settings',
    getParentRoute: () => PrivateRouteTeamsTeamIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/teams/$teamId/settings/index.lazy').then(
      (d) => d.Route,
    ),
  );
const PrivateRouteTeamsTeamIdTrendingIndexRoute =
  PrivateRouteTeamsTeamIdTrendingIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => PrivateRouteTeamsTeamIdTrendingLazyRoute,
  } as any);
const PrivateRouteUsersUserIdEventsIndexRouteRoute =
  PrivateRouteUsersUserIdEventsIndexRouteRouteImport.update({
    id: '/events/',
    path: '/events',
    getParentRoute: () => PrivateRouteUsersUserIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/users/$userId/events/index.lazy').then(
      (d) => d.Route,
    ),
  );
const PrivateRouteUsersUserIdPeopleCandidateIdRouteRoute =
  PrivateRouteUsersUserIdPeopleCandidateIdRouteRouteImport.update({
    id: '/$candidateId',
    path: '/$candidateId',
    getParentRoute: () => PrivateRouteUsersUserIdPeopleRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/users/$userId/people/$candidateId/lazy').then(
      (d) => d.Route,
    ),
  );
const PrivateRouteUsersUserIdPipelinesIndexRouteRoute =
  PrivateRouteUsersUserIdPipelinesIndexRouteRouteImport.update({
    id: '/pipelines/',
    path: '/pipelines',
    getParentRoute: () => PrivateRouteUsersUserIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/users/$userId/pipelines/index.lazy').then(
      (d) => d.Route,
    ),
  );
const PrivateRouteUsersUserIdPipelinesNewRouteRoute =
  PrivateRouteUsersUserIdPipelinesNewRouteRouteImport.update({
    id: '/pipelines/new',
    path: '/pipelines/new',
    getParentRoute: () => PrivateRouteUsersUserIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/users/$userId/pipelines/new.lazy').then(
      (d) => d.Route,
    ),
  );
const PrivateRouteUsersUserIdSettingsIndexRouteRoute =
  PrivateRouteUsersUserIdSettingsIndexRouteRouteImport.update({
    id: '/settings/',
    path: '/settings',
    getParentRoute: () => PrivateRouteUsersUserIdRouteRoute,
  } as any);
const PrivateRouteUsersUserIdTrendingIndexRoute =
  PrivateRouteUsersUserIdTrendingIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => PrivateRouteUsersUserIdTrendingRouteRoute,
  } as any);
const PrivateRouteInternalAdminUsersNewIndexRouteRoute =
  PrivateRouteInternalAdminUsersNewIndexRouteRouteImport.update({
    id: '/users/new/',
    path: '/users/new',
    getParentRoute: () => PrivateRouteInternalAdminRouteRoute,
  } as any);
const PrivateRouteInternalCandidatesCandidateIdAboutIndexRouteRoute =
  PrivateRouteInternalCandidatesCandidateIdAboutIndexRouteRouteImport.update({
    id: '/about/',
    path: '/about',
    getParentRoute: () => PrivateRouteInternalCandidatesCandidateIdRouteRoute,
  } as any);
const PrivateRouteInternalCandidatesCandidateIdAccountsIndexRouteRoute =
  PrivateRouteInternalCandidatesCandidateIdAccountsIndexRouteRouteImport.update(
    {
      id: '/accounts/',
      path: '/accounts',
      getParentRoute: () => PrivateRouteInternalCandidatesCandidateIdRouteRoute,
    } as any,
  );
const PrivateRouteInternalCandidatesCandidateIdCompareIndexRouteRoute =
  PrivateRouteInternalCandidatesCandidateIdCompareIndexRouteRouteImport.update({
    id: '/compare/',
    path: '/compare',
    getParentRoute: () => PrivateRouteInternalCandidatesCandidateIdRouteRoute,
  } as any);
const PrivateRouteInternalCandidatesCandidateIdFeedbackIndexRouteRoute =
  PrivateRouteInternalCandidatesCandidateIdFeedbackIndexRouteRouteImport.update(
    {
      id: '/feedback/',
      path: '/feedback',
      getParentRoute: () => PrivateRouteInternalCandidatesCandidateIdRouteRoute,
    } as any,
  );
const PrivateRouteInternalCandidatesCandidateIdPerformanceIndexRouteRoute =
  PrivateRouteInternalCandidatesCandidateIdPerformanceIndexRouteRouteImport.update(
    {
      id: '/performance/',
      path: '/performance',
      getParentRoute: () => PrivateRouteInternalCandidatesCandidateIdRouteRoute,
    } as any,
  );
const PrivateRouteInternalCandidatesCandidateIdProfileIndexRouteRoute =
  PrivateRouteInternalCandidatesCandidateIdProfileIndexRouteRouteImport.update({
    id: '/profile/',
    path: '/profile',
    getParentRoute: () => PrivateRouteInternalCandidatesCandidateIdRouteRoute,
  } as any);
const PrivateRouteInternalCandidatesCandidateIdRecommendationsIndexRouteRoute =
  PrivateRouteInternalCandidatesCandidateIdRecommendationsIndexRouteRouteImport.update(
    {
      id: '/recommendations/',
      path: '/recommendations',
      getParentRoute: () => PrivateRouteInternalCandidatesCandidateIdRouteRoute,
    } as any,
  );
const PrivateRouteInternalCandidatesCandidateIdSuggestedPipelinesIndexRouteRoute =
  PrivateRouteInternalCandidatesCandidateIdSuggestedPipelinesIndexRouteRouteImport.update(
    {
      id: '/suggested-pipelines/',
      path: '/suggested-pipelines',
      getParentRoute: () => PrivateRouteInternalCandidatesCandidateIdRouteRoute,
    } as any,
  );
const PrivateRouteInternalCompaniesCompanyIdPeopleIndexRouteRoute =
  PrivateRouteInternalCompaniesCompanyIdPeopleIndexRouteRouteImport.update({
    id: '/companies/$companyId/people/',
    path: '/companies/$companyId/people',
    getParentRoute: () => PrivateRouteInternalRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/_internal/companies/$companyId/people/index.lazy').then(
      (d) => d.Route,
    ),
  );
const PrivateRouteInternalCompaniesCompanyIdSettingsIndexRouteRoute =
  PrivateRouteInternalCompaniesCompanyIdSettingsIndexRouteRouteImport.update({
    id: '/companies/$companyId/settings/',
    path: '/companies/$companyId/settings',
    getParentRoute: () => PrivateRouteInternalRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/_internal/companies/$companyId/settings/index.lazy').then(
      (d) => d.Route,
    ),
  );
const PrivateRouteInternalEventsEventIdDetailsIndexRouteRoute =
  PrivateRouteInternalEventsEventIdDetailsIndexRouteRouteImport.update({
    id: '/details/',
    path: '/details',
    getParentRoute: () => PrivateRouteInternalEventsEventIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/_internal/events/$eventId/details/index.lazy').then(
      (d) => d.Route,
    ),
  );
const PrivateRouteInternalEventsEventIdEmailSettingsIndexRouteRoute =
  PrivateRouteInternalEventsEventIdEmailSettingsIndexRouteRouteImport.update({
    id: '/email-settings/',
    path: '/email-settings',
    getParentRoute: () => PrivateRouteInternalEventsEventIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/_internal/events/$eventId/email-settings/index.lazy').then(
      (d) => d.Route,
    ),
  );
const PrivateRouteInternalEventsEventIdEmailsIndexRouteRoute =
  PrivateRouteInternalEventsEventIdEmailsIndexRouteRouteImport.update({
    id: '/emails/',
    path: '/emails',
    getParentRoute: () => PrivateRouteInternalEventsEventIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/_internal/events/$eventId/emails/index.lazy').then(
      (d) => d.Route,
    ),
  );
const PrivateRouteInternalEventsParticipantsParticipantIdIndexRouteRoute =
  PrivateRouteInternalEventsParticipantsParticipantIdIndexRouteRouteImport.update(
    {
      id: '/',
      path: '',
      getParentRoute: () =>
        PrivateRouteInternalEventsParticipantsParticipantIdRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_private/_route/_internal/events/participants/$participantId/index.lazy').then(
      (d) => d.Route,
    ),
  );
const PrivateRouteInternalPeopleIdentityIdCandidateTasksRouteRoute =
  PrivateRouteInternalPeopleIdentityIdCandidateTasksRouteRouteImport.update({
    id: '/tasks',
    path: '/tasks',
    getParentRoute: () =>
      PrivateRouteInternalPeopleIdentityIdCandidateRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/_internal/people/$identityId/_candidate/tasks/lazy').then(
      (d) => d.Route,
    ),
  );
const PrivateRouteInternalPeopleIdentityIdAccountsIndexRouteRoute =
  PrivateRouteInternalPeopleIdentityIdAccountsIndexRouteRouteImport.update({
    id: '/accounts/',
    path: '/accounts',
    getParentRoute: () => PrivateRouteInternalPeopleIdentityIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/_internal/people/$identityId/accounts/index.lazy').then(
      (d) => d.Route,
    ),
  );
const PrivateRouteInternalPeopleIdentityIdEmailsIndexRouteRoute =
  PrivateRouteInternalPeopleIdentityIdEmailsIndexRouteRouteImport.update({
    id: '/emails/',
    path: '/emails',
    getParentRoute: () => PrivateRouteInternalPeopleIdentityIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/_internal/people/$identityId/emails/index.lazy').then(
      (d) => d.Route,
    ),
  );
const PrivateRouteInternalTrendingSubmissionIdEditIndexRouteRoute =
  PrivateRouteInternalTrendingSubmissionIdEditIndexRouteRouteImport.update({
    id: '/$submissionId/edit/',
    path: '/$submissionId/edit',
    getParentRoute: () => PrivateRouteInternalTrendingRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/_internal/trending/$submissionId/edit/index.lazy').then(
      (d) => d.Route,
    ),
  );
const PrivateRouteTeamsTeamIdCandidatesCandidateIdIndexRouteRoute =
  PrivateRouteTeamsTeamIdCandidatesCandidateIdIndexRouteRouteImport.update({
    id: '/',
    path: '',
    getParentRoute: () =>
      PrivateRouteTeamsTeamIdCandidatesCandidateIdRouteRoute,
  } as any);
const PrivateRouteTeamsTeamIdCandidatesCandidateIdTabIdRouteRoute =
  PrivateRouteTeamsTeamIdCandidatesCandidateIdTabIdRouteRouteImport.update({
    id: '/$tabId',
    path: '/$tabId',
    getParentRoute: () =>
      PrivateRouteTeamsTeamIdCandidatesCandidateIdRouteRoute,
  } as any);
const PrivateRouteTeamsTeamIdIntroductionsCandidateIdIndexRouteRoute =
  PrivateRouteTeamsTeamIdIntroductionsCandidateIdIndexRouteRouteImport.update({
    id: '/introductions/$candidateId/',
    path: '/introductions/$candidateId',
    getParentRoute: () => PrivateRouteTeamsTeamIdRouteRoute,
  } as any);
const PrivateRouteTeamsTeamIdPipelinesPipelineIdInternalLazyRoute =
  PrivateRouteTeamsTeamIdPipelinesPipelineIdInternalLazyRouteImport.update({
    id: '/_internal',
    getParentRoute: () => PrivateRouteTeamsTeamIdPipelinesPipelineIdLazyRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/teams/$teamId/pipelines/$pipelineId/_internal/lazy').then(
      (d) => d.Route,
    ),
  );
const PrivateRouteTeamsTeamIdPipelinesPipelineIdEditRouteRoute =
  PrivateRouteTeamsTeamIdPipelinesPipelineIdEditRouteRouteImport.update({
    id: '/pipelines_/$pipelineId/edit',
    path: '/pipelines/$pipelineId/edit',
    getParentRoute: () => PrivateRouteTeamsTeamIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/teams/$teamId/pipelines_/$pipelineId/edit.lazy').then(
      (d) => d.Route,
    ),
  );
const PrivateRouteTeamsTeamIdSearchesSearchIdIndexRouteRoute =
  PrivateRouteTeamsTeamIdSearchesSearchIdIndexRouteRouteImport.update({
    id: '/searches/$searchId/',
    path: '/searches/$searchId',
    getParentRoute: () => PrivateRouteTeamsTeamIdRouteRoute,
  } as any);
const PrivateRouteTeamsTeamIdTrendingRecommendationIdIndexRouteRoute =
  PrivateRouteTeamsTeamIdTrendingRecommendationIdIndexRouteRouteImport.update({
    id: '/$recommendationId/',
    path: '/$recommendationId',
    getParentRoute: () => PrivateRouteTeamsTeamIdTrendingLazyRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/teams/$teamId/trending/$recommendationId/index.lazy').then(
      (d) => d.Route,
    ),
  );
const PrivateRouteUsersUserIdEventsEventIdIndexRouteRoute =
  PrivateRouteUsersUserIdEventsEventIdIndexRouteRouteImport.update({
    id: '/events/$eventId/',
    path: '/events/$eventId',
    getParentRoute: () => PrivateRouteUsersUserIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/users/$userId/events/$eventId/index.lazy').then(
      (d) => d.Route,
    ),
  );
const PrivateRouteUsersUserIdPipelinesPipelineIdIndexRouteRoute =
  PrivateRouteUsersUserIdPipelinesPipelineIdIndexRouteRouteImport.update({
    id: '/pipelines/$pipelineId/',
    path: '/pipelines/$pipelineId',
    getParentRoute: () => PrivateRouteUsersUserIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/users/$userId/pipelines/$pipelineId/index.lazy').then(
      (d) => d.Route,
    ),
  );
const PrivateRouteUsersUserIdPipelinesPipelineIdEditRouteRoute =
  PrivateRouteUsersUserIdPipelinesPipelineIdEditRouteRouteImport.update({
    id: '/pipelines/$pipelineId/edit',
    path: '/pipelines/$pipelineId/edit',
    getParentRoute: () => PrivateRouteUsersUserIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/users/$userId/pipelines/$pipelineId/edit.lazy').then(
      (d) => d.Route,
    ),
  );
const PrivateRouteUsersUserIdTrendingRecommendationIdIndexRouteRoute =
  PrivateRouteUsersUserIdTrendingRecommendationIdIndexRouteRouteImport.update({
    id: '/$recommendationId/',
    path: '/$recommendationId',
    getParentRoute: () => PrivateRouteUsersUserIdTrendingRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/users/$userId/trending/$recommendationId/index.lazy').then(
      (d) => d.Route,
    ),
  );
const PrivateRouteInternalAdminUsersUserIdSettingsIndexRouteRoute =
  PrivateRouteInternalAdminUsersUserIdSettingsIndexRouteRouteImport.update({
    id: '/settings/',
    path: '/settings',
    getParentRoute: () => PrivateRouteInternalAdminUsersUserIdRouteRoute,
  } as any);
const PrivateRouteInternalEventsEventIdParticipantsNewIndexRouteRoute =
  PrivateRouteInternalEventsEventIdParticipantsNewIndexRouteRouteImport.update({
    id: '/new/',
    path: '/new',
    getParentRoute: () =>
      PrivateRouteInternalEventsEventIdParticipantsRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/_internal/events/$eventId/participants/new/index.lazy').then(
      (d) => d.Route,
    ),
  );
const PrivateRouteInternalPeopleIdentityIdCandidateAboutIndexRouteRoute =
  PrivateRouteInternalPeopleIdentityIdCandidateAboutIndexRouteRouteImport.update(
    {
      id: '/about/',
      path: '/about',
      getParentRoute: () =>
        PrivateRouteInternalPeopleIdentityIdCandidateRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_private/_route/_internal/people/$identityId/_candidate/about/index.lazy').then(
      (d) => d.Route,
    ),
  );
const PrivateRouteInternalPeopleIdentityIdCandidateCompareIndexRouteRoute =
  PrivateRouteInternalPeopleIdentityIdCandidateCompareIndexRouteRouteImport.update(
    {
      id: '/compare/',
      path: '/compare',
      getParentRoute: () =>
        PrivateRouteInternalPeopleIdentityIdCandidateRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_private/_route/_internal/people/$identityId/_candidate/compare/index.lazy').then(
      (d) => d.Route,
    ),
  );
const PrivateRouteInternalPeopleIdentityIdCandidateFeedbackIndexRouteRoute =
  PrivateRouteInternalPeopleIdentityIdCandidateFeedbackIndexRouteRouteImport.update(
    {
      id: '/feedback/',
      path: '/feedback',
      getParentRoute: () =>
        PrivateRouteInternalPeopleIdentityIdCandidateRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_private/_route/_internal/people/$identityId/_candidate/feedback/index.lazy').then(
      (d) => d.Route,
    ),
  );
const PrivateRouteInternalPeopleIdentityIdCandidatePerformanceIndexRouteRoute =
  PrivateRouteInternalPeopleIdentityIdCandidatePerformanceIndexRouteRouteImport.update(
    {
      id: '/performance/',
      path: '/performance',
      getParentRoute: () =>
        PrivateRouteInternalPeopleIdentityIdCandidateRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_private/_route/_internal/people/$identityId/_candidate/performance/index.lazy').then(
      (d) => d.Route,
    ),
  );
const PrivateRouteInternalPeopleIdentityIdCandidateProfileIndexRouteRoute =
  PrivateRouteInternalPeopleIdentityIdCandidateProfileIndexRouteRouteImport.update(
    {
      id: '/profile/',
      path: '/profile',
      getParentRoute: () =>
        PrivateRouteInternalPeopleIdentityIdCandidateRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_private/_route/_internal/people/$identityId/_candidate/profile/index.lazy').then(
      (d) => d.Route,
    ),
  );
const PrivateRouteInternalPeopleIdentityIdCandidateRecommendationsIndexRouteRoute =
  PrivateRouteInternalPeopleIdentityIdCandidateRecommendationsIndexRouteRouteImport.update(
    {
      id: '/recommendations/',
      path: '/recommendations',
      getParentRoute: () =>
        PrivateRouteInternalPeopleIdentityIdCandidateRouteRoute,
    } as any,
  );
const PrivateRouteInternalPeopleIdentityIdCandidateSuggestedPipelinesIndexRouteRoute =
  PrivateRouteInternalPeopleIdentityIdCandidateSuggestedPipelinesIndexRouteRouteImport.update(
    {
      id: '/suggested-pipelines/',
      path: '/suggested-pipelines',
      getParentRoute: () =>
        PrivateRouteInternalPeopleIdentityIdCandidateRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_private/_route/_internal/people/$identityId/_candidate/suggested-pipelines/index.lazy').then(
      (d) => d.Route,
    ),
  );
const PrivateRouteInternalPeopleIdentityIdCandidateTasksIndexLazyRoute =
  PrivateRouteInternalPeopleIdentityIdCandidateTasksIndexLazyRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        PrivateRouteInternalPeopleIdentityIdCandidateTasksRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_private/_route/_internal/people/$identityId/_candidate/tasks/index.lazy').then(
      (d) => d.Route,
    ),
  );
const PrivateRouteTeamsTeamIdCandidatesCandidateIdActivityIndexRouteRoute =
  PrivateRouteTeamsTeamIdCandidatesCandidateIdActivityIndexRouteRouteImport.update(
    {
      id: '/activity/',
      path: '/activity',
      getParentRoute: () =>
        PrivateRouteTeamsTeamIdCandidatesCandidateIdRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_private/_route/teams/$teamId/candidates/$candidateId/activity/index.lazy').then(
      (d) => d.Route,
    ),
  );
const PrivateRouteTeamsTeamIdCandidatesCandidateIdPipelinesIndexRouteRoute =
  PrivateRouteTeamsTeamIdCandidatesCandidateIdPipelinesIndexRouteRouteImport.update(
    {
      id: '/pipelines/',
      path: '/pipelines',
      getParentRoute: () =>
        PrivateRouteTeamsTeamIdCandidatesCandidateIdRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_private/_route/teams/$teamId/candidates/$candidateId/pipelines/index.lazy').then(
      (d) => d.Route,
    ),
  );
const PrivateRouteTeamsTeamIdPipelinesPipelineIdInternalIndexRouteRoute =
  PrivateRouteTeamsTeamIdPipelinesPipelineIdInternalIndexRouteRouteImport.update(
    {
      id: '/',
      path: '',
      getParentRoute: () =>
        PrivateRouteTeamsTeamIdPipelinesPipelineIdInternalLazyRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_private/_route/teams/$teamId/pipelines/$pipelineId/_internal/index/lazy').then(
      (d) => d.Route,
    ),
  );
const PrivateRouteTeamsTeamIdPipelinesPipelineIdInternalRecommendationsRouteRoute =
  PrivateRouteTeamsTeamIdPipelinesPipelineIdInternalRecommendationsRouteRouteImport.update(
    {
      id: '/recommendations',
      path: '/recommendations',
      getParentRoute: () =>
        PrivateRouteTeamsTeamIdPipelinesPipelineIdInternalLazyRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_private/_route/teams/$teamId/pipelines/$pipelineId/_internal/recommendations/lazy').then(
      (d) => d.Route,
    ),
  );
const PrivateRouteTeamsTeamIdPipelinesPipelineIdRecommendationsNewRouteRoute =
  PrivateRouteTeamsTeamIdPipelinesPipelineIdRecommendationsNewRouteRouteImport.update(
    {
      id: '/pipelines/$pipelineId_/recommendations/new',
      path: '/pipelines/$pipelineId/recommendations/new',
      getParentRoute: () => PrivateRouteTeamsTeamIdRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_private/_route/teams/$teamId/pipelines/$pipelineId_/recommendations/new/lazy').then(
      (d) => d.Route,
    ),
  );
const PrivateRouteUsersUserIdPipelinesPipelineIdRecommendationsNewRouteRoute =
  PrivateRouteUsersUserIdPipelinesPipelineIdRecommendationsNewRouteRouteImport.update(
    {
      id: '/pipelines/$pipelineId_/recommendations/new',
      path: '/pipelines/$pipelineId/recommendations/new',
      getParentRoute: () => PrivateRouteUsersUserIdRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_private/_route/users/$userId/pipelines/$pipelineId_/recommendations/new/lazy').then(
      (d) => d.Route,
    ),
  );
const PrivateRouteInternalCandidatesCandidateIdTasksGoalsGoalIdIndexRouteRoute =
  PrivateRouteInternalCandidatesCandidateIdTasksGoalsGoalIdIndexRouteRouteImport.update(
    {
      id: '/goals/$goalId/',
      path: '/goals/$goalId',
      getParentRoute: () =>
        PrivateRouteInternalCandidatesCandidateIdTasksRouteRoute,
    } as any,
  );
const PrivateRouteTeamsTeamIdPipelinesPipelineIdInternalRecommendationsIndexRouteRoute =
  PrivateRouteTeamsTeamIdPipelinesPipelineIdInternalRecommendationsIndexRouteRouteImport.update(
    {
      id: '/',
      path: '',
      getParentRoute: () =>
        PrivateRouteTeamsTeamIdPipelinesPipelineIdInternalRecommendationsRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_private/_route/teams/$teamId/pipelines/$pipelineId/_internal/recommendations/index.lazy').then(
      (d) => d.Route,
    ),
  );
const PrivateRouteTeamsTeamIdPipelinesPipelineIdIntroductionsCandidateIdIndexRouteRoute =
  PrivateRouteTeamsTeamIdPipelinesPipelineIdIntroductionsCandidateIdIndexRouteRouteImport.update(
    {
      id: '/introductions/$candidateId/',
      path: '/introductions/$candidateId',
      getParentRoute: () => PrivateRouteTeamsTeamIdPipelinesPipelineIdLazyRoute,
    } as any,
  );
const PrivateRouteTeamsTeamIdPipelinesPipelineIdSubmissionsSubmissionIdIndexRouteRoute =
  PrivateRouteTeamsTeamIdPipelinesPipelineIdSubmissionsSubmissionIdIndexRouteRouteImport.update(
    {
      id: '/pipelines/$pipelineId_/submissions/$submissionId/',
      path: '/pipelines/$pipelineId/submissions/$submissionId',
      getParentRoute: () => PrivateRouteTeamsTeamIdRouteRoute,
    } as any,
  );
const PrivateRouteTeamsTeamIdSearchesSearchIdCandidatesCandidateIdIndexRouteRoute =
  PrivateRouteTeamsTeamIdSearchesSearchIdCandidatesCandidateIdIndexRouteRouteImport.update(
    {
      id: '/searches/$searchId/candidates/$candidateId/',
      path: '/searches/$searchId/candidates/$candidateId',
      getParentRoute: () => PrivateRouteTeamsTeamIdRouteRoute,
    } as any,
  );
const PrivateRouteUsersUserIdPipelinesPipelineIdRecommendationsRecommendationIdIndexRouteRoute =
  PrivateRouteUsersUserIdPipelinesPipelineIdRecommendationsRecommendationIdIndexRouteRouteImport.update(
    {
      id: '/pipelines/$pipelineId/recommendations/$recommendationId/',
      path: '/pipelines/$pipelineId/recommendations/$recommendationId',
      getParentRoute: () => PrivateRouteUsersUserIdRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_private/_route/users/$userId/pipelines/$pipelineId/recommendations.$recommendationId.index.lazy').then(
      (d) => d.Route,
    ),
  );
const PrivateRouteInternalPeopleIdentityIdCandidateTasksGoalsGoalIdIndexRouteRoute =
  PrivateRouteInternalPeopleIdentityIdCandidateTasksGoalsGoalIdIndexRouteRouteImport.update(
    {
      id: '/goals/$goalId/',
      path: '/goals/$goalId',
      getParentRoute: () =>
        PrivateRouteInternalPeopleIdentityIdCandidateTasksRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_private/_route/_internal/people/$identityId/_candidate/tasks/goals/$goalId/index.lazy').then(
      (d) => d.Route,
    ),
  );
const PrivateRouteInternalTeamsTeamIdSearchesSearchIdSubmissionsSubmissionIdIndexRouteRoute =
  PrivateRouteInternalTeamsTeamIdSearchesSearchIdSubmissionsSubmissionIdIndexRouteRouteImport.update(
    {
      id: '/teams/$teamId/searches/$searchId/submissions/$submissionId/',
      path: '/teams/$teamId/searches/$searchId/submissions/$submissionId',
      getParentRoute: () => PrivateRouteInternalRouteRoute,
    } as any,
  );
const PrivateRouteTeamsTeamIdPipelinesPipelineIdInternalRecommendationsRecommendationIdIndexRouteRoute =
  PrivateRouteTeamsTeamIdPipelinesPipelineIdInternalRecommendationsRecommendationIdIndexRouteRouteImport.update(
    {
      id: '/$recommendationId/',
      path: '/$recommendationId',
      getParentRoute: () =>
        PrivateRouteTeamsTeamIdPipelinesPipelineIdInternalRecommendationsRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_private/_route/teams/$teamId/pipelines/$pipelineId/_internal/recommendations/$recommendationId/index.lazy').then(
      (d) => d.Route,
    ),
  );

export interface FileRoutesByFullPath {
  '/': typeof PrivateIndexRouteRoute;
  '/events': typeof PrivateRouteInternalEventsRouteRouteWithChildren;
  '/registration': typeof RegistrationRouteRoute;
  '/events/rsvp': typeof EventsRsvpRouteRoute;
  '/set-password': typeof PrivateAuthSetPasswordRouteRoute;
  '/$': typeof PrivateRouteSplatRouteRoute;
  '/profile': typeof PrivateRouteProfileRouteRouteWithChildren;
  '/logout/': typeof LayoutAuthLogoutIndexRouteRoute;
  '/maintenance/': typeof LayoutAuthMaintenanceIndexRouteRoute;
  '/teams/': typeof PrivateTeamsIndexRouteRoute;
  '/admin': typeof PrivateRouteInternalAdminRouteRouteWithChildren;
  '/pipelines': typeof PrivateRouteInternalPipelinesRouteRouteWithChildren;
  '/tasks': typeof PrivateRouteInternalTasksRouteRouteWithChildren;
  '/trending': typeof PrivateRouteInternalTrendingRouteRouteWithChildren;
  '/teams/$teamId': typeof PrivateRouteTeamsTeamIdRouteRouteWithChildren;
  '/users/$userId': typeof PrivateRouteUsersUserIdRouteRouteWithChildren;
  '/email-response/': typeof LayoutAuthGuestEmailResponseIndexRouteRoute;
  '/join/': typeof LayoutAuthGuestJoinIndexRouteRoute;
  '/login/': typeof LayoutAuthGuestLoginIndexRouteRoute;
  '/signup/': typeof PrivateAuthSignupIndexRouteRoute;
  '/profile/': typeof PrivateRouteProfileIndexRouteRoute;
  '/users/': typeof PrivateRouteUsersIndexRouteRoute;
  '/teams/$teamId/': typeof PrivateTeamsTeamIdIndexRouteRoute;
  '/pipelines/': typeof PrivateRouteInternalPipelinesIndexRouteRoute;
  '/candidates/$candidateId': typeof PrivateRouteInternalCandidatesCandidateIdRouteRouteWithChildren;
  '/events/$eventId': typeof PrivateRouteInternalEventsEventIdRouteRouteWithChildren;
  '/people/$identityId': typeof PrivateRouteInternalPeopleIdentityIdRouteRouteWithChildren;
  '/pipelines/new': typeof PrivateRouteInternalPipelinesNewRouteRoute;
  '/teams/$teamId/candidates': typeof PrivateRouteTeamsTeamIdCandidatesRouteRouteWithChildren;
  '/teams/$teamId/network': typeof PrivateRouteTeamsTeamIdNetworkRouteRoute;
  '/users/$userId/people': typeof PrivateRouteUsersUserIdPeopleRouteRouteWithChildren;
  '/users/$userId/trending': typeof PrivateRouteUsersUserIdTrendingRouteRouteWithChildren;
  '/teams/$teamId/trending': typeof PrivateRouteTeamsTeamIdTrendingLazyRouteWithChildren;
  '/companies/': typeof PrivateRouteInternalCompaniesIndexRouteRoute;
  '/events/': typeof PrivateRouteInternalEventsIndexRouteRoute;
  '/experiments/': typeof PrivateRouteInternalExperimentsIndexRouteRoute;
  '/home/': typeof PrivateRouteInternalHomeIndexRouteRoute;
  '/introductions/': typeof PrivateRouteInternalIntroductionsIndexRouteRoute;
  '/peers/': typeof PrivateRouteInternalPeersIndexRouteRoute;
  '/people/': typeof PrivateRouteInternalPeopleIndexRouteRoute;
  '/performance/': typeof PrivateRouteInternalPerformanceIndexRouteRoute;
  '/pipeline-submissions/': typeof PrivateRouteInternalPipelineSubmissionsIndexRouteRoute;
  '/search-submissions/': typeof PrivateRouteInternalSearchSubmissionsIndexRouteRoute;
  '/searches/': typeof PrivateRouteInternalSearchesIndexRouteRoute;
  '/tasks/': typeof PrivateRouteInternalTasksIndexRouteRoute;
  '/tools/': typeof PrivateRouteInternalToolsIndexRouteRoute;
  '/trending/': typeof PrivateRouteInternalTrendingIndexRouteRoute;
  '/profile/teams/': typeof PrivateRouteProfileTeamsIndexRouteRoute;
  '/users/$userId/': typeof PrivateRouteUsersUserIdIndexRouteRoute;
  '/users/new/': typeof PrivateRouteUsersNewIndexRouteRoute;
  '/admin/users/$userId': typeof PrivateRouteInternalAdminUsersUserIdRouteRouteWithChildren;
  '/candidates/$candidateId/tasks': typeof PrivateRouteInternalCandidatesCandidateIdTasksRouteRouteWithChildren;
  '/events/$eventId/participants': typeof PrivateRouteInternalEventsEventIdParticipantsRouteRouteWithChildren;
  '/events/participants/$participantId': typeof PrivateRouteInternalEventsParticipantsParticipantIdRouteRouteWithChildren;
  '/teams/$teamId/candidates/$candidateId': typeof PrivateRouteTeamsTeamIdCandidatesCandidateIdRouteRouteWithChildren;
  '/teams/$teamId/pipelines/new': typeof PrivateRouteTeamsTeamIdPipelinesNewRouteRoute;
  '/users/$userId/people/$candidateId': typeof PrivateRouteUsersUserIdPeopleCandidateIdRouteRoute;
  '/users/$userId/pipelines/new': typeof PrivateRouteUsersUserIdPipelinesNewRouteRoute;
  '/teams/$teamId/pipelines/$pipelineId': typeof PrivateRouteTeamsTeamIdPipelinesPipelineIdInternalLazyRouteWithChildren;
  '/admin/users/': typeof PrivateRouteInternalAdminUsersIndexRouteRoute;
  '/candidates/$candidateId/': typeof PrivateRouteInternalCandidatesCandidateIdIndexRouteRoute;
  '/candidates/new/': typeof PrivateRouteInternalCandidatesNewIndexRouteRoute;
  '/events/$eventId/': typeof PrivateRouteInternalEventsEventIdIndexRouteRoute;
  '/events/events/': typeof PrivateRouteInternalEventsEventsIndexRouteRoute;
  '/events/new/': typeof PrivateRouteInternalEventsNewIndexRouteRoute;
  '/events/participants/': typeof PrivateRouteInternalEventsParticipantsIndexRouteRoute;
  '/events/settings/': typeof PrivateRouteInternalEventsSettingsIndexRouteRoute;
  '/introduction-submissions/$submissionId/': typeof PrivateRouteInternalIntroductionSubmissionsSubmissionIdIndexRouteRoute;
  '/peers/new/': typeof PrivateRouteInternalPeersNewIndexRouteRoute;
  '/people/$identityId/': typeof PrivateRouteInternalPeopleIdentityIdIndexRouteRoute;
  '/pipeline-submissions/$submissionId/': typeof PrivateRouteInternalPipelineSubmissionsSubmissionIdIndexRouteRoute;
  '/tasks/executive-services/': typeof PrivateRouteInternalTasksExecutiveServicesIndexRouteRoute;
  '/tasks/me/': typeof PrivateRouteInternalTasksMeIndexRouteRoute;
  '/tools/ai-candidate-discovery/': typeof PrivateRouteInternalToolsAiCandidateDiscoveryIndexRouteRoute;
  '/tools/email-templates/': typeof PrivateRouteInternalToolsEmailTemplatesIndexRouteRoute;
  '/tools/market-searches/': typeof PrivateRouteInternalToolsMarketSearchesIndexRouteRoute;
  '/tools/merge-people/': typeof PrivateRouteInternalToolsMergePeopleIndexRouteRoute;
  '/tools/move-team/': typeof PrivateRouteInternalToolsMoveTeamIndexRouteRoute;
  '/tools/pathway-activity-defaults/': typeof PrivateRouteInternalToolsPathwayActivityDefaultsIndexRouteRoute;
  '/trending/$submissionId/': typeof PrivateRouteInternalTrendingSubmissionIdIndexRouteRoute;
  '/trending/campaigns/': typeof PrivateRouteInternalTrendingCampaignsIndexRouteRoute;
  '/trending/new/': typeof PrivateRouteInternalTrendingNewIndexRouteRoute;
  '/trending/people/': typeof PrivateRouteInternalTrendingPeopleIndexRouteRoute;
  '/teams/$teamId/home/': typeof PrivateRouteTeamsTeamIdHomeIndexRouteRoute;
  '/teams/$teamId/introductions/': typeof PrivateRouteTeamsTeamIdIntroductionsIndexRouteRoute;
  '/teams/$teamId/pipelines/': typeof PrivateRouteTeamsTeamIdPipelinesIndexRouteRoute;
  '/teams/$teamId/searches/': typeof PrivateRouteTeamsTeamIdSearchesIndexRouteRoute;
  '/teams/$teamId/settings/': typeof PrivateRouteTeamsTeamIdSettingsIndexRouteRoute;
  '/users/$userId/events/': typeof PrivateRouteUsersUserIdEventsIndexRouteRoute;
  '/users/$userId/pipelines/': typeof PrivateRouteUsersUserIdPipelinesIndexRouteRoute;
  '/users/$userId/settings/': typeof PrivateRouteUsersUserIdSettingsIndexRouteRoute;
  '/teams/$teamId/trending/': typeof PrivateRouteTeamsTeamIdTrendingIndexRoute;
  '/users/$userId/trending/': typeof PrivateRouteUsersUserIdTrendingIndexRoute;
  '/people/$identityId/tasks': typeof PrivateRouteInternalPeopleIdentityIdCandidateTasksRouteRouteWithChildren;
  '/teams/$teamId/candidates/$candidateId/$tabId': typeof PrivateRouteTeamsTeamIdCandidatesCandidateIdTabIdRouteRoute;
  '/teams/$teamId/pipelines/$pipelineId/edit': typeof PrivateRouteTeamsTeamIdPipelinesPipelineIdEditRouteRoute;
  '/users/$userId/pipelines/$pipelineId/edit': typeof PrivateRouteUsersUserIdPipelinesPipelineIdEditRouteRoute;
  '/admin/users/new/': typeof PrivateRouteInternalAdminUsersNewIndexRouteRoute;
  '/candidates/$candidateId/about/': typeof PrivateRouteInternalCandidatesCandidateIdAboutIndexRouteRoute;
  '/candidates/$candidateId/accounts/': typeof PrivateRouteInternalCandidatesCandidateIdAccountsIndexRouteRoute;
  '/candidates/$candidateId/compare/': typeof PrivateRouteInternalCandidatesCandidateIdCompareIndexRouteRoute;
  '/candidates/$candidateId/feedback/': typeof PrivateRouteInternalCandidatesCandidateIdFeedbackIndexRouteRoute;
  '/candidates/$candidateId/performance/': typeof PrivateRouteInternalCandidatesCandidateIdPerformanceIndexRouteRoute;
  '/candidates/$candidateId/profile/': typeof PrivateRouteInternalCandidatesCandidateIdProfileIndexRouteRoute;
  '/candidates/$candidateId/recommendations/': typeof PrivateRouteInternalCandidatesCandidateIdRecommendationsIndexRouteRoute;
  '/candidates/$candidateId/suggested-pipelines/': typeof PrivateRouteInternalCandidatesCandidateIdSuggestedPipelinesIndexRouteRoute;
  '/companies/$companyId/people/': typeof PrivateRouteInternalCompaniesCompanyIdPeopleIndexRouteRoute;
  '/companies/$companyId/settings/': typeof PrivateRouteInternalCompaniesCompanyIdSettingsIndexRouteRoute;
  '/events/$eventId/details/': typeof PrivateRouteInternalEventsEventIdDetailsIndexRouteRoute;
  '/events/$eventId/email-settings/': typeof PrivateRouteInternalEventsEventIdEmailSettingsIndexRouteRoute;
  '/events/$eventId/emails/': typeof PrivateRouteInternalEventsEventIdEmailsIndexRouteRoute;
  '/events/participants/$participantId/': typeof PrivateRouteInternalEventsParticipantsParticipantIdIndexRouteRoute;
  '/people/$identityId/accounts/': typeof PrivateRouteInternalPeopleIdentityIdAccountsIndexRouteRoute;
  '/people/$identityId/emails/': typeof PrivateRouteInternalPeopleIdentityIdEmailsIndexRouteRoute;
  '/trending/$submissionId/edit/': typeof PrivateRouteInternalTrendingSubmissionIdEditIndexRouteRoute;
  '/teams/$teamId/candidates/$candidateId/': typeof PrivateRouteTeamsTeamIdCandidatesCandidateIdIndexRouteRoute;
  '/teams/$teamId/introductions/$candidateId/': typeof PrivateRouteTeamsTeamIdIntroductionsCandidateIdIndexRouteRoute;
  '/teams/$teamId/searches/$searchId/': typeof PrivateRouteTeamsTeamIdSearchesSearchIdIndexRouteRoute;
  '/teams/$teamId/trending/$recommendationId/': typeof PrivateRouteTeamsTeamIdTrendingRecommendationIdIndexRouteRoute;
  '/users/$userId/events/$eventId/': typeof PrivateRouteUsersUserIdEventsEventIdIndexRouteRoute;
  '/users/$userId/pipelines/$pipelineId/': typeof PrivateRouteUsersUserIdPipelinesPipelineIdIndexRouteRoute;
  '/users/$userId/trending/$recommendationId/': typeof PrivateRouteUsersUserIdTrendingRecommendationIdIndexRouteRoute;
  '/teams/$teamId/pipelines/$pipelineId/': typeof PrivateRouteTeamsTeamIdPipelinesPipelineIdInternalIndexRouteRoute;
  '/teams/$teamId/pipelines/$pipelineId/recommendations': typeof PrivateRouteTeamsTeamIdPipelinesPipelineIdInternalRecommendationsRouteRouteWithChildren;
  '/teams/$teamId/pipelines/$pipelineId/recommendations/new': typeof PrivateRouteTeamsTeamIdPipelinesPipelineIdRecommendationsNewRouteRoute;
  '/users/$userId/pipelines/$pipelineId/recommendations/new': typeof PrivateRouteUsersUserIdPipelinesPipelineIdRecommendationsNewRouteRoute;
  '/admin/users/$userId/settings/': typeof PrivateRouteInternalAdminUsersUserIdSettingsIndexRouteRoute;
  '/events/$eventId/participants/new/': typeof PrivateRouteInternalEventsEventIdParticipantsNewIndexRouteRoute;
  '/people/$identityId/about/': typeof PrivateRouteInternalPeopleIdentityIdCandidateAboutIndexRouteRoute;
  '/people/$identityId/compare/': typeof PrivateRouteInternalPeopleIdentityIdCandidateCompareIndexRouteRoute;
  '/people/$identityId/feedback/': typeof PrivateRouteInternalPeopleIdentityIdCandidateFeedbackIndexRouteRoute;
  '/people/$identityId/performance/': typeof PrivateRouteInternalPeopleIdentityIdCandidatePerformanceIndexRouteRoute;
  '/people/$identityId/profile/': typeof PrivateRouteInternalPeopleIdentityIdCandidateProfileIndexRouteRoute;
  '/people/$identityId/recommendations/': typeof PrivateRouteInternalPeopleIdentityIdCandidateRecommendationsIndexRouteRoute;
  '/people/$identityId/suggested-pipelines/': typeof PrivateRouteInternalPeopleIdentityIdCandidateSuggestedPipelinesIndexRouteRoute;
  '/teams/$teamId/candidates/$candidateId/activity/': typeof PrivateRouteTeamsTeamIdCandidatesCandidateIdActivityIndexRouteRoute;
  '/teams/$teamId/candidates/$candidateId/pipelines/': typeof PrivateRouteTeamsTeamIdCandidatesCandidateIdPipelinesIndexRouteRoute;
  '/people/$identityId/tasks/': typeof PrivateRouteInternalPeopleIdentityIdCandidateTasksIndexLazyRoute;
  '/candidates/$candidateId/tasks/goals/$goalId/': typeof PrivateRouteInternalCandidatesCandidateIdTasksGoalsGoalIdIndexRouteRoute;
  '/teams/$teamId/pipelines/$pipelineId/recommendations/': typeof PrivateRouteTeamsTeamIdPipelinesPipelineIdInternalRecommendationsIndexRouteRoute;
  '/teams/$teamId/pipelines/$pipelineId/introductions/$candidateId/': typeof PrivateRouteTeamsTeamIdPipelinesPipelineIdIntroductionsCandidateIdIndexRouteRoute;
  '/teams/$teamId/pipelines/$pipelineId/submissions/$submissionId/': typeof PrivateRouteTeamsTeamIdPipelinesPipelineIdSubmissionsSubmissionIdIndexRouteRoute;
  '/teams/$teamId/searches/$searchId/candidates/$candidateId/': typeof PrivateRouteTeamsTeamIdSearchesSearchIdCandidatesCandidateIdIndexRouteRoute;
  '/users/$userId/pipelines/$pipelineId/recommendations/$recommendationId/': typeof PrivateRouteUsersUserIdPipelinesPipelineIdRecommendationsRecommendationIdIndexRouteRoute;
  '/people/$identityId/tasks/goals/$goalId/': typeof PrivateRouteInternalPeopleIdentityIdCandidateTasksGoalsGoalIdIndexRouteRoute;
  '/teams/$teamId/searches/$searchId/submissions/$submissionId/': typeof PrivateRouteInternalTeamsTeamIdSearchesSearchIdSubmissionsSubmissionIdIndexRouteRoute;
  '/teams/$teamId/pipelines/$pipelineId/recommendations/$recommendationId/': typeof PrivateRouteTeamsTeamIdPipelinesPipelineIdInternalRecommendationsRecommendationIdIndexRouteRoute;
}
export interface FileRoutesByTo {
  '/': typeof PrivateIndexRouteRoute;
  '/events': typeof PrivateRouteInternalEventsIndexRouteRoute;
  '/registration': typeof RegistrationRouteRoute;
  '/events/rsvp': typeof EventsRsvpRouteRoute;
  '/set-password': typeof PrivateAuthSetPasswordRouteRoute;
  '/$': typeof PrivateRouteSplatRouteRoute;
  '/profile': typeof PrivateRouteProfileIndexRouteRoute;
  '/logout': typeof LayoutAuthLogoutIndexRouteRoute;
  '/maintenance': typeof LayoutAuthMaintenanceIndexRouteRoute;
  '/teams': typeof PrivateTeamsIndexRouteRoute;
  '/admin': typeof PrivateRouteInternalAdminRouteRouteWithChildren;
  '/pipelines': typeof PrivateRouteInternalPipelinesIndexRouteRoute;
  '/tasks': typeof PrivateRouteInternalTasksIndexRouteRoute;
  '/trending': typeof PrivateRouteInternalTrendingIndexRouteRoute;
  '/teams/$teamId': typeof PrivateTeamsTeamIdIndexRouteRoute;
  '/users/$userId': typeof PrivateRouteUsersUserIdIndexRouteRoute;
  '/email-response': typeof LayoutAuthGuestEmailResponseIndexRouteRoute;
  '/join': typeof LayoutAuthGuestJoinIndexRouteRoute;
  '/login': typeof LayoutAuthGuestLoginIndexRouteRoute;
  '/signup': typeof PrivateAuthSignupIndexRouteRoute;
  '/users': typeof PrivateRouteUsersIndexRouteRoute;
  '/candidates/$candidateId': typeof PrivateRouteInternalCandidatesCandidateIdIndexRouteRoute;
  '/events/$eventId': typeof PrivateRouteInternalEventsEventIdIndexRouteRoute;
  '/people/$identityId': typeof PrivateRouteInternalPeopleIdentityIdIndexRouteRoute;
  '/pipelines/new': typeof PrivateRouteInternalPipelinesNewRouteRoute;
  '/teams/$teamId/candidates': typeof PrivateRouteTeamsTeamIdCandidatesRouteRouteWithChildren;
  '/teams/$teamId/network': typeof PrivateRouteTeamsTeamIdNetworkRouteRoute;
  '/users/$userId/people': typeof PrivateRouteUsersUserIdPeopleRouteRouteWithChildren;
  '/companies': typeof PrivateRouteInternalCompaniesIndexRouteRoute;
  '/experiments': typeof PrivateRouteInternalExperimentsIndexRouteRoute;
  '/home': typeof PrivateRouteInternalHomeIndexRouteRoute;
  '/introductions': typeof PrivateRouteInternalIntroductionsIndexRouteRoute;
  '/peers': typeof PrivateRouteInternalPeersIndexRouteRoute;
  '/people': typeof PrivateRouteInternalPeopleIndexRouteRoute;
  '/performance': typeof PrivateRouteInternalPerformanceIndexRouteRoute;
  '/pipeline-submissions': typeof PrivateRouteInternalPipelineSubmissionsIndexRouteRoute;
  '/search-submissions': typeof PrivateRouteInternalSearchSubmissionsIndexRouteRoute;
  '/searches': typeof PrivateRouteInternalSearchesIndexRouteRoute;
  '/tools': typeof PrivateRouteInternalToolsIndexRouteRoute;
  '/profile/teams': typeof PrivateRouteProfileTeamsIndexRouteRoute;
  '/users/new': typeof PrivateRouteUsersNewIndexRouteRoute;
  '/admin/users/$userId': typeof PrivateRouteInternalAdminUsersUserIdRouteRouteWithChildren;
  '/candidates/$candidateId/tasks': typeof PrivateRouteInternalCandidatesCandidateIdTasksRouteRouteWithChildren;
  '/events/$eventId/participants': typeof PrivateRouteInternalEventsEventIdParticipantsRouteRouteWithChildren;
  '/events/participants/$participantId': typeof PrivateRouteInternalEventsParticipantsParticipantIdIndexRouteRoute;
  '/teams/$teamId/candidates/$candidateId': typeof PrivateRouteTeamsTeamIdCandidatesCandidateIdIndexRouteRoute;
  '/teams/$teamId/pipelines/new': typeof PrivateRouteTeamsTeamIdPipelinesNewRouteRoute;
  '/users/$userId/people/$candidateId': typeof PrivateRouteUsersUserIdPeopleCandidateIdRouteRoute;
  '/users/$userId/pipelines/new': typeof PrivateRouteUsersUserIdPipelinesNewRouteRoute;
  '/teams/$teamId/pipelines/$pipelineId': typeof PrivateRouteTeamsTeamIdPipelinesPipelineIdInternalIndexRouteRoute;
  '/admin/users': typeof PrivateRouteInternalAdminUsersIndexRouteRoute;
  '/candidates/new': typeof PrivateRouteInternalCandidatesNewIndexRouteRoute;
  '/events/events': typeof PrivateRouteInternalEventsEventsIndexRouteRoute;
  '/events/new': typeof PrivateRouteInternalEventsNewIndexRouteRoute;
  '/events/participants': typeof PrivateRouteInternalEventsParticipantsIndexRouteRoute;
  '/events/settings': typeof PrivateRouteInternalEventsSettingsIndexRouteRoute;
  '/introduction-submissions/$submissionId': typeof PrivateRouteInternalIntroductionSubmissionsSubmissionIdIndexRouteRoute;
  '/peers/new': typeof PrivateRouteInternalPeersNewIndexRouteRoute;
  '/pipeline-submissions/$submissionId': typeof PrivateRouteInternalPipelineSubmissionsSubmissionIdIndexRouteRoute;
  '/tasks/executive-services': typeof PrivateRouteInternalTasksExecutiveServicesIndexRouteRoute;
  '/tasks/me': typeof PrivateRouteInternalTasksMeIndexRouteRoute;
  '/tools/ai-candidate-discovery': typeof PrivateRouteInternalToolsAiCandidateDiscoveryIndexRouteRoute;
  '/tools/email-templates': typeof PrivateRouteInternalToolsEmailTemplatesIndexRouteRoute;
  '/tools/market-searches': typeof PrivateRouteInternalToolsMarketSearchesIndexRouteRoute;
  '/tools/merge-people': typeof PrivateRouteInternalToolsMergePeopleIndexRouteRoute;
  '/tools/move-team': typeof PrivateRouteInternalToolsMoveTeamIndexRouteRoute;
  '/tools/pathway-activity-defaults': typeof PrivateRouteInternalToolsPathwayActivityDefaultsIndexRouteRoute;
  '/trending/$submissionId': typeof PrivateRouteInternalTrendingSubmissionIdIndexRouteRoute;
  '/trending/campaigns': typeof PrivateRouteInternalTrendingCampaignsIndexRouteRoute;
  '/trending/new': typeof PrivateRouteInternalTrendingNewIndexRouteRoute;
  '/trending/people': typeof PrivateRouteInternalTrendingPeopleIndexRouteRoute;
  '/teams/$teamId/home': typeof PrivateRouteTeamsTeamIdHomeIndexRouteRoute;
  '/teams/$teamId/introductions': typeof PrivateRouteTeamsTeamIdIntroductionsIndexRouteRoute;
  '/teams/$teamId/pipelines': typeof PrivateRouteTeamsTeamIdPipelinesIndexRouteRoute;
  '/teams/$teamId/searches': typeof PrivateRouteTeamsTeamIdSearchesIndexRouteRoute;
  '/teams/$teamId/settings': typeof PrivateRouteTeamsTeamIdSettingsIndexRouteRoute;
  '/users/$userId/events': typeof PrivateRouteUsersUserIdEventsIndexRouteRoute;
  '/users/$userId/pipelines': typeof PrivateRouteUsersUserIdPipelinesIndexRouteRoute;
  '/users/$userId/settings': typeof PrivateRouteUsersUserIdSettingsIndexRouteRoute;
  '/teams/$teamId/trending': typeof PrivateRouteTeamsTeamIdTrendingIndexRoute;
  '/users/$userId/trending': typeof PrivateRouteUsersUserIdTrendingIndexRoute;
  '/teams/$teamId/candidates/$candidateId/$tabId': typeof PrivateRouteTeamsTeamIdCandidatesCandidateIdTabIdRouteRoute;
  '/teams/$teamId/pipelines/$pipelineId/edit': typeof PrivateRouteTeamsTeamIdPipelinesPipelineIdEditRouteRoute;
  '/users/$userId/pipelines/$pipelineId/edit': typeof PrivateRouteUsersUserIdPipelinesPipelineIdEditRouteRoute;
  '/admin/users/new': typeof PrivateRouteInternalAdminUsersNewIndexRouteRoute;
  '/candidates/$candidateId/about': typeof PrivateRouteInternalCandidatesCandidateIdAboutIndexRouteRoute;
  '/candidates/$candidateId/accounts': typeof PrivateRouteInternalCandidatesCandidateIdAccountsIndexRouteRoute;
  '/candidates/$candidateId/compare': typeof PrivateRouteInternalCandidatesCandidateIdCompareIndexRouteRoute;
  '/candidates/$candidateId/feedback': typeof PrivateRouteInternalCandidatesCandidateIdFeedbackIndexRouteRoute;
  '/candidates/$candidateId/performance': typeof PrivateRouteInternalCandidatesCandidateIdPerformanceIndexRouteRoute;
  '/candidates/$candidateId/profile': typeof PrivateRouteInternalCandidatesCandidateIdProfileIndexRouteRoute;
  '/candidates/$candidateId/recommendations': typeof PrivateRouteInternalCandidatesCandidateIdRecommendationsIndexRouteRoute;
  '/candidates/$candidateId/suggested-pipelines': typeof PrivateRouteInternalCandidatesCandidateIdSuggestedPipelinesIndexRouteRoute;
  '/companies/$companyId/people': typeof PrivateRouteInternalCompaniesCompanyIdPeopleIndexRouteRoute;
  '/companies/$companyId/settings': typeof PrivateRouteInternalCompaniesCompanyIdSettingsIndexRouteRoute;
  '/events/$eventId/details': typeof PrivateRouteInternalEventsEventIdDetailsIndexRouteRoute;
  '/events/$eventId/email-settings': typeof PrivateRouteInternalEventsEventIdEmailSettingsIndexRouteRoute;
  '/events/$eventId/emails': typeof PrivateRouteInternalEventsEventIdEmailsIndexRouteRoute;
  '/people/$identityId/accounts': typeof PrivateRouteInternalPeopleIdentityIdAccountsIndexRouteRoute;
  '/people/$identityId/emails': typeof PrivateRouteInternalPeopleIdentityIdEmailsIndexRouteRoute;
  '/trending/$submissionId/edit': typeof PrivateRouteInternalTrendingSubmissionIdEditIndexRouteRoute;
  '/teams/$teamId/introductions/$candidateId': typeof PrivateRouteTeamsTeamIdIntroductionsCandidateIdIndexRouteRoute;
  '/teams/$teamId/searches/$searchId': typeof PrivateRouteTeamsTeamIdSearchesSearchIdIndexRouteRoute;
  '/teams/$teamId/trending/$recommendationId': typeof PrivateRouteTeamsTeamIdTrendingRecommendationIdIndexRouteRoute;
  '/users/$userId/events/$eventId': typeof PrivateRouteUsersUserIdEventsEventIdIndexRouteRoute;
  '/users/$userId/pipelines/$pipelineId': typeof PrivateRouteUsersUserIdPipelinesPipelineIdIndexRouteRoute;
  '/users/$userId/trending/$recommendationId': typeof PrivateRouteUsersUserIdTrendingRecommendationIdIndexRouteRoute;
  '/teams/$teamId/pipelines/$pipelineId/recommendations': typeof PrivateRouteTeamsTeamIdPipelinesPipelineIdInternalRecommendationsIndexRouteRoute;
  '/teams/$teamId/pipelines/$pipelineId/recommendations/new': typeof PrivateRouteTeamsTeamIdPipelinesPipelineIdRecommendationsNewRouteRoute;
  '/users/$userId/pipelines/$pipelineId/recommendations/new': typeof PrivateRouteUsersUserIdPipelinesPipelineIdRecommendationsNewRouteRoute;
  '/admin/users/$userId/settings': typeof PrivateRouteInternalAdminUsersUserIdSettingsIndexRouteRoute;
  '/events/$eventId/participants/new': typeof PrivateRouteInternalEventsEventIdParticipantsNewIndexRouteRoute;
  '/people/$identityId/about': typeof PrivateRouteInternalPeopleIdentityIdCandidateAboutIndexRouteRoute;
  '/people/$identityId/compare': typeof PrivateRouteInternalPeopleIdentityIdCandidateCompareIndexRouteRoute;
  '/people/$identityId/feedback': typeof PrivateRouteInternalPeopleIdentityIdCandidateFeedbackIndexRouteRoute;
  '/people/$identityId/performance': typeof PrivateRouteInternalPeopleIdentityIdCandidatePerformanceIndexRouteRoute;
  '/people/$identityId/profile': typeof PrivateRouteInternalPeopleIdentityIdCandidateProfileIndexRouteRoute;
  '/people/$identityId/recommendations': typeof PrivateRouteInternalPeopleIdentityIdCandidateRecommendationsIndexRouteRoute;
  '/people/$identityId/suggested-pipelines': typeof PrivateRouteInternalPeopleIdentityIdCandidateSuggestedPipelinesIndexRouteRoute;
  '/teams/$teamId/candidates/$candidateId/activity': typeof PrivateRouteTeamsTeamIdCandidatesCandidateIdActivityIndexRouteRoute;
  '/teams/$teamId/candidates/$candidateId/pipelines': typeof PrivateRouteTeamsTeamIdCandidatesCandidateIdPipelinesIndexRouteRoute;
  '/people/$identityId/tasks': typeof PrivateRouteInternalPeopleIdentityIdCandidateTasksIndexLazyRoute;
  '/candidates/$candidateId/tasks/goals/$goalId': typeof PrivateRouteInternalCandidatesCandidateIdTasksGoalsGoalIdIndexRouteRoute;
  '/teams/$teamId/pipelines/$pipelineId/introductions/$candidateId': typeof PrivateRouteTeamsTeamIdPipelinesPipelineIdIntroductionsCandidateIdIndexRouteRoute;
  '/teams/$teamId/pipelines/$pipelineId/submissions/$submissionId': typeof PrivateRouteTeamsTeamIdPipelinesPipelineIdSubmissionsSubmissionIdIndexRouteRoute;
  '/teams/$teamId/searches/$searchId/candidates/$candidateId': typeof PrivateRouteTeamsTeamIdSearchesSearchIdCandidatesCandidateIdIndexRouteRoute;
  '/users/$userId/pipelines/$pipelineId/recommendations/$recommendationId': typeof PrivateRouteUsersUserIdPipelinesPipelineIdRecommendationsRecommendationIdIndexRouteRoute;
  '/people/$identityId/tasks/goals/$goalId': typeof PrivateRouteInternalPeopleIdentityIdCandidateTasksGoalsGoalIdIndexRouteRoute;
  '/teams/$teamId/searches/$searchId/submissions/$submissionId': typeof PrivateRouteInternalTeamsTeamIdSearchesSearchIdSubmissionsSubmissionIdIndexRouteRoute;
  '/teams/$teamId/pipelines/$pipelineId/recommendations/$recommendationId': typeof PrivateRouteTeamsTeamIdPipelinesPipelineIdInternalRecommendationsRecommendationIdIndexRouteRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  '/_layoutAuth': typeof LayoutAuthRouteRouteWithChildren;
  '/_private': typeof PrivateRouteRouteWithChildren;
  '/events': typeof EventsRouteRouteWithChildren;
  '/registration': typeof RegistrationRouteRoute;
  '/_layoutAuth/_guest': typeof LayoutAuthGuestRouteRouteWithChildren;
  '/_private/_route': typeof PrivateRouteRouteRouteWithChildren;
  '/events/rsvp': typeof EventsRsvpRouteRoute;
  '/_private/_auth': typeof PrivateAuthLazyRouteWithChildren;
  '/_private/': typeof PrivateIndexRouteRoute;
  '/_private/_auth/set-password': typeof PrivateAuthSetPasswordRouteRoute;
  '/_private/_route/$': typeof PrivateRouteSplatRouteRoute;
  '/_private/_route/_internal': typeof PrivateRouteInternalRouteRouteWithChildren;
  '/_private/_route/profile': typeof PrivateRouteProfileRouteRouteWithChildren;
  '/_layoutAuth/logout/': typeof LayoutAuthLogoutIndexRouteRoute;
  '/_layoutAuth/maintenance/': typeof LayoutAuthMaintenanceIndexRouteRoute;
  '/_private/teams/': typeof PrivateTeamsIndexRouteRoute;
  '/_private/_route/_internal/admin': typeof PrivateRouteInternalAdminRouteRouteWithChildren;
  '/_private/_route/_internal/events': typeof PrivateRouteInternalEventsRouteRouteWithChildren;
  '/_private/_route/_internal/pipelines': typeof PrivateRouteInternalPipelinesRouteRouteWithChildren;
  '/_private/_route/_internal/tasks': typeof PrivateRouteInternalTasksRouteRouteWithChildren;
  '/_private/_route/_internal/trending': typeof PrivateRouteInternalTrendingRouteRouteWithChildren;
  '/_private/_route/teams/$teamId': typeof PrivateRouteTeamsTeamIdRouteRouteWithChildren;
  '/_private/_route/users/$userId': typeof PrivateRouteUsersUserIdRouteRouteWithChildren;
  '/_layoutAuth/_guest/email-response/': typeof LayoutAuthGuestEmailResponseIndexRouteRoute;
  '/_layoutAuth/_guest/join/': typeof LayoutAuthGuestJoinIndexRouteRoute;
  '/_layoutAuth/_guest/login/': typeof LayoutAuthGuestLoginIndexRouteRoute;
  '/_private/_auth/signup/': typeof PrivateAuthSignupIndexRouteRoute;
  '/_private/_route/profile/': typeof PrivateRouteProfileIndexRouteRoute;
  '/_private/_route/users/': typeof PrivateRouteUsersIndexRouteRoute;
  '/_private/teams/$teamId/': typeof PrivateTeamsTeamIdIndexRouteRoute;
  '/_private/_route/_internal/pipelines/': typeof PrivateRouteInternalPipelinesIndexRouteRoute;
  '/_private/_route/_internal/candidates/$candidateId': typeof PrivateRouteInternalCandidatesCandidateIdRouteRouteWithChildren;
  '/_private/_route/_internal/events/$eventId': typeof PrivateRouteInternalEventsEventIdRouteRouteWithChildren;
  '/_private/_route/_internal/people/$identityId': typeof PrivateRouteInternalPeopleIdentityIdRouteRouteWithChildren;
  '/_private/_route/_internal/pipelines_/new': typeof PrivateRouteInternalPipelinesNewRouteRoute;
  '/_private/_route/teams/$teamId/candidates': typeof PrivateRouteTeamsTeamIdCandidatesRouteRouteWithChildren;
  '/_private/_route/teams/$teamId/network': typeof PrivateRouteTeamsTeamIdNetworkRouteRoute;
  '/_private/_route/users/$userId/people': typeof PrivateRouteUsersUserIdPeopleRouteRouteWithChildren;
  '/_private/_route/users/$userId/trending': typeof PrivateRouteUsersUserIdTrendingRouteRouteWithChildren;
  '/_private/_route/teams/$teamId/trending': typeof PrivateRouteTeamsTeamIdTrendingLazyRouteWithChildren;
  '/_private/_route/_internal/companies/': typeof PrivateRouteInternalCompaniesIndexRouteRoute;
  '/_private/_route/_internal/events/': typeof PrivateRouteInternalEventsIndexRouteRoute;
  '/_private/_route/_internal/experiments/': typeof PrivateRouteInternalExperimentsIndexRouteRoute;
  '/_private/_route/_internal/home/': typeof PrivateRouteInternalHomeIndexRouteRoute;
  '/_private/_route/_internal/introductions/': typeof PrivateRouteInternalIntroductionsIndexRouteRoute;
  '/_private/_route/_internal/peers/': typeof PrivateRouteInternalPeersIndexRouteRoute;
  '/_private/_route/_internal/people/': typeof PrivateRouteInternalPeopleIndexRouteRoute;
  '/_private/_route/_internal/performance/': typeof PrivateRouteInternalPerformanceIndexRouteRoute;
  '/_private/_route/_internal/pipeline-submissions/': typeof PrivateRouteInternalPipelineSubmissionsIndexRouteRoute;
  '/_private/_route/_internal/search-submissions/': typeof PrivateRouteInternalSearchSubmissionsIndexRouteRoute;
  '/_private/_route/_internal/searches/': typeof PrivateRouteInternalSearchesIndexRouteRoute;
  '/_private/_route/_internal/tasks/': typeof PrivateRouteInternalTasksIndexRouteRoute;
  '/_private/_route/_internal/tools/': typeof PrivateRouteInternalToolsIndexRouteRoute;
  '/_private/_route/_internal/trending/': typeof PrivateRouteInternalTrendingIndexRouteRoute;
  '/_private/_route/profile/teams/': typeof PrivateRouteProfileTeamsIndexRouteRoute;
  '/_private/_route/users/$userId/': typeof PrivateRouteUsersUserIdIndexRouteRoute;
  '/_private/_route/users/new/': typeof PrivateRouteUsersNewIndexRouteRoute;
  '/_private/_route/_internal/admin/users/$userId': typeof PrivateRouteInternalAdminUsersUserIdRouteRouteWithChildren;
  '/_private/_route/_internal/candidates/$candidateId/tasks': typeof PrivateRouteInternalCandidatesCandidateIdTasksRouteRouteWithChildren;
  '/_private/_route/_internal/events/$eventId/participants': typeof PrivateRouteInternalEventsEventIdParticipantsRouteRouteWithChildren;
  '/_private/_route/_internal/events/participants/$participantId': typeof PrivateRouteInternalEventsParticipantsParticipantIdRouteRouteWithChildren;
  '/_private/_route/_internal/people/$identityId/_candidate': typeof PrivateRouteInternalPeopleIdentityIdCandidateRouteRouteWithChildren;
  '/_private/_route/teams/$teamId/candidates/$candidateId': typeof PrivateRouteTeamsTeamIdCandidatesCandidateIdRouteRouteWithChildren;
  '/_private/_route/teams/$teamId/pipelines/new': typeof PrivateRouteTeamsTeamIdPipelinesNewRouteRoute;
  '/_private/_route/users/$userId/people/$candidateId': typeof PrivateRouteUsersUserIdPeopleCandidateIdRouteRoute;
  '/_private/_route/users/$userId/pipelines/new': typeof PrivateRouteUsersUserIdPipelinesNewRouteRoute;
  '/_private/_route/teams/$teamId/pipelines/$pipelineId': typeof PrivateRouteTeamsTeamIdPipelinesPipelineIdLazyRouteWithChildren;
  '/_private/_route/_internal/admin/users/': typeof PrivateRouteInternalAdminUsersIndexRouteRoute;
  '/_private/_route/_internal/candidates/$candidateId/': typeof PrivateRouteInternalCandidatesCandidateIdIndexRouteRoute;
  '/_private/_route/_internal/candidates/new/': typeof PrivateRouteInternalCandidatesNewIndexRouteRoute;
  '/_private/_route/_internal/events/$eventId/': typeof PrivateRouteInternalEventsEventIdIndexRouteRoute;
  '/_private/_route/_internal/events/events/': typeof PrivateRouteInternalEventsEventsIndexRouteRoute;
  '/_private/_route/_internal/events/new/': typeof PrivateRouteInternalEventsNewIndexRouteRoute;
  '/_private/_route/_internal/events/participants/': typeof PrivateRouteInternalEventsParticipantsIndexRouteRoute;
  '/_private/_route/_internal/events/settings/': typeof PrivateRouteInternalEventsSettingsIndexRouteRoute;
  '/_private/_route/_internal/introduction-submissions/$submissionId/': typeof PrivateRouteInternalIntroductionSubmissionsSubmissionIdIndexRouteRoute;
  '/_private/_route/_internal/peers/new/': typeof PrivateRouteInternalPeersNewIndexRouteRoute;
  '/_private/_route/_internal/people/$identityId/': typeof PrivateRouteInternalPeopleIdentityIdIndexRouteRoute;
  '/_private/_route/_internal/pipeline-submissions/$submissionId/': typeof PrivateRouteInternalPipelineSubmissionsSubmissionIdIndexRouteRoute;
  '/_private/_route/_internal/tasks/executive-services/': typeof PrivateRouteInternalTasksExecutiveServicesIndexRouteRoute;
  '/_private/_route/_internal/tasks/me/': typeof PrivateRouteInternalTasksMeIndexRouteRoute;
  '/_private/_route/_internal/tools/ai-candidate-discovery/': typeof PrivateRouteInternalToolsAiCandidateDiscoveryIndexRouteRoute;
  '/_private/_route/_internal/tools/email-templates/': typeof PrivateRouteInternalToolsEmailTemplatesIndexRouteRoute;
  '/_private/_route/_internal/tools/market-searches/': typeof PrivateRouteInternalToolsMarketSearchesIndexRouteRoute;
  '/_private/_route/_internal/tools/merge-people/': typeof PrivateRouteInternalToolsMergePeopleIndexRouteRoute;
  '/_private/_route/_internal/tools/move-team/': typeof PrivateRouteInternalToolsMoveTeamIndexRouteRoute;
  '/_private/_route/_internal/tools/pathway-activity-defaults/': typeof PrivateRouteInternalToolsPathwayActivityDefaultsIndexRouteRoute;
  '/_private/_route/_internal/trending/$submissionId/': typeof PrivateRouteInternalTrendingSubmissionIdIndexRouteRoute;
  '/_private/_route/_internal/trending/campaigns/': typeof PrivateRouteInternalTrendingCampaignsIndexRouteRoute;
  '/_private/_route/_internal/trending/new/': typeof PrivateRouteInternalTrendingNewIndexRouteRoute;
  '/_private/_route/_internal/trending/people/': typeof PrivateRouteInternalTrendingPeopleIndexRouteRoute;
  '/_private/_route/teams/$teamId/home/': typeof PrivateRouteTeamsTeamIdHomeIndexRouteRoute;
  '/_private/_route/teams/$teamId/introductions/': typeof PrivateRouteTeamsTeamIdIntroductionsIndexRouteRoute;
  '/_private/_route/teams/$teamId/pipelines/': typeof PrivateRouteTeamsTeamIdPipelinesIndexRouteRoute;
  '/_private/_route/teams/$teamId/searches/': typeof PrivateRouteTeamsTeamIdSearchesIndexRouteRoute;
  '/_private/_route/teams/$teamId/settings/': typeof PrivateRouteTeamsTeamIdSettingsIndexRouteRoute;
  '/_private/_route/users/$userId/events/': typeof PrivateRouteUsersUserIdEventsIndexRouteRoute;
  '/_private/_route/users/$userId/pipelines/': typeof PrivateRouteUsersUserIdPipelinesIndexRouteRoute;
  '/_private/_route/users/$userId/settings/': typeof PrivateRouteUsersUserIdSettingsIndexRouteRoute;
  '/_private/_route/teams/$teamId/trending/': typeof PrivateRouteTeamsTeamIdTrendingIndexRoute;
  '/_private/_route/users/$userId/trending/': typeof PrivateRouteUsersUserIdTrendingIndexRoute;
  '/_private/_route/_internal/people/$identityId/_candidate/tasks': typeof PrivateRouteInternalPeopleIdentityIdCandidateTasksRouteRouteWithChildren;
  '/_private/_route/teams/$teamId/candidates/$candidateId/$tabId': typeof PrivateRouteTeamsTeamIdCandidatesCandidateIdTabIdRouteRoute;
  '/_private/_route/teams/$teamId/pipelines_/$pipelineId/edit': typeof PrivateRouteTeamsTeamIdPipelinesPipelineIdEditRouteRoute;
  '/_private/_route/users/$userId/pipelines/$pipelineId/edit': typeof PrivateRouteUsersUserIdPipelinesPipelineIdEditRouteRoute;
  '/_private/_route/teams/$teamId/pipelines/$pipelineId/_internal': typeof PrivateRouteTeamsTeamIdPipelinesPipelineIdInternalLazyRouteWithChildren;
  '/_private/_route/_internal/admin/users/new/': typeof PrivateRouteInternalAdminUsersNewIndexRouteRoute;
  '/_private/_route/_internal/candidates/$candidateId/about/': typeof PrivateRouteInternalCandidatesCandidateIdAboutIndexRouteRoute;
  '/_private/_route/_internal/candidates/$candidateId/accounts/': typeof PrivateRouteInternalCandidatesCandidateIdAccountsIndexRouteRoute;
  '/_private/_route/_internal/candidates/$candidateId/compare/': typeof PrivateRouteInternalCandidatesCandidateIdCompareIndexRouteRoute;
  '/_private/_route/_internal/candidates/$candidateId/feedback/': typeof PrivateRouteInternalCandidatesCandidateIdFeedbackIndexRouteRoute;
  '/_private/_route/_internal/candidates/$candidateId/performance/': typeof PrivateRouteInternalCandidatesCandidateIdPerformanceIndexRouteRoute;
  '/_private/_route/_internal/candidates/$candidateId/profile/': typeof PrivateRouteInternalCandidatesCandidateIdProfileIndexRouteRoute;
  '/_private/_route/_internal/candidates/$candidateId/recommendations/': typeof PrivateRouteInternalCandidatesCandidateIdRecommendationsIndexRouteRoute;
  '/_private/_route/_internal/candidates/$candidateId/suggested-pipelines/': typeof PrivateRouteInternalCandidatesCandidateIdSuggestedPipelinesIndexRouteRoute;
  '/_private/_route/_internal/companies/$companyId/people/': typeof PrivateRouteInternalCompaniesCompanyIdPeopleIndexRouteRoute;
  '/_private/_route/_internal/companies/$companyId/settings/': typeof PrivateRouteInternalCompaniesCompanyIdSettingsIndexRouteRoute;
  '/_private/_route/_internal/events/$eventId/details/': typeof PrivateRouteInternalEventsEventIdDetailsIndexRouteRoute;
  '/_private/_route/_internal/events/$eventId/email-settings/': typeof PrivateRouteInternalEventsEventIdEmailSettingsIndexRouteRoute;
  '/_private/_route/_internal/events/$eventId/emails/': typeof PrivateRouteInternalEventsEventIdEmailsIndexRouteRoute;
  '/_private/_route/_internal/events/participants/$participantId/': typeof PrivateRouteInternalEventsParticipantsParticipantIdIndexRouteRoute;
  '/_private/_route/_internal/people/$identityId/accounts/': typeof PrivateRouteInternalPeopleIdentityIdAccountsIndexRouteRoute;
  '/_private/_route/_internal/people/$identityId/emails/': typeof PrivateRouteInternalPeopleIdentityIdEmailsIndexRouteRoute;
  '/_private/_route/_internal/trending/$submissionId/edit/': typeof PrivateRouteInternalTrendingSubmissionIdEditIndexRouteRoute;
  '/_private/_route/teams/$teamId/candidates/$candidateId/': typeof PrivateRouteTeamsTeamIdCandidatesCandidateIdIndexRouteRoute;
  '/_private/_route/teams/$teamId/introductions/$candidateId/': typeof PrivateRouteTeamsTeamIdIntroductionsCandidateIdIndexRouteRoute;
  '/_private/_route/teams/$teamId/searches/$searchId/': typeof PrivateRouteTeamsTeamIdSearchesSearchIdIndexRouteRoute;
  '/_private/_route/teams/$teamId/trending/$recommendationId/': typeof PrivateRouteTeamsTeamIdTrendingRecommendationIdIndexRouteRoute;
  '/_private/_route/users/$userId/events/$eventId/': typeof PrivateRouteUsersUserIdEventsEventIdIndexRouteRoute;
  '/_private/_route/users/$userId/pipelines/$pipelineId/': typeof PrivateRouteUsersUserIdPipelinesPipelineIdIndexRouteRoute;
  '/_private/_route/users/$userId/trending/$recommendationId/': typeof PrivateRouteUsersUserIdTrendingRecommendationIdIndexRouteRoute;
  '/_private/_route/teams/$teamId/pipelines/$pipelineId/_internal/': typeof PrivateRouteTeamsTeamIdPipelinesPipelineIdInternalIndexRouteRoute;
  '/_private/_route/teams/$teamId/pipelines/$pipelineId/_internal/recommendations': typeof PrivateRouteTeamsTeamIdPipelinesPipelineIdInternalRecommendationsRouteRouteWithChildren;
  '/_private/_route/teams/$teamId/pipelines/$pipelineId_/recommendations/new': typeof PrivateRouteTeamsTeamIdPipelinesPipelineIdRecommendationsNewRouteRoute;
  '/_private/_route/users/$userId/pipelines/$pipelineId_/recommendations/new': typeof PrivateRouteUsersUserIdPipelinesPipelineIdRecommendationsNewRouteRoute;
  '/_private/_route/_internal/admin/users/$userId/settings/': typeof PrivateRouteInternalAdminUsersUserIdSettingsIndexRouteRoute;
  '/_private/_route/_internal/events/$eventId/participants/new/': typeof PrivateRouteInternalEventsEventIdParticipantsNewIndexRouteRoute;
  '/_private/_route/_internal/people/$identityId/_candidate/about/': typeof PrivateRouteInternalPeopleIdentityIdCandidateAboutIndexRouteRoute;
  '/_private/_route/_internal/people/$identityId/_candidate/compare/': typeof PrivateRouteInternalPeopleIdentityIdCandidateCompareIndexRouteRoute;
  '/_private/_route/_internal/people/$identityId/_candidate/feedback/': typeof PrivateRouteInternalPeopleIdentityIdCandidateFeedbackIndexRouteRoute;
  '/_private/_route/_internal/people/$identityId/_candidate/performance/': typeof PrivateRouteInternalPeopleIdentityIdCandidatePerformanceIndexRouteRoute;
  '/_private/_route/_internal/people/$identityId/_candidate/profile/': typeof PrivateRouteInternalPeopleIdentityIdCandidateProfileIndexRouteRoute;
  '/_private/_route/_internal/people/$identityId/_candidate/recommendations/': typeof PrivateRouteInternalPeopleIdentityIdCandidateRecommendationsIndexRouteRoute;
  '/_private/_route/_internal/people/$identityId/_candidate/suggested-pipelines/': typeof PrivateRouteInternalPeopleIdentityIdCandidateSuggestedPipelinesIndexRouteRoute;
  '/_private/_route/teams/$teamId/candidates/$candidateId/activity/': typeof PrivateRouteTeamsTeamIdCandidatesCandidateIdActivityIndexRouteRoute;
  '/_private/_route/teams/$teamId/candidates/$candidateId/pipelines/': typeof PrivateRouteTeamsTeamIdCandidatesCandidateIdPipelinesIndexRouteRoute;
  '/_private/_route/_internal/people/$identityId/_candidate/tasks/': typeof PrivateRouteInternalPeopleIdentityIdCandidateTasksIndexLazyRoute;
  '/_private/_route/_internal/candidates/$candidateId/tasks/goals/$goalId/': typeof PrivateRouteInternalCandidatesCandidateIdTasksGoalsGoalIdIndexRouteRoute;
  '/_private/_route/teams/$teamId/pipelines/$pipelineId/_internal/recommendations/': typeof PrivateRouteTeamsTeamIdPipelinesPipelineIdInternalRecommendationsIndexRouteRoute;
  '/_private/_route/teams/$teamId/pipelines/$pipelineId/introductions/$candidateId/': typeof PrivateRouteTeamsTeamIdPipelinesPipelineIdIntroductionsCandidateIdIndexRouteRoute;
  '/_private/_route/teams/$teamId/pipelines/$pipelineId_/submissions/$submissionId/': typeof PrivateRouteTeamsTeamIdPipelinesPipelineIdSubmissionsSubmissionIdIndexRouteRoute;
  '/_private/_route/teams/$teamId/searches/$searchId/candidates/$candidateId/': typeof PrivateRouteTeamsTeamIdSearchesSearchIdCandidatesCandidateIdIndexRouteRoute;
  '/_private/_route/users/$userId/pipelines/$pipelineId/recommendations/$recommendationId/': typeof PrivateRouteUsersUserIdPipelinesPipelineIdRecommendationsRecommendationIdIndexRouteRoute;
  '/_private/_route/_internal/people/$identityId/_candidate/tasks/goals/$goalId/': typeof PrivateRouteInternalPeopleIdentityIdCandidateTasksGoalsGoalIdIndexRouteRoute;
  '/_private/_route/_internal/teams/$teamId/searches/$searchId/submissions/$submissionId/': typeof PrivateRouteInternalTeamsTeamIdSearchesSearchIdSubmissionsSubmissionIdIndexRouteRoute;
  '/_private/_route/teams/$teamId/pipelines/$pipelineId/_internal/recommendations/$recommendationId/': typeof PrivateRouteTeamsTeamIdPipelinesPipelineIdInternalRecommendationsRecommendationIdIndexRouteRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | '/'
    | '/events'
    | '/registration'
    | '/events/rsvp'
    | '/set-password'
    | '/$'
    | '/profile'
    | '/logout/'
    | '/maintenance/'
    | '/teams/'
    | '/admin'
    | '/pipelines'
    | '/tasks'
    | '/trending'
    | '/teams/$teamId'
    | '/users/$userId'
    | '/email-response/'
    | '/join/'
    | '/login/'
    | '/signup/'
    | '/profile/'
    | '/users/'
    | '/teams/$teamId/'
    | '/pipelines/'
    | '/candidates/$candidateId'
    | '/events/$eventId'
    | '/people/$identityId'
    | '/pipelines/new'
    | '/teams/$teamId/candidates'
    | '/teams/$teamId/network'
    | '/users/$userId/people'
    | '/users/$userId/trending'
    | '/teams/$teamId/trending'
    | '/companies/'
    | '/events/'
    | '/experiments/'
    | '/home/'
    | '/introductions/'
    | '/peers/'
    | '/people/'
    | '/performance/'
    | '/pipeline-submissions/'
    | '/search-submissions/'
    | '/searches/'
    | '/tasks/'
    | '/tools/'
    | '/trending/'
    | '/profile/teams/'
    | '/users/$userId/'
    | '/users/new/'
    | '/admin/users/$userId'
    | '/candidates/$candidateId/tasks'
    | '/events/$eventId/participants'
    | '/events/participants/$participantId'
    | '/teams/$teamId/candidates/$candidateId'
    | '/teams/$teamId/pipelines/new'
    | '/users/$userId/people/$candidateId'
    | '/users/$userId/pipelines/new'
    | '/teams/$teamId/pipelines/$pipelineId'
    | '/admin/users/'
    | '/candidates/$candidateId/'
    | '/candidates/new/'
    | '/events/$eventId/'
    | '/events/events/'
    | '/events/new/'
    | '/events/participants/'
    | '/events/settings/'
    | '/introduction-submissions/$submissionId/'
    | '/peers/new/'
    | '/people/$identityId/'
    | '/pipeline-submissions/$submissionId/'
    | '/tasks/executive-services/'
    | '/tasks/me/'
    | '/tools/ai-candidate-discovery/'
    | '/tools/email-templates/'
    | '/tools/market-searches/'
    | '/tools/merge-people/'
    | '/tools/move-team/'
    | '/tools/pathway-activity-defaults/'
    | '/trending/$submissionId/'
    | '/trending/campaigns/'
    | '/trending/new/'
    | '/trending/people/'
    | '/teams/$teamId/home/'
    | '/teams/$teamId/introductions/'
    | '/teams/$teamId/pipelines/'
    | '/teams/$teamId/searches/'
    | '/teams/$teamId/settings/'
    | '/users/$userId/events/'
    | '/users/$userId/pipelines/'
    | '/users/$userId/settings/'
    | '/teams/$teamId/trending/'
    | '/users/$userId/trending/'
    | '/people/$identityId/tasks'
    | '/teams/$teamId/candidates/$candidateId/$tabId'
    | '/teams/$teamId/pipelines/$pipelineId/edit'
    | '/users/$userId/pipelines/$pipelineId/edit'
    | '/admin/users/new/'
    | '/candidates/$candidateId/about/'
    | '/candidates/$candidateId/accounts/'
    | '/candidates/$candidateId/compare/'
    | '/candidates/$candidateId/feedback/'
    | '/candidates/$candidateId/performance/'
    | '/candidates/$candidateId/profile/'
    | '/candidates/$candidateId/recommendations/'
    | '/candidates/$candidateId/suggested-pipelines/'
    | '/companies/$companyId/people/'
    | '/companies/$companyId/settings/'
    | '/events/$eventId/details/'
    | '/events/$eventId/email-settings/'
    | '/events/$eventId/emails/'
    | '/events/participants/$participantId/'
    | '/people/$identityId/accounts/'
    | '/people/$identityId/emails/'
    | '/trending/$submissionId/edit/'
    | '/teams/$teamId/candidates/$candidateId/'
    | '/teams/$teamId/introductions/$candidateId/'
    | '/teams/$teamId/searches/$searchId/'
    | '/teams/$teamId/trending/$recommendationId/'
    | '/users/$userId/events/$eventId/'
    | '/users/$userId/pipelines/$pipelineId/'
    | '/users/$userId/trending/$recommendationId/'
    | '/teams/$teamId/pipelines/$pipelineId/'
    | '/teams/$teamId/pipelines/$pipelineId/recommendations'
    | '/teams/$teamId/pipelines/$pipelineId/recommendations/new'
    | '/users/$userId/pipelines/$pipelineId/recommendations/new'
    | '/admin/users/$userId/settings/'
    | '/events/$eventId/participants/new/'
    | '/people/$identityId/about/'
    | '/people/$identityId/compare/'
    | '/people/$identityId/feedback/'
    | '/people/$identityId/performance/'
    | '/people/$identityId/profile/'
    | '/people/$identityId/recommendations/'
    | '/people/$identityId/suggested-pipelines/'
    | '/teams/$teamId/candidates/$candidateId/activity/'
    | '/teams/$teamId/candidates/$candidateId/pipelines/'
    | '/people/$identityId/tasks/'
    | '/candidates/$candidateId/tasks/goals/$goalId/'
    | '/teams/$teamId/pipelines/$pipelineId/recommendations/'
    | '/teams/$teamId/pipelines/$pipelineId/introductions/$candidateId/'
    | '/teams/$teamId/pipelines/$pipelineId/submissions/$submissionId/'
    | '/teams/$teamId/searches/$searchId/candidates/$candidateId/'
    | '/users/$userId/pipelines/$pipelineId/recommendations/$recommendationId/'
    | '/people/$identityId/tasks/goals/$goalId/'
    | '/teams/$teamId/searches/$searchId/submissions/$submissionId/'
    | '/teams/$teamId/pipelines/$pipelineId/recommendations/$recommendationId/';
  fileRoutesByTo: FileRoutesByTo;
  to:
    | '/'
    | '/events'
    | '/registration'
    | '/events/rsvp'
    | '/set-password'
    | '/$'
    | '/profile'
    | '/logout'
    | '/maintenance'
    | '/teams'
    | '/admin'
    | '/pipelines'
    | '/tasks'
    | '/trending'
    | '/teams/$teamId'
    | '/users/$userId'
    | '/email-response'
    | '/join'
    | '/login'
    | '/signup'
    | '/users'
    | '/candidates/$candidateId'
    | '/events/$eventId'
    | '/people/$identityId'
    | '/pipelines/new'
    | '/teams/$teamId/candidates'
    | '/teams/$teamId/network'
    | '/users/$userId/people'
    | '/companies'
    | '/experiments'
    | '/home'
    | '/introductions'
    | '/peers'
    | '/people'
    | '/performance'
    | '/pipeline-submissions'
    | '/search-submissions'
    | '/searches'
    | '/tools'
    | '/profile/teams'
    | '/users/new'
    | '/admin/users/$userId'
    | '/candidates/$candidateId/tasks'
    | '/events/$eventId/participants'
    | '/events/participants/$participantId'
    | '/teams/$teamId/candidates/$candidateId'
    | '/teams/$teamId/pipelines/new'
    | '/users/$userId/people/$candidateId'
    | '/users/$userId/pipelines/new'
    | '/teams/$teamId/pipelines/$pipelineId'
    | '/admin/users'
    | '/candidates/new'
    | '/events/events'
    | '/events/new'
    | '/events/participants'
    | '/events/settings'
    | '/introduction-submissions/$submissionId'
    | '/peers/new'
    | '/pipeline-submissions/$submissionId'
    | '/tasks/executive-services'
    | '/tasks/me'
    | '/tools/ai-candidate-discovery'
    | '/tools/email-templates'
    | '/tools/market-searches'
    | '/tools/merge-people'
    | '/tools/move-team'
    | '/tools/pathway-activity-defaults'
    | '/trending/$submissionId'
    | '/trending/campaigns'
    | '/trending/new'
    | '/trending/people'
    | '/teams/$teamId/home'
    | '/teams/$teamId/introductions'
    | '/teams/$teamId/pipelines'
    | '/teams/$teamId/searches'
    | '/teams/$teamId/settings'
    | '/users/$userId/events'
    | '/users/$userId/pipelines'
    | '/users/$userId/settings'
    | '/teams/$teamId/trending'
    | '/users/$userId/trending'
    | '/teams/$teamId/candidates/$candidateId/$tabId'
    | '/teams/$teamId/pipelines/$pipelineId/edit'
    | '/users/$userId/pipelines/$pipelineId/edit'
    | '/admin/users/new'
    | '/candidates/$candidateId/about'
    | '/candidates/$candidateId/accounts'
    | '/candidates/$candidateId/compare'
    | '/candidates/$candidateId/feedback'
    | '/candidates/$candidateId/performance'
    | '/candidates/$candidateId/profile'
    | '/candidates/$candidateId/recommendations'
    | '/candidates/$candidateId/suggested-pipelines'
    | '/companies/$companyId/people'
    | '/companies/$companyId/settings'
    | '/events/$eventId/details'
    | '/events/$eventId/email-settings'
    | '/events/$eventId/emails'
    | '/people/$identityId/accounts'
    | '/people/$identityId/emails'
    | '/trending/$submissionId/edit'
    | '/teams/$teamId/introductions/$candidateId'
    | '/teams/$teamId/searches/$searchId'
    | '/teams/$teamId/trending/$recommendationId'
    | '/users/$userId/events/$eventId'
    | '/users/$userId/pipelines/$pipelineId'
    | '/users/$userId/trending/$recommendationId'
    | '/teams/$teamId/pipelines/$pipelineId/recommendations'
    | '/teams/$teamId/pipelines/$pipelineId/recommendations/new'
    | '/users/$userId/pipelines/$pipelineId/recommendations/new'
    | '/admin/users/$userId/settings'
    | '/events/$eventId/participants/new'
    | '/people/$identityId/about'
    | '/people/$identityId/compare'
    | '/people/$identityId/feedback'
    | '/people/$identityId/performance'
    | '/people/$identityId/profile'
    | '/people/$identityId/recommendations'
    | '/people/$identityId/suggested-pipelines'
    | '/teams/$teamId/candidates/$candidateId/activity'
    | '/teams/$teamId/candidates/$candidateId/pipelines'
    | '/people/$identityId/tasks'
    | '/candidates/$candidateId/tasks/goals/$goalId'
    | '/teams/$teamId/pipelines/$pipelineId/introductions/$candidateId'
    | '/teams/$teamId/pipelines/$pipelineId/submissions/$submissionId'
    | '/teams/$teamId/searches/$searchId/candidates/$candidateId'
    | '/users/$userId/pipelines/$pipelineId/recommendations/$recommendationId'
    | '/people/$identityId/tasks/goals/$goalId'
    | '/teams/$teamId/searches/$searchId/submissions/$submissionId'
    | '/teams/$teamId/pipelines/$pipelineId/recommendations/$recommendationId';
  id:
    | '__root__'
    | '/_layoutAuth'
    | '/_private'
    | '/events'
    | '/registration'
    | '/_layoutAuth/_guest'
    | '/_private/_route'
    | '/events/rsvp'
    | '/_private/_auth'
    | '/_private/'
    | '/_private/_auth/set-password'
    | '/_private/_route/$'
    | '/_private/_route/_internal'
    | '/_private/_route/profile'
    | '/_layoutAuth/logout/'
    | '/_layoutAuth/maintenance/'
    | '/_private/teams/'
    | '/_private/_route/_internal/admin'
    | '/_private/_route/_internal/events'
    | '/_private/_route/_internal/pipelines'
    | '/_private/_route/_internal/tasks'
    | '/_private/_route/_internal/trending'
    | '/_private/_route/teams/$teamId'
    | '/_private/_route/users/$userId'
    | '/_layoutAuth/_guest/email-response/'
    | '/_layoutAuth/_guest/join/'
    | '/_layoutAuth/_guest/login/'
    | '/_private/_auth/signup/'
    | '/_private/_route/profile/'
    | '/_private/_route/users/'
    | '/_private/teams/$teamId/'
    | '/_private/_route/_internal/pipelines/'
    | '/_private/_route/_internal/candidates/$candidateId'
    | '/_private/_route/_internal/events/$eventId'
    | '/_private/_route/_internal/people/$identityId'
    | '/_private/_route/_internal/pipelines_/new'
    | '/_private/_route/teams/$teamId/candidates'
    | '/_private/_route/teams/$teamId/network'
    | '/_private/_route/users/$userId/people'
    | '/_private/_route/users/$userId/trending'
    | '/_private/_route/teams/$teamId/trending'
    | '/_private/_route/_internal/companies/'
    | '/_private/_route/_internal/events/'
    | '/_private/_route/_internal/experiments/'
    | '/_private/_route/_internal/home/'
    | '/_private/_route/_internal/introductions/'
    | '/_private/_route/_internal/peers/'
    | '/_private/_route/_internal/people/'
    | '/_private/_route/_internal/performance/'
    | '/_private/_route/_internal/pipeline-submissions/'
    | '/_private/_route/_internal/search-submissions/'
    | '/_private/_route/_internal/searches/'
    | '/_private/_route/_internal/tasks/'
    | '/_private/_route/_internal/tools/'
    | '/_private/_route/_internal/trending/'
    | '/_private/_route/profile/teams/'
    | '/_private/_route/users/$userId/'
    | '/_private/_route/users/new/'
    | '/_private/_route/_internal/admin/users/$userId'
    | '/_private/_route/_internal/candidates/$candidateId/tasks'
    | '/_private/_route/_internal/events/$eventId/participants'
    | '/_private/_route/_internal/events/participants/$participantId'
    | '/_private/_route/_internal/people/$identityId/_candidate'
    | '/_private/_route/teams/$teamId/candidates/$candidateId'
    | '/_private/_route/teams/$teamId/pipelines/new'
    | '/_private/_route/users/$userId/people/$candidateId'
    | '/_private/_route/users/$userId/pipelines/new'
    | '/_private/_route/teams/$teamId/pipelines/$pipelineId'
    | '/_private/_route/_internal/admin/users/'
    | '/_private/_route/_internal/candidates/$candidateId/'
    | '/_private/_route/_internal/candidates/new/'
    | '/_private/_route/_internal/events/$eventId/'
    | '/_private/_route/_internal/events/events/'
    | '/_private/_route/_internal/events/new/'
    | '/_private/_route/_internal/events/participants/'
    | '/_private/_route/_internal/events/settings/'
    | '/_private/_route/_internal/introduction-submissions/$submissionId/'
    | '/_private/_route/_internal/peers/new/'
    | '/_private/_route/_internal/people/$identityId/'
    | '/_private/_route/_internal/pipeline-submissions/$submissionId/'
    | '/_private/_route/_internal/tasks/executive-services/'
    | '/_private/_route/_internal/tasks/me/'
    | '/_private/_route/_internal/tools/ai-candidate-discovery/'
    | '/_private/_route/_internal/tools/email-templates/'
    | '/_private/_route/_internal/tools/market-searches/'
    | '/_private/_route/_internal/tools/merge-people/'
    | '/_private/_route/_internal/tools/move-team/'
    | '/_private/_route/_internal/tools/pathway-activity-defaults/'
    | '/_private/_route/_internal/trending/$submissionId/'
    | '/_private/_route/_internal/trending/campaigns/'
    | '/_private/_route/_internal/trending/new/'
    | '/_private/_route/_internal/trending/people/'
    | '/_private/_route/teams/$teamId/home/'
    | '/_private/_route/teams/$teamId/introductions/'
    | '/_private/_route/teams/$teamId/pipelines/'
    | '/_private/_route/teams/$teamId/searches/'
    | '/_private/_route/teams/$teamId/settings/'
    | '/_private/_route/users/$userId/events/'
    | '/_private/_route/users/$userId/pipelines/'
    | '/_private/_route/users/$userId/settings/'
    | '/_private/_route/teams/$teamId/trending/'
    | '/_private/_route/users/$userId/trending/'
    | '/_private/_route/_internal/people/$identityId/_candidate/tasks'
    | '/_private/_route/teams/$teamId/candidates/$candidateId/$tabId'
    | '/_private/_route/teams/$teamId/pipelines_/$pipelineId/edit'
    | '/_private/_route/users/$userId/pipelines/$pipelineId/edit'
    | '/_private/_route/teams/$teamId/pipelines/$pipelineId/_internal'
    | '/_private/_route/_internal/admin/users/new/'
    | '/_private/_route/_internal/candidates/$candidateId/about/'
    | '/_private/_route/_internal/candidates/$candidateId/accounts/'
    | '/_private/_route/_internal/candidates/$candidateId/compare/'
    | '/_private/_route/_internal/candidates/$candidateId/feedback/'
    | '/_private/_route/_internal/candidates/$candidateId/performance/'
    | '/_private/_route/_internal/candidates/$candidateId/profile/'
    | '/_private/_route/_internal/candidates/$candidateId/recommendations/'
    | '/_private/_route/_internal/candidates/$candidateId/suggested-pipelines/'
    | '/_private/_route/_internal/companies/$companyId/people/'
    | '/_private/_route/_internal/companies/$companyId/settings/'
    | '/_private/_route/_internal/events/$eventId/details/'
    | '/_private/_route/_internal/events/$eventId/email-settings/'
    | '/_private/_route/_internal/events/$eventId/emails/'
    | '/_private/_route/_internal/events/participants/$participantId/'
    | '/_private/_route/_internal/people/$identityId/accounts/'
    | '/_private/_route/_internal/people/$identityId/emails/'
    | '/_private/_route/_internal/trending/$submissionId/edit/'
    | '/_private/_route/teams/$teamId/candidates/$candidateId/'
    | '/_private/_route/teams/$teamId/introductions/$candidateId/'
    | '/_private/_route/teams/$teamId/searches/$searchId/'
    | '/_private/_route/teams/$teamId/trending/$recommendationId/'
    | '/_private/_route/users/$userId/events/$eventId/'
    | '/_private/_route/users/$userId/pipelines/$pipelineId/'
    | '/_private/_route/users/$userId/trending/$recommendationId/'
    | '/_private/_route/teams/$teamId/pipelines/$pipelineId/_internal/'
    | '/_private/_route/teams/$teamId/pipelines/$pipelineId/_internal/recommendations'
    | '/_private/_route/teams/$teamId/pipelines/$pipelineId_/recommendations/new'
    | '/_private/_route/users/$userId/pipelines/$pipelineId_/recommendations/new'
    | '/_private/_route/_internal/admin/users/$userId/settings/'
    | '/_private/_route/_internal/events/$eventId/participants/new/'
    | '/_private/_route/_internal/people/$identityId/_candidate/about/'
    | '/_private/_route/_internal/people/$identityId/_candidate/compare/'
    | '/_private/_route/_internal/people/$identityId/_candidate/feedback/'
    | '/_private/_route/_internal/people/$identityId/_candidate/performance/'
    | '/_private/_route/_internal/people/$identityId/_candidate/profile/'
    | '/_private/_route/_internal/people/$identityId/_candidate/recommendations/'
    | '/_private/_route/_internal/people/$identityId/_candidate/suggested-pipelines/'
    | '/_private/_route/teams/$teamId/candidates/$candidateId/activity/'
    | '/_private/_route/teams/$teamId/candidates/$candidateId/pipelines/'
    | '/_private/_route/_internal/people/$identityId/_candidate/tasks/'
    | '/_private/_route/_internal/candidates/$candidateId/tasks/goals/$goalId/'
    | '/_private/_route/teams/$teamId/pipelines/$pipelineId/_internal/recommendations/'
    | '/_private/_route/teams/$teamId/pipelines/$pipelineId/introductions/$candidateId/'
    | '/_private/_route/teams/$teamId/pipelines/$pipelineId_/submissions/$submissionId/'
    | '/_private/_route/teams/$teamId/searches/$searchId/candidates/$candidateId/'
    | '/_private/_route/users/$userId/pipelines/$pipelineId/recommendations/$recommendationId/'
    | '/_private/_route/_internal/people/$identityId/_candidate/tasks/goals/$goalId/'
    | '/_private/_route/_internal/teams/$teamId/searches/$searchId/submissions/$submissionId/'
    | '/_private/_route/teams/$teamId/pipelines/$pipelineId/_internal/recommendations/$recommendationId/';
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  LayoutAuthRouteRoute: typeof LayoutAuthRouteRouteWithChildren;
  PrivateRouteRoute: typeof PrivateRouteRouteWithChildren;
  EventsRouteRoute: typeof EventsRouteRouteWithChildren;
  RegistrationRouteRoute: typeof RegistrationRouteRoute;
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_layoutAuth': {
      id: '/_layoutAuth';
      path: '';
      fullPath: '/';
      preLoaderRoute: typeof LayoutAuthRouteRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/_private': {
      id: '/_private';
      path: '';
      fullPath: '/';
      preLoaderRoute: typeof PrivateRouteRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/events': {
      id: '/events';
      path: '/events';
      fullPath: '/events';
      preLoaderRoute: typeof EventsRouteRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/registration': {
      id: '/registration';
      path: '/registration';
      fullPath: '/registration';
      preLoaderRoute: typeof RegistrationRouteRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/_layoutAuth/_guest': {
      id: '/_layoutAuth/_guest';
      path: '';
      fullPath: '/';
      preLoaderRoute: typeof LayoutAuthGuestRouteRouteImport;
      parentRoute: typeof LayoutAuthRouteRoute;
    };
    '/_private/': {
      id: '/_private/';
      path: '';
      fullPath: '/';
      preLoaderRoute: typeof PrivateIndexRouteRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    '/_private/_auth': {
      id: '/_private/_auth';
      path: '';
      fullPath: '/';
      preLoaderRoute: typeof PrivateAuthLazyRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    '/_private/_route': {
      id: '/_private/_route';
      path: '';
      fullPath: '/';
      preLoaderRoute: typeof PrivateRouteRouteRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    '/events/rsvp': {
      id: '/events/rsvp';
      path: '/rsvp';
      fullPath: '/events/rsvp';
      preLoaderRoute: typeof EventsRsvpRouteRouteImport;
      parentRoute: typeof EventsRouteRoute;
    };
    '/_layoutAuth/logout/': {
      id: '/_layoutAuth/logout/';
      path: '/logout';
      fullPath: '/logout/';
      preLoaderRoute: typeof LayoutAuthLogoutIndexRouteRouteImport;
      parentRoute: typeof LayoutAuthRouteRoute;
    };
    '/_layoutAuth/maintenance/': {
      id: '/_layoutAuth/maintenance/';
      path: '/maintenance';
      fullPath: '/maintenance/';
      preLoaderRoute: typeof LayoutAuthMaintenanceIndexRouteRouteImport;
      parentRoute: typeof LayoutAuthRouteRoute;
    };
    '/_private/_auth/set-password': {
      id: '/_private/_auth/set-password';
      path: '/set-password';
      fullPath: '/set-password';
      preLoaderRoute: typeof PrivateAuthSetPasswordRouteRouteImport;
      parentRoute: typeof PrivateAuthLazyRoute;
    };
    '/_private/_route/$': {
      id: '/_private/_route/$';
      path: '/$';
      fullPath: '/$';
      preLoaderRoute: typeof PrivateRouteSplatRouteRouteImport;
      parentRoute: typeof PrivateRouteRouteRoute;
    };
    '/_private/_route/_internal': {
      id: '/_private/_route/_internal';
      path: '';
      fullPath: '/';
      preLoaderRoute: typeof PrivateRouteInternalRouteRouteImport;
      parentRoute: typeof PrivateRouteRouteRoute;
    };
    '/_private/_route/profile': {
      id: '/_private/_route/profile';
      path: '/profile';
      fullPath: '/profile';
      preLoaderRoute: typeof PrivateRouteProfileRouteRouteImport;
      parentRoute: typeof PrivateRouteRouteRoute;
    };
    '/_private/teams/': {
      id: '/_private/teams/';
      path: '/teams';
      fullPath: '/teams/';
      preLoaderRoute: typeof PrivateTeamsIndexRouteRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    '/_layoutAuth/_guest/email-response/': {
      id: '/_layoutAuth/_guest/email-response/';
      path: '/email-response';
      fullPath: '/email-response/';
      preLoaderRoute: typeof LayoutAuthGuestEmailResponseIndexRouteRouteImport;
      parentRoute: typeof LayoutAuthGuestRouteRoute;
    };
    '/_layoutAuth/_guest/join/': {
      id: '/_layoutAuth/_guest/join/';
      path: '/join';
      fullPath: '/join/';
      preLoaderRoute: typeof LayoutAuthGuestJoinIndexRouteRouteImport;
      parentRoute: typeof LayoutAuthGuestRouteRoute;
    };
    '/_layoutAuth/_guest/login/': {
      id: '/_layoutAuth/_guest/login/';
      path: '/login';
      fullPath: '/login/';
      preLoaderRoute: typeof LayoutAuthGuestLoginIndexRouteRouteImport;
      parentRoute: typeof LayoutAuthGuestRouteRoute;
    };
    '/_private/_auth/signup/': {
      id: '/_private/_auth/signup/';
      path: '/signup';
      fullPath: '/signup/';
      preLoaderRoute: typeof PrivateAuthSignupIndexRouteRouteImport;
      parentRoute: typeof PrivateAuthLazyRoute;
    };
    '/_private/_route/_internal/admin': {
      id: '/_private/_route/_internal/admin';
      path: '/admin';
      fullPath: '/admin';
      preLoaderRoute: typeof PrivateRouteInternalAdminRouteRouteImport;
      parentRoute: typeof PrivateRouteInternalRouteRoute;
    };
    '/_private/_route/_internal/events': {
      id: '/_private/_route/_internal/events';
      path: '/events';
      fullPath: '/events';
      preLoaderRoute: typeof PrivateRouteInternalEventsRouteRouteImport;
      parentRoute: typeof PrivateRouteInternalRouteRoute;
    };
    '/_private/_route/_internal/pipelines': {
      id: '/_private/_route/_internal/pipelines';
      path: '/pipelines';
      fullPath: '/pipelines';
      preLoaderRoute: typeof PrivateRouteInternalPipelinesRouteRouteImport;
      parentRoute: typeof PrivateRouteInternalRouteRoute;
    };
    '/_private/_route/_internal/tasks': {
      id: '/_private/_route/_internal/tasks';
      path: '/tasks';
      fullPath: '/tasks';
      preLoaderRoute: typeof PrivateRouteInternalTasksRouteRouteImport;
      parentRoute: typeof PrivateRouteInternalRouteRoute;
    };
    '/_private/_route/_internal/trending': {
      id: '/_private/_route/_internal/trending';
      path: '/trending';
      fullPath: '/trending';
      preLoaderRoute: typeof PrivateRouteInternalTrendingRouteRouteImport;
      parentRoute: typeof PrivateRouteInternalRouteRoute;
    };
    '/_private/_route/profile/': {
      id: '/_private/_route/profile/';
      path: '';
      fullPath: '/profile/';
      preLoaderRoute: typeof PrivateRouteProfileIndexRouteRouteImport;
      parentRoute: typeof PrivateRouteProfileRouteRoute;
    };
    '/_private/_route/teams/$teamId': {
      id: '/_private/_route/teams/$teamId';
      path: '/teams/$teamId';
      fullPath: '/teams/$teamId';
      preLoaderRoute: typeof PrivateRouteTeamsTeamIdRouteRouteImport;
      parentRoute: typeof PrivateRouteRouteRoute;
    };
    '/_private/_route/users/': {
      id: '/_private/_route/users/';
      path: '/users';
      fullPath: '/users/';
      preLoaderRoute: typeof PrivateRouteUsersIndexRouteRouteImport;
      parentRoute: typeof PrivateRouteRouteRoute;
    };
    '/_private/_route/users/$userId': {
      id: '/_private/_route/users/$userId';
      path: '/users/$userId';
      fullPath: '/users/$userId';
      preLoaderRoute: typeof PrivateRouteUsersUserIdRouteRouteImport;
      parentRoute: typeof PrivateRouteRouteRoute;
    };
    '/_private/teams/$teamId/': {
      id: '/_private/teams/$teamId/';
      path: '/teams/$teamId';
      fullPath: '/teams/$teamId/';
      preLoaderRoute: typeof PrivateTeamsTeamIdIndexRouteRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    '/_private/_route/_internal/candidates/$candidateId': {
      id: '/_private/_route/_internal/candidates/$candidateId';
      path: '/candidates/$candidateId';
      fullPath: '/candidates/$candidateId';
      preLoaderRoute: typeof PrivateRouteInternalCandidatesCandidateIdRouteRouteImport;
      parentRoute: typeof PrivateRouteInternalRouteRoute;
    };
    '/_private/_route/_internal/companies/': {
      id: '/_private/_route/_internal/companies/';
      path: '/companies';
      fullPath: '/companies/';
      preLoaderRoute: typeof PrivateRouteInternalCompaniesIndexRouteRouteImport;
      parentRoute: typeof PrivateRouteInternalRouteRoute;
    };
    '/_private/_route/_internal/events/': {
      id: '/_private/_route/_internal/events/';
      path: '';
      fullPath: '/events/';
      preLoaderRoute: typeof PrivateRouteInternalEventsIndexRouteRouteImport;
      parentRoute: typeof PrivateRouteInternalEventsRouteRoute;
    };
    '/_private/_route/_internal/events/$eventId': {
      id: '/_private/_route/_internal/events/$eventId';
      path: '/$eventId';
      fullPath: '/events/$eventId';
      preLoaderRoute: typeof PrivateRouteInternalEventsEventIdRouteRouteImport;
      parentRoute: typeof PrivateRouteInternalEventsRouteRoute;
    };
    '/_private/_route/_internal/experiments/': {
      id: '/_private/_route/_internal/experiments/';
      path: '/experiments';
      fullPath: '/experiments/';
      preLoaderRoute: typeof PrivateRouteInternalExperimentsIndexRouteRouteImport;
      parentRoute: typeof PrivateRouteInternalRouteRoute;
    };
    '/_private/_route/_internal/home/': {
      id: '/_private/_route/_internal/home/';
      path: '/home';
      fullPath: '/home/';
      preLoaderRoute: typeof PrivateRouteInternalHomeIndexRouteRouteImport;
      parentRoute: typeof PrivateRouteInternalRouteRoute;
    };
    '/_private/_route/_internal/introductions/': {
      id: '/_private/_route/_internal/introductions/';
      path: '/introductions';
      fullPath: '/introductions/';
      preLoaderRoute: typeof PrivateRouteInternalIntroductionsIndexRouteRouteImport;
      parentRoute: typeof PrivateRouteInternalRouteRoute;
    };
    '/_private/_route/_internal/peers/': {
      id: '/_private/_route/_internal/peers/';
      path: '/peers';
      fullPath: '/peers/';
      preLoaderRoute: typeof PrivateRouteInternalPeersIndexRouteRouteImport;
      parentRoute: typeof PrivateRouteInternalRouteRoute;
    };
    '/_private/_route/_internal/people/': {
      id: '/_private/_route/_internal/people/';
      path: '/people';
      fullPath: '/people/';
      preLoaderRoute: typeof PrivateRouteInternalPeopleIndexRouteRouteImport;
      parentRoute: typeof PrivateRouteInternalRouteRoute;
    };
    '/_private/_route/_internal/people/$identityId': {
      id: '/_private/_route/_internal/people/$identityId';
      path: '/people/$identityId';
      fullPath: '/people/$identityId';
      preLoaderRoute: typeof PrivateRouteInternalPeopleIdentityIdRouteRouteImport;
      parentRoute: typeof PrivateRouteInternalRouteRoute;
    };
    '/_private/_route/_internal/performance/': {
      id: '/_private/_route/_internal/performance/';
      path: '/performance';
      fullPath: '/performance/';
      preLoaderRoute: typeof PrivateRouteInternalPerformanceIndexRouteRouteImport;
      parentRoute: typeof PrivateRouteInternalRouteRoute;
    };
    '/_private/_route/_internal/pipeline-submissions/': {
      id: '/_private/_route/_internal/pipeline-submissions/';
      path: '/pipeline-submissions';
      fullPath: '/pipeline-submissions/';
      preLoaderRoute: typeof PrivateRouteInternalPipelineSubmissionsIndexRouteRouteImport;
      parentRoute: typeof PrivateRouteInternalRouteRoute;
    };
    '/_private/_route/_internal/pipelines/': {
      id: '/_private/_route/_internal/pipelines/';
      path: '';
      fullPath: '/pipelines/';
      preLoaderRoute: typeof PrivateRouteInternalPipelinesIndexRouteRouteImport;
      parentRoute: typeof PrivateRouteInternalPipelinesRouteRoute;
    };
    '/_private/_route/_internal/pipelines_/new': {
      id: '/_private/_route/_internal/pipelines_/new';
      path: '/pipelines/new';
      fullPath: '/pipelines/new';
      preLoaderRoute: typeof PrivateRouteInternalPipelinesNewRouteRouteImport;
      parentRoute: typeof PrivateRouteInternalRouteRoute;
    };
    '/_private/_route/_internal/search-submissions/': {
      id: '/_private/_route/_internal/search-submissions/';
      path: '/search-submissions';
      fullPath: '/search-submissions/';
      preLoaderRoute: typeof PrivateRouteInternalSearchSubmissionsIndexRouteRouteImport;
      parentRoute: typeof PrivateRouteInternalRouteRoute;
    };
    '/_private/_route/_internal/searches/': {
      id: '/_private/_route/_internal/searches/';
      path: '/searches';
      fullPath: '/searches/';
      preLoaderRoute: typeof PrivateRouteInternalSearchesIndexRouteRouteImport;
      parentRoute: typeof PrivateRouteInternalRouteRoute;
    };
    '/_private/_route/_internal/tasks/': {
      id: '/_private/_route/_internal/tasks/';
      path: '';
      fullPath: '/tasks/';
      preLoaderRoute: typeof PrivateRouteInternalTasksIndexRouteRouteImport;
      parentRoute: typeof PrivateRouteInternalTasksRouteRoute;
    };
    '/_private/_route/_internal/tools/': {
      id: '/_private/_route/_internal/tools/';
      path: '/tools';
      fullPath: '/tools/';
      preLoaderRoute: typeof PrivateRouteInternalToolsIndexRouteRouteImport;
      parentRoute: typeof PrivateRouteInternalRouteRoute;
    };
    '/_private/_route/_internal/trending/': {
      id: '/_private/_route/_internal/trending/';
      path: '';
      fullPath: '/trending/';
      preLoaderRoute: typeof PrivateRouteInternalTrendingIndexRouteRouteImport;
      parentRoute: typeof PrivateRouteInternalTrendingRouteRoute;
    };
    '/_private/_route/profile/teams/': {
      id: '/_private/_route/profile/teams/';
      path: '/teams';
      fullPath: '/profile/teams/';
      preLoaderRoute: typeof PrivateRouteProfileTeamsIndexRouteRouteImport;
      parentRoute: typeof PrivateRouteProfileRouteRoute;
    };
    '/_private/_route/teams/$teamId/candidates': {
      id: '/_private/_route/teams/$teamId/candidates';
      path: '/candidates';
      fullPath: '/teams/$teamId/candidates';
      preLoaderRoute: typeof PrivateRouteTeamsTeamIdCandidatesRouteRouteImport;
      parentRoute: typeof PrivateRouteTeamsTeamIdRouteRoute;
    };
    '/_private/_route/teams/$teamId/network': {
      id: '/_private/_route/teams/$teamId/network';
      path: '/network';
      fullPath: '/teams/$teamId/network';
      preLoaderRoute: typeof PrivateRouteTeamsTeamIdNetworkRouteRouteImport;
      parentRoute: typeof PrivateRouteTeamsTeamIdRouteRoute;
    };
    '/_private/_route/teams/$teamId/trending': {
      id: '/_private/_route/teams/$teamId/trending';
      path: '/trending';
      fullPath: '/teams/$teamId/trending';
      preLoaderRoute: typeof PrivateRouteTeamsTeamIdTrendingLazyRouteImport;
      parentRoute: typeof PrivateRouteTeamsTeamIdRouteRoute;
    };
    '/_private/_route/users/$userId/': {
      id: '/_private/_route/users/$userId/';
      path: '';
      fullPath: '/users/$userId/';
      preLoaderRoute: typeof PrivateRouteUsersUserIdIndexRouteRouteImport;
      parentRoute: typeof PrivateRouteUsersUserIdRouteRoute;
    };
    '/_private/_route/users/$userId/people': {
      id: '/_private/_route/users/$userId/people';
      path: '/people';
      fullPath: '/users/$userId/people';
      preLoaderRoute: typeof PrivateRouteUsersUserIdPeopleRouteRouteImport;
      parentRoute: typeof PrivateRouteUsersUserIdRouteRoute;
    };
    '/_private/_route/users/$userId/trending': {
      id: '/_private/_route/users/$userId/trending';
      path: '/trending';
      fullPath: '/users/$userId/trending';
      preLoaderRoute: typeof PrivateRouteUsersUserIdTrendingRouteRouteImport;
      parentRoute: typeof PrivateRouteUsersUserIdRouteRoute;
    };
    '/_private/_route/users/new/': {
      id: '/_private/_route/users/new/';
      path: '/users/new';
      fullPath: '/users/new/';
      preLoaderRoute: typeof PrivateRouteUsersNewIndexRouteRouteImport;
      parentRoute: typeof PrivateRouteRouteRoute;
    };
    '/_private/_route/_internal/admin/users/': {
      id: '/_private/_route/_internal/admin/users/';
      path: '/users';
      fullPath: '/admin/users/';
      preLoaderRoute: typeof PrivateRouteInternalAdminUsersIndexRouteRouteImport;
      parentRoute: typeof PrivateRouteInternalAdminRouteRoute;
    };
    '/_private/_route/_internal/admin/users/$userId': {
      id: '/_private/_route/_internal/admin/users/$userId';
      path: '/users/$userId';
      fullPath: '/admin/users/$userId';
      preLoaderRoute: typeof PrivateRouteInternalAdminUsersUserIdRouteRouteImport;
      parentRoute: typeof PrivateRouteInternalAdminRouteRoute;
    };
    '/_private/_route/_internal/candidates/$candidateId/': {
      id: '/_private/_route/_internal/candidates/$candidateId/';
      path: '';
      fullPath: '/candidates/$candidateId/';
      preLoaderRoute: typeof PrivateRouteInternalCandidatesCandidateIdIndexRouteRouteImport;
      parentRoute: typeof PrivateRouteInternalCandidatesCandidateIdRouteRoute;
    };
    '/_private/_route/_internal/candidates/$candidateId/tasks': {
      id: '/_private/_route/_internal/candidates/$candidateId/tasks';
      path: '/tasks';
      fullPath: '/candidates/$candidateId/tasks';
      preLoaderRoute: typeof PrivateRouteInternalCandidatesCandidateIdTasksRouteRouteImport;
      parentRoute: typeof PrivateRouteInternalCandidatesCandidateIdRouteRoute;
    };
    '/_private/_route/_internal/candidates/new/': {
      id: '/_private/_route/_internal/candidates/new/';
      path: '/candidates/new';
      fullPath: '/candidates/new/';
      preLoaderRoute: typeof PrivateRouteInternalCandidatesNewIndexRouteRouteImport;
      parentRoute: typeof PrivateRouteInternalRouteRoute;
    };
    '/_private/_route/_internal/events/$eventId/': {
      id: '/_private/_route/_internal/events/$eventId/';
      path: '';
      fullPath: '/events/$eventId/';
      preLoaderRoute: typeof PrivateRouteInternalEventsEventIdIndexRouteRouteImport;
      parentRoute: typeof PrivateRouteInternalEventsEventIdRouteRoute;
    };
    '/_private/_route/_internal/events/$eventId/participants': {
      id: '/_private/_route/_internal/events/$eventId/participants';
      path: '/participants';
      fullPath: '/events/$eventId/participants';
      preLoaderRoute: typeof PrivateRouteInternalEventsEventIdParticipantsRouteRouteImport;
      parentRoute: typeof PrivateRouteInternalEventsEventIdRouteRoute;
    };
    '/_private/_route/_internal/events/events/': {
      id: '/_private/_route/_internal/events/events/';
      path: '/events';
      fullPath: '/events/events/';
      preLoaderRoute: typeof PrivateRouteInternalEventsEventsIndexRouteRouteImport;
      parentRoute: typeof PrivateRouteInternalEventsRouteRoute;
    };
    '/_private/_route/_internal/events/new/': {
      id: '/_private/_route/_internal/events/new/';
      path: '/new';
      fullPath: '/events/new/';
      preLoaderRoute: typeof PrivateRouteInternalEventsNewIndexRouteRouteImport;
      parentRoute: typeof PrivateRouteInternalEventsRouteRoute;
    };
    '/_private/_route/_internal/events/participants/': {
      id: '/_private/_route/_internal/events/participants/';
      path: '/participants';
      fullPath: '/events/participants/';
      preLoaderRoute: typeof PrivateRouteInternalEventsParticipantsIndexRouteRouteImport;
      parentRoute: typeof PrivateRouteInternalEventsRouteRoute;
    };
    '/_private/_route/_internal/events/participants/$participantId': {
      id: '/_private/_route/_internal/events/participants/$participantId';
      path: '/participants/$participantId';
      fullPath: '/events/participants/$participantId';
      preLoaderRoute: typeof PrivateRouteInternalEventsParticipantsParticipantIdRouteRouteImport;
      parentRoute: typeof PrivateRouteInternalEventsRouteRoute;
    };
    '/_private/_route/_internal/events/settings/': {
      id: '/_private/_route/_internal/events/settings/';
      path: '/settings';
      fullPath: '/events/settings/';
      preLoaderRoute: typeof PrivateRouteInternalEventsSettingsIndexRouteRouteImport;
      parentRoute: typeof PrivateRouteInternalEventsRouteRoute;
    };
    '/_private/_route/_internal/introduction-submissions/$submissionId/': {
      id: '/_private/_route/_internal/introduction-submissions/$submissionId/';
      path: '/introduction-submissions/$submissionId';
      fullPath: '/introduction-submissions/$submissionId/';
      preLoaderRoute: typeof PrivateRouteInternalIntroductionSubmissionsSubmissionIdIndexRouteRouteImport;
      parentRoute: typeof PrivateRouteInternalRouteRoute;
    };
    '/_private/_route/_internal/peers/new/': {
      id: '/_private/_route/_internal/peers/new/';
      path: '/peers/new';
      fullPath: '/peers/new/';
      preLoaderRoute: typeof PrivateRouteInternalPeersNewIndexRouteRouteImport;
      parentRoute: typeof PrivateRouteInternalRouteRoute;
    };
    '/_private/_route/_internal/people/$identityId/': {
      id: '/_private/_route/_internal/people/$identityId/';
      path: '';
      fullPath: '/people/$identityId/';
      preLoaderRoute: typeof PrivateRouteInternalPeopleIdentityIdIndexRouteRouteImport;
      parentRoute: typeof PrivateRouteInternalPeopleIdentityIdRouteRoute;
    };
    '/_private/_route/_internal/people/$identityId/_candidate': {
      id: '/_private/_route/_internal/people/$identityId/_candidate';
      path: '';
      fullPath: '/people/$identityId';
      preLoaderRoute: typeof PrivateRouteInternalPeopleIdentityIdCandidateRouteRouteImport;
      parentRoute: typeof PrivateRouteInternalPeopleIdentityIdRouteRoute;
    };
    '/_private/_route/_internal/pipeline-submissions/$submissionId/': {
      id: '/_private/_route/_internal/pipeline-submissions/$submissionId/';
      path: '/pipeline-submissions/$submissionId';
      fullPath: '/pipeline-submissions/$submissionId/';
      preLoaderRoute: typeof PrivateRouteInternalPipelineSubmissionsSubmissionIdIndexRouteRouteImport;
      parentRoute: typeof PrivateRouteInternalRouteRoute;
    };
    '/_private/_route/_internal/tasks/executive-services/': {
      id: '/_private/_route/_internal/tasks/executive-services/';
      path: '/executive-services';
      fullPath: '/tasks/executive-services/';
      preLoaderRoute: typeof PrivateRouteInternalTasksExecutiveServicesIndexRouteRouteImport;
      parentRoute: typeof PrivateRouteInternalTasksRouteRoute;
    };
    '/_private/_route/_internal/tasks/me/': {
      id: '/_private/_route/_internal/tasks/me/';
      path: '/me';
      fullPath: '/tasks/me/';
      preLoaderRoute: typeof PrivateRouteInternalTasksMeIndexRouteRouteImport;
      parentRoute: typeof PrivateRouteInternalTasksRouteRoute;
    };
    '/_private/_route/_internal/tools/ai-candidate-discovery/': {
      id: '/_private/_route/_internal/tools/ai-candidate-discovery/';
      path: '/tools/ai-candidate-discovery';
      fullPath: '/tools/ai-candidate-discovery/';
      preLoaderRoute: typeof PrivateRouteInternalToolsAiCandidateDiscoveryIndexRouteRouteImport;
      parentRoute: typeof PrivateRouteInternalRouteRoute;
    };
    '/_private/_route/_internal/tools/email-templates/': {
      id: '/_private/_route/_internal/tools/email-templates/';
      path: '/tools/email-templates';
      fullPath: '/tools/email-templates/';
      preLoaderRoute: typeof PrivateRouteInternalToolsEmailTemplatesIndexRouteRouteImport;
      parentRoute: typeof PrivateRouteInternalRouteRoute;
    };
    '/_private/_route/_internal/tools/market-searches/': {
      id: '/_private/_route/_internal/tools/market-searches/';
      path: '/tools/market-searches';
      fullPath: '/tools/market-searches/';
      preLoaderRoute: typeof PrivateRouteInternalToolsMarketSearchesIndexRouteRouteImport;
      parentRoute: typeof PrivateRouteInternalRouteRoute;
    };
    '/_private/_route/_internal/tools/merge-people/': {
      id: '/_private/_route/_internal/tools/merge-people/';
      path: '/tools/merge-people';
      fullPath: '/tools/merge-people/';
      preLoaderRoute: typeof PrivateRouteInternalToolsMergePeopleIndexRouteRouteImport;
      parentRoute: typeof PrivateRouteInternalRouteRoute;
    };
    '/_private/_route/_internal/tools/move-team/': {
      id: '/_private/_route/_internal/tools/move-team/';
      path: '/tools/move-team';
      fullPath: '/tools/move-team/';
      preLoaderRoute: typeof PrivateRouteInternalToolsMoveTeamIndexRouteRouteImport;
      parentRoute: typeof PrivateRouteInternalRouteRoute;
    };
    '/_private/_route/_internal/tools/pathway-activity-defaults/': {
      id: '/_private/_route/_internal/tools/pathway-activity-defaults/';
      path: '/tools/pathway-activity-defaults';
      fullPath: '/tools/pathway-activity-defaults/';
      preLoaderRoute: typeof PrivateRouteInternalToolsPathwayActivityDefaultsIndexRouteRouteImport;
      parentRoute: typeof PrivateRouteInternalRouteRoute;
    };
    '/_private/_route/_internal/trending/$submissionId/': {
      id: '/_private/_route/_internal/trending/$submissionId/';
      path: '/$submissionId';
      fullPath: '/trending/$submissionId/';
      preLoaderRoute: typeof PrivateRouteInternalTrendingSubmissionIdIndexRouteRouteImport;
      parentRoute: typeof PrivateRouteInternalTrendingRouteRoute;
    };
    '/_private/_route/_internal/trending/campaigns/': {
      id: '/_private/_route/_internal/trending/campaigns/';
      path: '/campaigns';
      fullPath: '/trending/campaigns/';
      preLoaderRoute: typeof PrivateRouteInternalTrendingCampaignsIndexRouteRouteImport;
      parentRoute: typeof PrivateRouteInternalTrendingRouteRoute;
    };
    '/_private/_route/_internal/trending/new/': {
      id: '/_private/_route/_internal/trending/new/';
      path: '/new';
      fullPath: '/trending/new/';
      preLoaderRoute: typeof PrivateRouteInternalTrendingNewIndexRouteRouteImport;
      parentRoute: typeof PrivateRouteInternalTrendingRouteRoute;
    };
    '/_private/_route/_internal/trending/people/': {
      id: '/_private/_route/_internal/trending/people/';
      path: '/people';
      fullPath: '/trending/people/';
      preLoaderRoute: typeof PrivateRouteInternalTrendingPeopleIndexRouteRouteImport;
      parentRoute: typeof PrivateRouteInternalTrendingRouteRoute;
    };
    '/_private/_route/teams/$teamId/candidates/$candidateId': {
      id: '/_private/_route/teams/$teamId/candidates/$candidateId';
      path: '/$candidateId';
      fullPath: '/teams/$teamId/candidates/$candidateId';
      preLoaderRoute: typeof PrivateRouteTeamsTeamIdCandidatesCandidateIdRouteRouteImport;
      parentRoute: typeof PrivateRouteTeamsTeamIdCandidatesRouteRoute;
    };
    '/_private/_route/teams/$teamId/home/': {
      id: '/_private/_route/teams/$teamId/home/';
      path: '/home';
      fullPath: '/teams/$teamId/home/';
      preLoaderRoute: typeof PrivateRouteTeamsTeamIdHomeIndexRouteRouteImport;
      parentRoute: typeof PrivateRouteTeamsTeamIdRouteRoute;
    };
    '/_private/_route/teams/$teamId/introductions/': {
      id: '/_private/_route/teams/$teamId/introductions/';
      path: '/introductions';
      fullPath: '/teams/$teamId/introductions/';
      preLoaderRoute: typeof PrivateRouteTeamsTeamIdIntroductionsIndexRouteRouteImport;
      parentRoute: typeof PrivateRouteTeamsTeamIdRouteRoute;
    };
    '/_private/_route/teams/$teamId/pipelines/': {
      id: '/_private/_route/teams/$teamId/pipelines/';
      path: '/pipelines';
      fullPath: '/teams/$teamId/pipelines/';
      preLoaderRoute: typeof PrivateRouteTeamsTeamIdPipelinesIndexRouteRouteImport;
      parentRoute: typeof PrivateRouteTeamsTeamIdRouteRoute;
    };
    '/_private/_route/teams/$teamId/pipelines/$pipelineId': {
      id: '/_private/_route/teams/$teamId/pipelines/$pipelineId';
      path: '/pipelines/$pipelineId';
      fullPath: '/teams/$teamId/pipelines/$pipelineId';
      preLoaderRoute: typeof PrivateRouteTeamsTeamIdPipelinesPipelineIdLazyRouteImport;
      parentRoute: typeof PrivateRouteTeamsTeamIdRouteRoute;
    };
    '/_private/_route/teams/$teamId/pipelines/new': {
      id: '/_private/_route/teams/$teamId/pipelines/new';
      path: '/pipelines/new';
      fullPath: '/teams/$teamId/pipelines/new';
      preLoaderRoute: typeof PrivateRouteTeamsTeamIdPipelinesNewRouteRouteImport;
      parentRoute: typeof PrivateRouteTeamsTeamIdRouteRoute;
    };
    '/_private/_route/teams/$teamId/searches/': {
      id: '/_private/_route/teams/$teamId/searches/';
      path: '/searches';
      fullPath: '/teams/$teamId/searches/';
      preLoaderRoute: typeof PrivateRouteTeamsTeamIdSearchesIndexRouteRouteImport;
      parentRoute: typeof PrivateRouteTeamsTeamIdRouteRoute;
    };
    '/_private/_route/teams/$teamId/settings/': {
      id: '/_private/_route/teams/$teamId/settings/';
      path: '/settings';
      fullPath: '/teams/$teamId/settings/';
      preLoaderRoute: typeof PrivateRouteTeamsTeamIdSettingsIndexRouteRouteImport;
      parentRoute: typeof PrivateRouteTeamsTeamIdRouteRoute;
    };
    '/_private/_route/teams/$teamId/trending/': {
      id: '/_private/_route/teams/$teamId/trending/';
      path: '/';
      fullPath: '/teams/$teamId/trending/';
      preLoaderRoute: typeof PrivateRouteTeamsTeamIdTrendingIndexRouteImport;
      parentRoute: typeof PrivateRouteTeamsTeamIdTrendingLazyRoute;
    };
    '/_private/_route/users/$userId/events/': {
      id: '/_private/_route/users/$userId/events/';
      path: '/events';
      fullPath: '/users/$userId/events/';
      preLoaderRoute: typeof PrivateRouteUsersUserIdEventsIndexRouteRouteImport;
      parentRoute: typeof PrivateRouteUsersUserIdRouteRoute;
    };
    '/_private/_route/users/$userId/people/$candidateId': {
      id: '/_private/_route/users/$userId/people/$candidateId';
      path: '/$candidateId';
      fullPath: '/users/$userId/people/$candidateId';
      preLoaderRoute: typeof PrivateRouteUsersUserIdPeopleCandidateIdRouteRouteImport;
      parentRoute: typeof PrivateRouteUsersUserIdPeopleRouteRoute;
    };
    '/_private/_route/users/$userId/pipelines/': {
      id: '/_private/_route/users/$userId/pipelines/';
      path: '/pipelines';
      fullPath: '/users/$userId/pipelines/';
      preLoaderRoute: typeof PrivateRouteUsersUserIdPipelinesIndexRouteRouteImport;
      parentRoute: typeof PrivateRouteUsersUserIdRouteRoute;
    };
    '/_private/_route/users/$userId/pipelines/new': {
      id: '/_private/_route/users/$userId/pipelines/new';
      path: '/pipelines/new';
      fullPath: '/users/$userId/pipelines/new';
      preLoaderRoute: typeof PrivateRouteUsersUserIdPipelinesNewRouteRouteImport;
      parentRoute: typeof PrivateRouteUsersUserIdRouteRoute;
    };
    '/_private/_route/users/$userId/settings/': {
      id: '/_private/_route/users/$userId/settings/';
      path: '/settings';
      fullPath: '/users/$userId/settings/';
      preLoaderRoute: typeof PrivateRouteUsersUserIdSettingsIndexRouteRouteImport;
      parentRoute: typeof PrivateRouteUsersUserIdRouteRoute;
    };
    '/_private/_route/users/$userId/trending/': {
      id: '/_private/_route/users/$userId/trending/';
      path: '/';
      fullPath: '/users/$userId/trending/';
      preLoaderRoute: typeof PrivateRouteUsersUserIdTrendingIndexRouteImport;
      parentRoute: typeof PrivateRouteUsersUserIdTrendingRouteRoute;
    };
    '/_private/_route/_internal/admin/users/new/': {
      id: '/_private/_route/_internal/admin/users/new/';
      path: '/users/new';
      fullPath: '/admin/users/new/';
      preLoaderRoute: typeof PrivateRouteInternalAdminUsersNewIndexRouteRouteImport;
      parentRoute: typeof PrivateRouteInternalAdminRouteRoute;
    };
    '/_private/_route/_internal/candidates/$candidateId/about/': {
      id: '/_private/_route/_internal/candidates/$candidateId/about/';
      path: '/about';
      fullPath: '/candidates/$candidateId/about/';
      preLoaderRoute: typeof PrivateRouteInternalCandidatesCandidateIdAboutIndexRouteRouteImport;
      parentRoute: typeof PrivateRouteInternalCandidatesCandidateIdRouteRoute;
    };
    '/_private/_route/_internal/candidates/$candidateId/accounts/': {
      id: '/_private/_route/_internal/candidates/$candidateId/accounts/';
      path: '/accounts';
      fullPath: '/candidates/$candidateId/accounts/';
      preLoaderRoute: typeof PrivateRouteInternalCandidatesCandidateIdAccountsIndexRouteRouteImport;
      parentRoute: typeof PrivateRouteInternalCandidatesCandidateIdRouteRoute;
    };
    '/_private/_route/_internal/candidates/$candidateId/compare/': {
      id: '/_private/_route/_internal/candidates/$candidateId/compare/';
      path: '/compare';
      fullPath: '/candidates/$candidateId/compare/';
      preLoaderRoute: typeof PrivateRouteInternalCandidatesCandidateIdCompareIndexRouteRouteImport;
      parentRoute: typeof PrivateRouteInternalCandidatesCandidateIdRouteRoute;
    };
    '/_private/_route/_internal/candidates/$candidateId/feedback/': {
      id: '/_private/_route/_internal/candidates/$candidateId/feedback/';
      path: '/feedback';
      fullPath: '/candidates/$candidateId/feedback/';
      preLoaderRoute: typeof PrivateRouteInternalCandidatesCandidateIdFeedbackIndexRouteRouteImport;
      parentRoute: typeof PrivateRouteInternalCandidatesCandidateIdRouteRoute;
    };
    '/_private/_route/_internal/candidates/$candidateId/performance/': {
      id: '/_private/_route/_internal/candidates/$candidateId/performance/';
      path: '/performance';
      fullPath: '/candidates/$candidateId/performance/';
      preLoaderRoute: typeof PrivateRouteInternalCandidatesCandidateIdPerformanceIndexRouteRouteImport;
      parentRoute: typeof PrivateRouteInternalCandidatesCandidateIdRouteRoute;
    };
    '/_private/_route/_internal/candidates/$candidateId/profile/': {
      id: '/_private/_route/_internal/candidates/$candidateId/profile/';
      path: '/profile';
      fullPath: '/candidates/$candidateId/profile/';
      preLoaderRoute: typeof PrivateRouteInternalCandidatesCandidateIdProfileIndexRouteRouteImport;
      parentRoute: typeof PrivateRouteInternalCandidatesCandidateIdRouteRoute;
    };
    '/_private/_route/_internal/candidates/$candidateId/recommendations/': {
      id: '/_private/_route/_internal/candidates/$candidateId/recommendations/';
      path: '/recommendations';
      fullPath: '/candidates/$candidateId/recommendations/';
      preLoaderRoute: typeof PrivateRouteInternalCandidatesCandidateIdRecommendationsIndexRouteRouteImport;
      parentRoute: typeof PrivateRouteInternalCandidatesCandidateIdRouteRoute;
    };
    '/_private/_route/_internal/candidates/$candidateId/suggested-pipelines/': {
      id: '/_private/_route/_internal/candidates/$candidateId/suggested-pipelines/';
      path: '/suggested-pipelines';
      fullPath: '/candidates/$candidateId/suggested-pipelines/';
      preLoaderRoute: typeof PrivateRouteInternalCandidatesCandidateIdSuggestedPipelinesIndexRouteRouteImport;
      parentRoute: typeof PrivateRouteInternalCandidatesCandidateIdRouteRoute;
    };
    '/_private/_route/_internal/companies/$companyId/people/': {
      id: '/_private/_route/_internal/companies/$companyId/people/';
      path: '/companies/$companyId/people';
      fullPath: '/companies/$companyId/people/';
      preLoaderRoute: typeof PrivateRouteInternalCompaniesCompanyIdPeopleIndexRouteRouteImport;
      parentRoute: typeof PrivateRouteInternalRouteRoute;
    };
    '/_private/_route/_internal/companies/$companyId/settings/': {
      id: '/_private/_route/_internal/companies/$companyId/settings/';
      path: '/companies/$companyId/settings';
      fullPath: '/companies/$companyId/settings/';
      preLoaderRoute: typeof PrivateRouteInternalCompaniesCompanyIdSettingsIndexRouteRouteImport;
      parentRoute: typeof PrivateRouteInternalRouteRoute;
    };
    '/_private/_route/_internal/events/$eventId/details/': {
      id: '/_private/_route/_internal/events/$eventId/details/';
      path: '/details';
      fullPath: '/events/$eventId/details/';
      preLoaderRoute: typeof PrivateRouteInternalEventsEventIdDetailsIndexRouteRouteImport;
      parentRoute: typeof PrivateRouteInternalEventsEventIdRouteRoute;
    };
    '/_private/_route/_internal/events/$eventId/email-settings/': {
      id: '/_private/_route/_internal/events/$eventId/email-settings/';
      path: '/email-settings';
      fullPath: '/events/$eventId/email-settings/';
      preLoaderRoute: typeof PrivateRouteInternalEventsEventIdEmailSettingsIndexRouteRouteImport;
      parentRoute: typeof PrivateRouteInternalEventsEventIdRouteRoute;
    };
    '/_private/_route/_internal/events/$eventId/emails/': {
      id: '/_private/_route/_internal/events/$eventId/emails/';
      path: '/emails';
      fullPath: '/events/$eventId/emails/';
      preLoaderRoute: typeof PrivateRouteInternalEventsEventIdEmailsIndexRouteRouteImport;
      parentRoute: typeof PrivateRouteInternalEventsEventIdRouteRoute;
    };
    '/_private/_route/_internal/events/participants/$participantId/': {
      id: '/_private/_route/_internal/events/participants/$participantId/';
      path: '';
      fullPath: '/events/participants/$participantId/';
      preLoaderRoute: typeof PrivateRouteInternalEventsParticipantsParticipantIdIndexRouteRouteImport;
      parentRoute: typeof PrivateRouteInternalEventsParticipantsParticipantIdRouteRoute;
    };
    '/_private/_route/_internal/people/$identityId/_candidate/tasks': {
      id: '/_private/_route/_internal/people/$identityId/_candidate/tasks';
      path: '/tasks';
      fullPath: '/people/$identityId/tasks';
      preLoaderRoute: typeof PrivateRouteInternalPeopleIdentityIdCandidateTasksRouteRouteImport;
      parentRoute: typeof PrivateRouteInternalPeopleIdentityIdCandidateRouteRoute;
    };
    '/_private/_route/_internal/people/$identityId/accounts/': {
      id: '/_private/_route/_internal/people/$identityId/accounts/';
      path: '/accounts';
      fullPath: '/people/$identityId/accounts/';
      preLoaderRoute: typeof PrivateRouteInternalPeopleIdentityIdAccountsIndexRouteRouteImport;
      parentRoute: typeof PrivateRouteInternalPeopleIdentityIdRouteRoute;
    };
    '/_private/_route/_internal/people/$identityId/emails/': {
      id: '/_private/_route/_internal/people/$identityId/emails/';
      path: '/emails';
      fullPath: '/people/$identityId/emails/';
      preLoaderRoute: typeof PrivateRouteInternalPeopleIdentityIdEmailsIndexRouteRouteImport;
      parentRoute: typeof PrivateRouteInternalPeopleIdentityIdRouteRoute;
    };
    '/_private/_route/_internal/trending/$submissionId/edit/': {
      id: '/_private/_route/_internal/trending/$submissionId/edit/';
      path: '/$submissionId/edit';
      fullPath: '/trending/$submissionId/edit/';
      preLoaderRoute: typeof PrivateRouteInternalTrendingSubmissionIdEditIndexRouteRouteImport;
      parentRoute: typeof PrivateRouteInternalTrendingRouteRoute;
    };
    '/_private/_route/teams/$teamId/candidates/$candidateId/': {
      id: '/_private/_route/teams/$teamId/candidates/$candidateId/';
      path: '';
      fullPath: '/teams/$teamId/candidates/$candidateId/';
      preLoaderRoute: typeof PrivateRouteTeamsTeamIdCandidatesCandidateIdIndexRouteRouteImport;
      parentRoute: typeof PrivateRouteTeamsTeamIdCandidatesCandidateIdRouteRoute;
    };
    '/_private/_route/teams/$teamId/candidates/$candidateId/$tabId': {
      id: '/_private/_route/teams/$teamId/candidates/$candidateId/$tabId';
      path: '/$tabId';
      fullPath: '/teams/$teamId/candidates/$candidateId/$tabId';
      preLoaderRoute: typeof PrivateRouteTeamsTeamIdCandidatesCandidateIdTabIdRouteRouteImport;
      parentRoute: typeof PrivateRouteTeamsTeamIdCandidatesCandidateIdRouteRoute;
    };
    '/_private/_route/teams/$teamId/introductions/$candidateId/': {
      id: '/_private/_route/teams/$teamId/introductions/$candidateId/';
      path: '/introductions/$candidateId';
      fullPath: '/teams/$teamId/introductions/$candidateId/';
      preLoaderRoute: typeof PrivateRouteTeamsTeamIdIntroductionsCandidateIdIndexRouteRouteImport;
      parentRoute: typeof PrivateRouteTeamsTeamIdRouteRoute;
    };
    '/_private/_route/teams/$teamId/pipelines/$pipelineId/_internal': {
      id: '/_private/_route/teams/$teamId/pipelines/$pipelineId/_internal';
      path: '';
      fullPath: '/teams/$teamId/pipelines/$pipelineId';
      preLoaderRoute: typeof PrivateRouteTeamsTeamIdPipelinesPipelineIdInternalLazyRouteImport;
      parentRoute: typeof PrivateRouteTeamsTeamIdPipelinesPipelineIdLazyRoute;
    };
    '/_private/_route/teams/$teamId/pipelines_/$pipelineId/edit': {
      id: '/_private/_route/teams/$teamId/pipelines_/$pipelineId/edit';
      path: '/pipelines/$pipelineId/edit';
      fullPath: '/teams/$teamId/pipelines/$pipelineId/edit';
      preLoaderRoute: typeof PrivateRouteTeamsTeamIdPipelinesPipelineIdEditRouteRouteImport;
      parentRoute: typeof PrivateRouteTeamsTeamIdRouteRoute;
    };
    '/_private/_route/teams/$teamId/searches/$searchId/': {
      id: '/_private/_route/teams/$teamId/searches/$searchId/';
      path: '/searches/$searchId';
      fullPath: '/teams/$teamId/searches/$searchId/';
      preLoaderRoute: typeof PrivateRouteTeamsTeamIdSearchesSearchIdIndexRouteRouteImport;
      parentRoute: typeof PrivateRouteTeamsTeamIdRouteRoute;
    };
    '/_private/_route/teams/$teamId/trending/$recommendationId/': {
      id: '/_private/_route/teams/$teamId/trending/$recommendationId/';
      path: '/$recommendationId';
      fullPath: '/teams/$teamId/trending/$recommendationId/';
      preLoaderRoute: typeof PrivateRouteTeamsTeamIdTrendingRecommendationIdIndexRouteRouteImport;
      parentRoute: typeof PrivateRouteTeamsTeamIdTrendingLazyRoute;
    };
    '/_private/_route/users/$userId/events/$eventId/': {
      id: '/_private/_route/users/$userId/events/$eventId/';
      path: '/events/$eventId';
      fullPath: '/users/$userId/events/$eventId/';
      preLoaderRoute: typeof PrivateRouteUsersUserIdEventsEventIdIndexRouteRouteImport;
      parentRoute: typeof PrivateRouteUsersUserIdRouteRoute;
    };
    '/_private/_route/users/$userId/pipelines/$pipelineId/': {
      id: '/_private/_route/users/$userId/pipelines/$pipelineId/';
      path: '/pipelines/$pipelineId';
      fullPath: '/users/$userId/pipelines/$pipelineId/';
      preLoaderRoute: typeof PrivateRouteUsersUserIdPipelinesPipelineIdIndexRouteRouteImport;
      parentRoute: typeof PrivateRouteUsersUserIdRouteRoute;
    };
    '/_private/_route/users/$userId/pipelines/$pipelineId/edit': {
      id: '/_private/_route/users/$userId/pipelines/$pipelineId/edit';
      path: '/pipelines/$pipelineId/edit';
      fullPath: '/users/$userId/pipelines/$pipelineId/edit';
      preLoaderRoute: typeof PrivateRouteUsersUserIdPipelinesPipelineIdEditRouteRouteImport;
      parentRoute: typeof PrivateRouteUsersUserIdRouteRoute;
    };
    '/_private/_route/users/$userId/trending/$recommendationId/': {
      id: '/_private/_route/users/$userId/trending/$recommendationId/';
      path: '/$recommendationId';
      fullPath: '/users/$userId/trending/$recommendationId/';
      preLoaderRoute: typeof PrivateRouteUsersUserIdTrendingRecommendationIdIndexRouteRouteImport;
      parentRoute: typeof PrivateRouteUsersUserIdTrendingRouteRoute;
    };
    '/_private/_route/_internal/admin/users/$userId/settings/': {
      id: '/_private/_route/_internal/admin/users/$userId/settings/';
      path: '/settings';
      fullPath: '/admin/users/$userId/settings/';
      preLoaderRoute: typeof PrivateRouteInternalAdminUsersUserIdSettingsIndexRouteRouteImport;
      parentRoute: typeof PrivateRouteInternalAdminUsersUserIdRouteRoute;
    };
    '/_private/_route/_internal/events/$eventId/participants/new/': {
      id: '/_private/_route/_internal/events/$eventId/participants/new/';
      path: '/new';
      fullPath: '/events/$eventId/participants/new/';
      preLoaderRoute: typeof PrivateRouteInternalEventsEventIdParticipantsNewIndexRouteRouteImport;
      parentRoute: typeof PrivateRouteInternalEventsEventIdParticipantsRouteRoute;
    };
    '/_private/_route/_internal/people/$identityId/_candidate/about/': {
      id: '/_private/_route/_internal/people/$identityId/_candidate/about/';
      path: '/about';
      fullPath: '/people/$identityId/about/';
      preLoaderRoute: typeof PrivateRouteInternalPeopleIdentityIdCandidateAboutIndexRouteRouteImport;
      parentRoute: typeof PrivateRouteInternalPeopleIdentityIdCandidateRouteRoute;
    };
    '/_private/_route/_internal/people/$identityId/_candidate/compare/': {
      id: '/_private/_route/_internal/people/$identityId/_candidate/compare/';
      path: '/compare';
      fullPath: '/people/$identityId/compare/';
      preLoaderRoute: typeof PrivateRouteInternalPeopleIdentityIdCandidateCompareIndexRouteRouteImport;
      parentRoute: typeof PrivateRouteInternalPeopleIdentityIdCandidateRouteRoute;
    };
    '/_private/_route/_internal/people/$identityId/_candidate/feedback/': {
      id: '/_private/_route/_internal/people/$identityId/_candidate/feedback/';
      path: '/feedback';
      fullPath: '/people/$identityId/feedback/';
      preLoaderRoute: typeof PrivateRouteInternalPeopleIdentityIdCandidateFeedbackIndexRouteRouteImport;
      parentRoute: typeof PrivateRouteInternalPeopleIdentityIdCandidateRouteRoute;
    };
    '/_private/_route/_internal/people/$identityId/_candidate/performance/': {
      id: '/_private/_route/_internal/people/$identityId/_candidate/performance/';
      path: '/performance';
      fullPath: '/people/$identityId/performance/';
      preLoaderRoute: typeof PrivateRouteInternalPeopleIdentityIdCandidatePerformanceIndexRouteRouteImport;
      parentRoute: typeof PrivateRouteInternalPeopleIdentityIdCandidateRouteRoute;
    };
    '/_private/_route/_internal/people/$identityId/_candidate/profile/': {
      id: '/_private/_route/_internal/people/$identityId/_candidate/profile/';
      path: '/profile';
      fullPath: '/people/$identityId/profile/';
      preLoaderRoute: typeof PrivateRouteInternalPeopleIdentityIdCandidateProfileIndexRouteRouteImport;
      parentRoute: typeof PrivateRouteInternalPeopleIdentityIdCandidateRouteRoute;
    };
    '/_private/_route/_internal/people/$identityId/_candidate/recommendations/': {
      id: '/_private/_route/_internal/people/$identityId/_candidate/recommendations/';
      path: '/recommendations';
      fullPath: '/people/$identityId/recommendations/';
      preLoaderRoute: typeof PrivateRouteInternalPeopleIdentityIdCandidateRecommendationsIndexRouteRouteImport;
      parentRoute: typeof PrivateRouteInternalPeopleIdentityIdCandidateRouteRoute;
    };
    '/_private/_route/_internal/people/$identityId/_candidate/suggested-pipelines/': {
      id: '/_private/_route/_internal/people/$identityId/_candidate/suggested-pipelines/';
      path: '/suggested-pipelines';
      fullPath: '/people/$identityId/suggested-pipelines/';
      preLoaderRoute: typeof PrivateRouteInternalPeopleIdentityIdCandidateSuggestedPipelinesIndexRouteRouteImport;
      parentRoute: typeof PrivateRouteInternalPeopleIdentityIdCandidateRouteRoute;
    };
    '/_private/_route/_internal/people/$identityId/_candidate/tasks/': {
      id: '/_private/_route/_internal/people/$identityId/_candidate/tasks/';
      path: '/';
      fullPath: '/people/$identityId/tasks/';
      preLoaderRoute: typeof PrivateRouteInternalPeopleIdentityIdCandidateTasksIndexLazyRouteImport;
      parentRoute: typeof PrivateRouteInternalPeopleIdentityIdCandidateTasksRouteRoute;
    };
    '/_private/_route/teams/$teamId/candidates/$candidateId/activity/': {
      id: '/_private/_route/teams/$teamId/candidates/$candidateId/activity/';
      path: '/activity';
      fullPath: '/teams/$teamId/candidates/$candidateId/activity/';
      preLoaderRoute: typeof PrivateRouteTeamsTeamIdCandidatesCandidateIdActivityIndexRouteRouteImport;
      parentRoute: typeof PrivateRouteTeamsTeamIdCandidatesCandidateIdRouteRoute;
    };
    '/_private/_route/teams/$teamId/candidates/$candidateId/pipelines/': {
      id: '/_private/_route/teams/$teamId/candidates/$candidateId/pipelines/';
      path: '/pipelines';
      fullPath: '/teams/$teamId/candidates/$candidateId/pipelines/';
      preLoaderRoute: typeof PrivateRouteTeamsTeamIdCandidatesCandidateIdPipelinesIndexRouteRouteImport;
      parentRoute: typeof PrivateRouteTeamsTeamIdCandidatesCandidateIdRouteRoute;
    };
    '/_private/_route/teams/$teamId/pipelines/$pipelineId/_internal/': {
      id: '/_private/_route/teams/$teamId/pipelines/$pipelineId/_internal/';
      path: '';
      fullPath: '/teams/$teamId/pipelines/$pipelineId/';
      preLoaderRoute: typeof PrivateRouteTeamsTeamIdPipelinesPipelineIdInternalIndexRouteRouteImport;
      parentRoute: typeof PrivateRouteTeamsTeamIdPipelinesPipelineIdInternalLazyRoute;
    };
    '/_private/_route/teams/$teamId/pipelines/$pipelineId/_internal/recommendations': {
      id: '/_private/_route/teams/$teamId/pipelines/$pipelineId/_internal/recommendations';
      path: '/recommendations';
      fullPath: '/teams/$teamId/pipelines/$pipelineId/recommendations';
      preLoaderRoute: typeof PrivateRouteTeamsTeamIdPipelinesPipelineIdInternalRecommendationsRouteRouteImport;
      parentRoute: typeof PrivateRouteTeamsTeamIdPipelinesPipelineIdInternalLazyRoute;
    };
    '/_private/_route/teams/$teamId/pipelines/$pipelineId_/recommendations/new': {
      id: '/_private/_route/teams/$teamId/pipelines/$pipelineId_/recommendations/new';
      path: '/pipelines/$pipelineId/recommendations/new';
      fullPath: '/teams/$teamId/pipelines/$pipelineId/recommendations/new';
      preLoaderRoute: typeof PrivateRouteTeamsTeamIdPipelinesPipelineIdRecommendationsNewRouteRouteImport;
      parentRoute: typeof PrivateRouteTeamsTeamIdRouteRoute;
    };
    '/_private/_route/users/$userId/pipelines/$pipelineId_/recommendations/new': {
      id: '/_private/_route/users/$userId/pipelines/$pipelineId_/recommendations/new';
      path: '/pipelines/$pipelineId/recommendations/new';
      fullPath: '/users/$userId/pipelines/$pipelineId/recommendations/new';
      preLoaderRoute: typeof PrivateRouteUsersUserIdPipelinesPipelineIdRecommendationsNewRouteRouteImport;
      parentRoute: typeof PrivateRouteUsersUserIdRouteRoute;
    };
    '/_private/_route/_internal/candidates/$candidateId/tasks/goals/$goalId/': {
      id: '/_private/_route/_internal/candidates/$candidateId/tasks/goals/$goalId/';
      path: '/goals/$goalId';
      fullPath: '/candidates/$candidateId/tasks/goals/$goalId/';
      preLoaderRoute: typeof PrivateRouteInternalCandidatesCandidateIdTasksGoalsGoalIdIndexRouteRouteImport;
      parentRoute: typeof PrivateRouteInternalCandidatesCandidateIdTasksRouteRoute;
    };
    '/_private/_route/teams/$teamId/pipelines/$pipelineId/_internal/recommendations/': {
      id: '/_private/_route/teams/$teamId/pipelines/$pipelineId/_internal/recommendations/';
      path: '';
      fullPath: '/teams/$teamId/pipelines/$pipelineId/recommendations/';
      preLoaderRoute: typeof PrivateRouteTeamsTeamIdPipelinesPipelineIdInternalRecommendationsIndexRouteRouteImport;
      parentRoute: typeof PrivateRouteTeamsTeamIdPipelinesPipelineIdInternalRecommendationsRouteRoute;
    };
    '/_private/_route/teams/$teamId/pipelines/$pipelineId/introductions/$candidateId/': {
      id: '/_private/_route/teams/$teamId/pipelines/$pipelineId/introductions/$candidateId/';
      path: '/introductions/$candidateId';
      fullPath: '/teams/$teamId/pipelines/$pipelineId/introductions/$candidateId/';
      preLoaderRoute: typeof PrivateRouteTeamsTeamIdPipelinesPipelineIdIntroductionsCandidateIdIndexRouteRouteImport;
      parentRoute: typeof PrivateRouteTeamsTeamIdPipelinesPipelineIdLazyRoute;
    };
    '/_private/_route/teams/$teamId/pipelines/$pipelineId_/submissions/$submissionId/': {
      id: '/_private/_route/teams/$teamId/pipelines/$pipelineId_/submissions/$submissionId/';
      path: '/pipelines/$pipelineId/submissions/$submissionId';
      fullPath: '/teams/$teamId/pipelines/$pipelineId/submissions/$submissionId/';
      preLoaderRoute: typeof PrivateRouteTeamsTeamIdPipelinesPipelineIdSubmissionsSubmissionIdIndexRouteRouteImport;
      parentRoute: typeof PrivateRouteTeamsTeamIdRouteRoute;
    };
    '/_private/_route/teams/$teamId/searches/$searchId/candidates/$candidateId/': {
      id: '/_private/_route/teams/$teamId/searches/$searchId/candidates/$candidateId/';
      path: '/searches/$searchId/candidates/$candidateId';
      fullPath: '/teams/$teamId/searches/$searchId/candidates/$candidateId/';
      preLoaderRoute: typeof PrivateRouteTeamsTeamIdSearchesSearchIdCandidatesCandidateIdIndexRouteRouteImport;
      parentRoute: typeof PrivateRouteTeamsTeamIdRouteRoute;
    };
    '/_private/_route/users/$userId/pipelines/$pipelineId/recommendations/$recommendationId/': {
      id: '/_private/_route/users/$userId/pipelines/$pipelineId/recommendations/$recommendationId/';
      path: '/pipelines/$pipelineId/recommendations/$recommendationId';
      fullPath: '/users/$userId/pipelines/$pipelineId/recommendations/$recommendationId/';
      preLoaderRoute: typeof PrivateRouteUsersUserIdPipelinesPipelineIdRecommendationsRecommendationIdIndexRouteRouteImport;
      parentRoute: typeof PrivateRouteUsersUserIdRouteRoute;
    };
    '/_private/_route/_internal/people/$identityId/_candidate/tasks/goals/$goalId/': {
      id: '/_private/_route/_internal/people/$identityId/_candidate/tasks/goals/$goalId/';
      path: '/goals/$goalId';
      fullPath: '/people/$identityId/tasks/goals/$goalId/';
      preLoaderRoute: typeof PrivateRouteInternalPeopleIdentityIdCandidateTasksGoalsGoalIdIndexRouteRouteImport;
      parentRoute: typeof PrivateRouteInternalPeopleIdentityIdCandidateTasksRouteRoute;
    };
    '/_private/_route/_internal/teams/$teamId/searches/$searchId/submissions/$submissionId/': {
      id: '/_private/_route/_internal/teams/$teamId/searches/$searchId/submissions/$submissionId/';
      path: '/teams/$teamId/searches/$searchId/submissions/$submissionId';
      fullPath: '/teams/$teamId/searches/$searchId/submissions/$submissionId/';
      preLoaderRoute: typeof PrivateRouteInternalTeamsTeamIdSearchesSearchIdSubmissionsSubmissionIdIndexRouteRouteImport;
      parentRoute: typeof PrivateRouteInternalRouteRoute;
    };
    '/_private/_route/teams/$teamId/pipelines/$pipelineId/_internal/recommendations/$recommendationId/': {
      id: '/_private/_route/teams/$teamId/pipelines/$pipelineId/_internal/recommendations/$recommendationId/';
      path: '/$recommendationId';
      fullPath: '/teams/$teamId/pipelines/$pipelineId/recommendations/$recommendationId/';
      preLoaderRoute: typeof PrivateRouteTeamsTeamIdPipelinesPipelineIdInternalRecommendationsRecommendationIdIndexRouteRouteImport;
      parentRoute: typeof PrivateRouteTeamsTeamIdPipelinesPipelineIdInternalRecommendationsRouteRoute;
    };
  }
}

interface LayoutAuthGuestRouteRouteChildren {
  LayoutAuthGuestEmailResponseIndexRouteRoute: typeof LayoutAuthGuestEmailResponseIndexRouteRoute;
  LayoutAuthGuestJoinIndexRouteRoute: typeof LayoutAuthGuestJoinIndexRouteRoute;
  LayoutAuthGuestLoginIndexRouteRoute: typeof LayoutAuthGuestLoginIndexRouteRoute;
}

const LayoutAuthGuestRouteRouteChildren: LayoutAuthGuestRouteRouteChildren = {
  LayoutAuthGuestEmailResponseIndexRouteRoute:
    LayoutAuthGuestEmailResponseIndexRouteRoute,
  LayoutAuthGuestJoinIndexRouteRoute: LayoutAuthGuestJoinIndexRouteRoute,
  LayoutAuthGuestLoginIndexRouteRoute: LayoutAuthGuestLoginIndexRouteRoute,
};

const LayoutAuthGuestRouteRouteWithChildren =
  LayoutAuthGuestRouteRoute._addFileChildren(LayoutAuthGuestRouteRouteChildren);

interface LayoutAuthRouteRouteChildren {
  LayoutAuthGuestRouteRoute: typeof LayoutAuthGuestRouteRouteWithChildren;
  LayoutAuthLogoutIndexRouteRoute: typeof LayoutAuthLogoutIndexRouteRoute;
  LayoutAuthMaintenanceIndexRouteRoute: typeof LayoutAuthMaintenanceIndexRouteRoute;
}

const LayoutAuthRouteRouteChildren: LayoutAuthRouteRouteChildren = {
  LayoutAuthGuestRouteRoute: LayoutAuthGuestRouteRouteWithChildren,
  LayoutAuthLogoutIndexRouteRoute: LayoutAuthLogoutIndexRouteRoute,
  LayoutAuthMaintenanceIndexRouteRoute: LayoutAuthMaintenanceIndexRouteRoute,
};

const LayoutAuthRouteRouteWithChildren = LayoutAuthRouteRoute._addFileChildren(
  LayoutAuthRouteRouteChildren,
);

interface PrivateRouteInternalAdminUsersUserIdRouteRouteChildren {
  PrivateRouteInternalAdminUsersUserIdSettingsIndexRouteRoute: typeof PrivateRouteInternalAdminUsersUserIdSettingsIndexRouteRoute;
}

const PrivateRouteInternalAdminUsersUserIdRouteRouteChildren: PrivateRouteInternalAdminUsersUserIdRouteRouteChildren =
  {
    PrivateRouteInternalAdminUsersUserIdSettingsIndexRouteRoute:
      PrivateRouteInternalAdminUsersUserIdSettingsIndexRouteRoute,
  };

const PrivateRouteInternalAdminUsersUserIdRouteRouteWithChildren =
  PrivateRouteInternalAdminUsersUserIdRouteRoute._addFileChildren(
    PrivateRouteInternalAdminUsersUserIdRouteRouteChildren,
  );

interface PrivateRouteInternalAdminRouteRouteChildren {
  PrivateRouteInternalAdminUsersUserIdRouteRoute: typeof PrivateRouteInternalAdminUsersUserIdRouteRouteWithChildren;
  PrivateRouteInternalAdminUsersIndexRouteRoute: typeof PrivateRouteInternalAdminUsersIndexRouteRoute;
  PrivateRouteInternalAdminUsersNewIndexRouteRoute: typeof PrivateRouteInternalAdminUsersNewIndexRouteRoute;
}

const PrivateRouteInternalAdminRouteRouteChildren: PrivateRouteInternalAdminRouteRouteChildren =
  {
    PrivateRouteInternalAdminUsersUserIdRouteRoute:
      PrivateRouteInternalAdminUsersUserIdRouteRouteWithChildren,
    PrivateRouteInternalAdminUsersIndexRouteRoute:
      PrivateRouteInternalAdminUsersIndexRouteRoute,
    PrivateRouteInternalAdminUsersNewIndexRouteRoute:
      PrivateRouteInternalAdminUsersNewIndexRouteRoute,
  };

const PrivateRouteInternalAdminRouteRouteWithChildren =
  PrivateRouteInternalAdminRouteRoute._addFileChildren(
    PrivateRouteInternalAdminRouteRouteChildren,
  );

interface PrivateRouteInternalEventsEventIdParticipantsRouteRouteChildren {
  PrivateRouteInternalEventsEventIdParticipantsNewIndexRouteRoute: typeof PrivateRouteInternalEventsEventIdParticipantsNewIndexRouteRoute;
}

const PrivateRouteInternalEventsEventIdParticipantsRouteRouteChildren: PrivateRouteInternalEventsEventIdParticipantsRouteRouteChildren =
  {
    PrivateRouteInternalEventsEventIdParticipantsNewIndexRouteRoute:
      PrivateRouteInternalEventsEventIdParticipantsNewIndexRouteRoute,
  };

const PrivateRouteInternalEventsEventIdParticipantsRouteRouteWithChildren =
  PrivateRouteInternalEventsEventIdParticipantsRouteRoute._addFileChildren(
    PrivateRouteInternalEventsEventIdParticipantsRouteRouteChildren,
  );

interface PrivateRouteInternalEventsEventIdRouteRouteChildren {
  PrivateRouteInternalEventsEventIdParticipantsRouteRoute: typeof PrivateRouteInternalEventsEventIdParticipantsRouteRouteWithChildren;
  PrivateRouteInternalEventsEventIdIndexRouteRoute: typeof PrivateRouteInternalEventsEventIdIndexRouteRoute;
  PrivateRouteInternalEventsEventIdDetailsIndexRouteRoute: typeof PrivateRouteInternalEventsEventIdDetailsIndexRouteRoute;
  PrivateRouteInternalEventsEventIdEmailSettingsIndexRouteRoute: typeof PrivateRouteInternalEventsEventIdEmailSettingsIndexRouteRoute;
  PrivateRouteInternalEventsEventIdEmailsIndexRouteRoute: typeof PrivateRouteInternalEventsEventIdEmailsIndexRouteRoute;
}

const PrivateRouteInternalEventsEventIdRouteRouteChildren: PrivateRouteInternalEventsEventIdRouteRouteChildren =
  {
    PrivateRouteInternalEventsEventIdParticipantsRouteRoute:
      PrivateRouteInternalEventsEventIdParticipantsRouteRouteWithChildren,
    PrivateRouteInternalEventsEventIdIndexRouteRoute:
      PrivateRouteInternalEventsEventIdIndexRouteRoute,
    PrivateRouteInternalEventsEventIdDetailsIndexRouteRoute:
      PrivateRouteInternalEventsEventIdDetailsIndexRouteRoute,
    PrivateRouteInternalEventsEventIdEmailSettingsIndexRouteRoute:
      PrivateRouteInternalEventsEventIdEmailSettingsIndexRouteRoute,
    PrivateRouteInternalEventsEventIdEmailsIndexRouteRoute:
      PrivateRouteInternalEventsEventIdEmailsIndexRouteRoute,
  };

const PrivateRouteInternalEventsEventIdRouteRouteWithChildren =
  PrivateRouteInternalEventsEventIdRouteRoute._addFileChildren(
    PrivateRouteInternalEventsEventIdRouteRouteChildren,
  );

interface PrivateRouteInternalEventsParticipantsParticipantIdRouteRouteChildren {
  PrivateRouteInternalEventsParticipantsParticipantIdIndexRouteRoute: typeof PrivateRouteInternalEventsParticipantsParticipantIdIndexRouteRoute;
}

const PrivateRouteInternalEventsParticipantsParticipantIdRouteRouteChildren: PrivateRouteInternalEventsParticipantsParticipantIdRouteRouteChildren =
  {
    PrivateRouteInternalEventsParticipantsParticipantIdIndexRouteRoute:
      PrivateRouteInternalEventsParticipantsParticipantIdIndexRouteRoute,
  };

const PrivateRouteInternalEventsParticipantsParticipantIdRouteRouteWithChildren =
  PrivateRouteInternalEventsParticipantsParticipantIdRouteRoute._addFileChildren(
    PrivateRouteInternalEventsParticipantsParticipantIdRouteRouteChildren,
  );

interface PrivateRouteInternalEventsRouteRouteChildren {
  PrivateRouteInternalEventsEventIdRouteRoute: typeof PrivateRouteInternalEventsEventIdRouteRouteWithChildren;
  PrivateRouteInternalEventsIndexRouteRoute: typeof PrivateRouteInternalEventsIndexRouteRoute;
  PrivateRouteInternalEventsParticipantsParticipantIdRouteRoute: typeof PrivateRouteInternalEventsParticipantsParticipantIdRouteRouteWithChildren;
  PrivateRouteInternalEventsEventsIndexRouteRoute: typeof PrivateRouteInternalEventsEventsIndexRouteRoute;
  PrivateRouteInternalEventsNewIndexRouteRoute: typeof PrivateRouteInternalEventsNewIndexRouteRoute;
  PrivateRouteInternalEventsParticipantsIndexRouteRoute: typeof PrivateRouteInternalEventsParticipantsIndexRouteRoute;
  PrivateRouteInternalEventsSettingsIndexRouteRoute: typeof PrivateRouteInternalEventsSettingsIndexRouteRoute;
}

const PrivateRouteInternalEventsRouteRouteChildren: PrivateRouteInternalEventsRouteRouteChildren =
  {
    PrivateRouteInternalEventsEventIdRouteRoute:
      PrivateRouteInternalEventsEventIdRouteRouteWithChildren,
    PrivateRouteInternalEventsIndexRouteRoute:
      PrivateRouteInternalEventsIndexRouteRoute,
    PrivateRouteInternalEventsParticipantsParticipantIdRouteRoute:
      PrivateRouteInternalEventsParticipantsParticipantIdRouteRouteWithChildren,
    PrivateRouteInternalEventsEventsIndexRouteRoute:
      PrivateRouteInternalEventsEventsIndexRouteRoute,
    PrivateRouteInternalEventsNewIndexRouteRoute:
      PrivateRouteInternalEventsNewIndexRouteRoute,
    PrivateRouteInternalEventsParticipantsIndexRouteRoute:
      PrivateRouteInternalEventsParticipantsIndexRouteRoute,
    PrivateRouteInternalEventsSettingsIndexRouteRoute:
      PrivateRouteInternalEventsSettingsIndexRouteRoute,
  };

const PrivateRouteInternalEventsRouteRouteWithChildren =
  PrivateRouteInternalEventsRouteRoute._addFileChildren(
    PrivateRouteInternalEventsRouteRouteChildren,
  );

interface PrivateRouteInternalPipelinesRouteRouteChildren {
  PrivateRouteInternalPipelinesIndexRouteRoute: typeof PrivateRouteInternalPipelinesIndexRouteRoute;
}

const PrivateRouteInternalPipelinesRouteRouteChildren: PrivateRouteInternalPipelinesRouteRouteChildren =
  {
    PrivateRouteInternalPipelinesIndexRouteRoute:
      PrivateRouteInternalPipelinesIndexRouteRoute,
  };

const PrivateRouteInternalPipelinesRouteRouteWithChildren =
  PrivateRouteInternalPipelinesRouteRoute._addFileChildren(
    PrivateRouteInternalPipelinesRouteRouteChildren,
  );

interface PrivateRouteInternalTasksRouteRouteChildren {
  PrivateRouteInternalTasksIndexRouteRoute: typeof PrivateRouteInternalTasksIndexRouteRoute;
  PrivateRouteInternalTasksExecutiveServicesIndexRouteRoute: typeof PrivateRouteInternalTasksExecutiveServicesIndexRouteRoute;
  PrivateRouteInternalTasksMeIndexRouteRoute: typeof PrivateRouteInternalTasksMeIndexRouteRoute;
}

const PrivateRouteInternalTasksRouteRouteChildren: PrivateRouteInternalTasksRouteRouteChildren =
  {
    PrivateRouteInternalTasksIndexRouteRoute:
      PrivateRouteInternalTasksIndexRouteRoute,
    PrivateRouteInternalTasksExecutiveServicesIndexRouteRoute:
      PrivateRouteInternalTasksExecutiveServicesIndexRouteRoute,
    PrivateRouteInternalTasksMeIndexRouteRoute:
      PrivateRouteInternalTasksMeIndexRouteRoute,
  };

const PrivateRouteInternalTasksRouteRouteWithChildren =
  PrivateRouteInternalTasksRouteRoute._addFileChildren(
    PrivateRouteInternalTasksRouteRouteChildren,
  );

interface PrivateRouteInternalTrendingRouteRouteChildren {
  PrivateRouteInternalTrendingIndexRouteRoute: typeof PrivateRouteInternalTrendingIndexRouteRoute;
  PrivateRouteInternalTrendingSubmissionIdIndexRouteRoute: typeof PrivateRouteInternalTrendingSubmissionIdIndexRouteRoute;
  PrivateRouteInternalTrendingCampaignsIndexRouteRoute: typeof PrivateRouteInternalTrendingCampaignsIndexRouteRoute;
  PrivateRouteInternalTrendingNewIndexRouteRoute: typeof PrivateRouteInternalTrendingNewIndexRouteRoute;
  PrivateRouteInternalTrendingPeopleIndexRouteRoute: typeof PrivateRouteInternalTrendingPeopleIndexRouteRoute;
  PrivateRouteInternalTrendingSubmissionIdEditIndexRouteRoute: typeof PrivateRouteInternalTrendingSubmissionIdEditIndexRouteRoute;
}

const PrivateRouteInternalTrendingRouteRouteChildren: PrivateRouteInternalTrendingRouteRouteChildren =
  {
    PrivateRouteInternalTrendingIndexRouteRoute:
      PrivateRouteInternalTrendingIndexRouteRoute,
    PrivateRouteInternalTrendingSubmissionIdIndexRouteRoute:
      PrivateRouteInternalTrendingSubmissionIdIndexRouteRoute,
    PrivateRouteInternalTrendingCampaignsIndexRouteRoute:
      PrivateRouteInternalTrendingCampaignsIndexRouteRoute,
    PrivateRouteInternalTrendingNewIndexRouteRoute:
      PrivateRouteInternalTrendingNewIndexRouteRoute,
    PrivateRouteInternalTrendingPeopleIndexRouteRoute:
      PrivateRouteInternalTrendingPeopleIndexRouteRoute,
    PrivateRouteInternalTrendingSubmissionIdEditIndexRouteRoute:
      PrivateRouteInternalTrendingSubmissionIdEditIndexRouteRoute,
  };

const PrivateRouteInternalTrendingRouteRouteWithChildren =
  PrivateRouteInternalTrendingRouteRoute._addFileChildren(
    PrivateRouteInternalTrendingRouteRouteChildren,
  );

interface PrivateRouteInternalCandidatesCandidateIdTasksRouteRouteChildren {
  PrivateRouteInternalCandidatesCandidateIdTasksGoalsGoalIdIndexRouteRoute: typeof PrivateRouteInternalCandidatesCandidateIdTasksGoalsGoalIdIndexRouteRoute;
}

const PrivateRouteInternalCandidatesCandidateIdTasksRouteRouteChildren: PrivateRouteInternalCandidatesCandidateIdTasksRouteRouteChildren =
  {
    PrivateRouteInternalCandidatesCandidateIdTasksGoalsGoalIdIndexRouteRoute:
      PrivateRouteInternalCandidatesCandidateIdTasksGoalsGoalIdIndexRouteRoute,
  };

const PrivateRouteInternalCandidatesCandidateIdTasksRouteRouteWithChildren =
  PrivateRouteInternalCandidatesCandidateIdTasksRouteRoute._addFileChildren(
    PrivateRouteInternalCandidatesCandidateIdTasksRouteRouteChildren,
  );

interface PrivateRouteInternalCandidatesCandidateIdRouteRouteChildren {
  PrivateRouteInternalCandidatesCandidateIdTasksRouteRoute: typeof PrivateRouteInternalCandidatesCandidateIdTasksRouteRouteWithChildren;
  PrivateRouteInternalCandidatesCandidateIdIndexRouteRoute: typeof PrivateRouteInternalCandidatesCandidateIdIndexRouteRoute;
  PrivateRouteInternalCandidatesCandidateIdAboutIndexRouteRoute: typeof PrivateRouteInternalCandidatesCandidateIdAboutIndexRouteRoute;
  PrivateRouteInternalCandidatesCandidateIdAccountsIndexRouteRoute: typeof PrivateRouteInternalCandidatesCandidateIdAccountsIndexRouteRoute;
  PrivateRouteInternalCandidatesCandidateIdCompareIndexRouteRoute: typeof PrivateRouteInternalCandidatesCandidateIdCompareIndexRouteRoute;
  PrivateRouteInternalCandidatesCandidateIdFeedbackIndexRouteRoute: typeof PrivateRouteInternalCandidatesCandidateIdFeedbackIndexRouteRoute;
  PrivateRouteInternalCandidatesCandidateIdPerformanceIndexRouteRoute: typeof PrivateRouteInternalCandidatesCandidateIdPerformanceIndexRouteRoute;
  PrivateRouteInternalCandidatesCandidateIdProfileIndexRouteRoute: typeof PrivateRouteInternalCandidatesCandidateIdProfileIndexRouteRoute;
  PrivateRouteInternalCandidatesCandidateIdRecommendationsIndexRouteRoute: typeof PrivateRouteInternalCandidatesCandidateIdRecommendationsIndexRouteRoute;
  PrivateRouteInternalCandidatesCandidateIdSuggestedPipelinesIndexRouteRoute: typeof PrivateRouteInternalCandidatesCandidateIdSuggestedPipelinesIndexRouteRoute;
}

const PrivateRouteInternalCandidatesCandidateIdRouteRouteChildren: PrivateRouteInternalCandidatesCandidateIdRouteRouteChildren =
  {
    PrivateRouteInternalCandidatesCandidateIdTasksRouteRoute:
      PrivateRouteInternalCandidatesCandidateIdTasksRouteRouteWithChildren,
    PrivateRouteInternalCandidatesCandidateIdIndexRouteRoute:
      PrivateRouteInternalCandidatesCandidateIdIndexRouteRoute,
    PrivateRouteInternalCandidatesCandidateIdAboutIndexRouteRoute:
      PrivateRouteInternalCandidatesCandidateIdAboutIndexRouteRoute,
    PrivateRouteInternalCandidatesCandidateIdAccountsIndexRouteRoute:
      PrivateRouteInternalCandidatesCandidateIdAccountsIndexRouteRoute,
    PrivateRouteInternalCandidatesCandidateIdCompareIndexRouteRoute:
      PrivateRouteInternalCandidatesCandidateIdCompareIndexRouteRoute,
    PrivateRouteInternalCandidatesCandidateIdFeedbackIndexRouteRoute:
      PrivateRouteInternalCandidatesCandidateIdFeedbackIndexRouteRoute,
    PrivateRouteInternalCandidatesCandidateIdPerformanceIndexRouteRoute:
      PrivateRouteInternalCandidatesCandidateIdPerformanceIndexRouteRoute,
    PrivateRouteInternalCandidatesCandidateIdProfileIndexRouteRoute:
      PrivateRouteInternalCandidatesCandidateIdProfileIndexRouteRoute,
    PrivateRouteInternalCandidatesCandidateIdRecommendationsIndexRouteRoute:
      PrivateRouteInternalCandidatesCandidateIdRecommendationsIndexRouteRoute,
    PrivateRouteInternalCandidatesCandidateIdSuggestedPipelinesIndexRouteRoute:
      PrivateRouteInternalCandidatesCandidateIdSuggestedPipelinesIndexRouteRoute,
  };

const PrivateRouteInternalCandidatesCandidateIdRouteRouteWithChildren =
  PrivateRouteInternalCandidatesCandidateIdRouteRoute._addFileChildren(
    PrivateRouteInternalCandidatesCandidateIdRouteRouteChildren,
  );

interface PrivateRouteInternalPeopleIdentityIdCandidateTasksRouteRouteChildren {
  PrivateRouteInternalPeopleIdentityIdCandidateTasksIndexLazyRoute: typeof PrivateRouteInternalPeopleIdentityIdCandidateTasksIndexLazyRoute;
  PrivateRouteInternalPeopleIdentityIdCandidateTasksGoalsGoalIdIndexRouteRoute: typeof PrivateRouteInternalPeopleIdentityIdCandidateTasksGoalsGoalIdIndexRouteRoute;
}

const PrivateRouteInternalPeopleIdentityIdCandidateTasksRouteRouteChildren: PrivateRouteInternalPeopleIdentityIdCandidateTasksRouteRouteChildren =
  {
    PrivateRouteInternalPeopleIdentityIdCandidateTasksIndexLazyRoute:
      PrivateRouteInternalPeopleIdentityIdCandidateTasksIndexLazyRoute,
    PrivateRouteInternalPeopleIdentityIdCandidateTasksGoalsGoalIdIndexRouteRoute:
      PrivateRouteInternalPeopleIdentityIdCandidateTasksGoalsGoalIdIndexRouteRoute,
  };

const PrivateRouteInternalPeopleIdentityIdCandidateTasksRouteRouteWithChildren =
  PrivateRouteInternalPeopleIdentityIdCandidateTasksRouteRoute._addFileChildren(
    PrivateRouteInternalPeopleIdentityIdCandidateTasksRouteRouteChildren,
  );

interface PrivateRouteInternalPeopleIdentityIdCandidateRouteRouteChildren {
  PrivateRouteInternalPeopleIdentityIdCandidateTasksRouteRoute: typeof PrivateRouteInternalPeopleIdentityIdCandidateTasksRouteRouteWithChildren;
  PrivateRouteInternalPeopleIdentityIdCandidateAboutIndexRouteRoute: typeof PrivateRouteInternalPeopleIdentityIdCandidateAboutIndexRouteRoute;
  PrivateRouteInternalPeopleIdentityIdCandidateCompareIndexRouteRoute: typeof PrivateRouteInternalPeopleIdentityIdCandidateCompareIndexRouteRoute;
  PrivateRouteInternalPeopleIdentityIdCandidateFeedbackIndexRouteRoute: typeof PrivateRouteInternalPeopleIdentityIdCandidateFeedbackIndexRouteRoute;
  PrivateRouteInternalPeopleIdentityIdCandidatePerformanceIndexRouteRoute: typeof PrivateRouteInternalPeopleIdentityIdCandidatePerformanceIndexRouteRoute;
  PrivateRouteInternalPeopleIdentityIdCandidateProfileIndexRouteRoute: typeof PrivateRouteInternalPeopleIdentityIdCandidateProfileIndexRouteRoute;
  PrivateRouteInternalPeopleIdentityIdCandidateRecommendationsIndexRouteRoute: typeof PrivateRouteInternalPeopleIdentityIdCandidateRecommendationsIndexRouteRoute;
  PrivateRouteInternalPeopleIdentityIdCandidateSuggestedPipelinesIndexRouteRoute: typeof PrivateRouteInternalPeopleIdentityIdCandidateSuggestedPipelinesIndexRouteRoute;
}

const PrivateRouteInternalPeopleIdentityIdCandidateRouteRouteChildren: PrivateRouteInternalPeopleIdentityIdCandidateRouteRouteChildren =
  {
    PrivateRouteInternalPeopleIdentityIdCandidateTasksRouteRoute:
      PrivateRouteInternalPeopleIdentityIdCandidateTasksRouteRouteWithChildren,
    PrivateRouteInternalPeopleIdentityIdCandidateAboutIndexRouteRoute:
      PrivateRouteInternalPeopleIdentityIdCandidateAboutIndexRouteRoute,
    PrivateRouteInternalPeopleIdentityIdCandidateCompareIndexRouteRoute:
      PrivateRouteInternalPeopleIdentityIdCandidateCompareIndexRouteRoute,
    PrivateRouteInternalPeopleIdentityIdCandidateFeedbackIndexRouteRoute:
      PrivateRouteInternalPeopleIdentityIdCandidateFeedbackIndexRouteRoute,
    PrivateRouteInternalPeopleIdentityIdCandidatePerformanceIndexRouteRoute:
      PrivateRouteInternalPeopleIdentityIdCandidatePerformanceIndexRouteRoute,
    PrivateRouteInternalPeopleIdentityIdCandidateProfileIndexRouteRoute:
      PrivateRouteInternalPeopleIdentityIdCandidateProfileIndexRouteRoute,
    PrivateRouteInternalPeopleIdentityIdCandidateRecommendationsIndexRouteRoute:
      PrivateRouteInternalPeopleIdentityIdCandidateRecommendationsIndexRouteRoute,
    PrivateRouteInternalPeopleIdentityIdCandidateSuggestedPipelinesIndexRouteRoute:
      PrivateRouteInternalPeopleIdentityIdCandidateSuggestedPipelinesIndexRouteRoute,
  };

const PrivateRouteInternalPeopleIdentityIdCandidateRouteRouteWithChildren =
  PrivateRouteInternalPeopleIdentityIdCandidateRouteRoute._addFileChildren(
    PrivateRouteInternalPeopleIdentityIdCandidateRouteRouteChildren,
  );

interface PrivateRouteInternalPeopleIdentityIdRouteRouteChildren {
  PrivateRouteInternalPeopleIdentityIdCandidateRouteRoute: typeof PrivateRouteInternalPeopleIdentityIdCandidateRouteRouteWithChildren;
  PrivateRouteInternalPeopleIdentityIdIndexRouteRoute: typeof PrivateRouteInternalPeopleIdentityIdIndexRouteRoute;
  PrivateRouteInternalPeopleIdentityIdAccountsIndexRouteRoute: typeof PrivateRouteInternalPeopleIdentityIdAccountsIndexRouteRoute;
  PrivateRouteInternalPeopleIdentityIdEmailsIndexRouteRoute: typeof PrivateRouteInternalPeopleIdentityIdEmailsIndexRouteRoute;
}

const PrivateRouteInternalPeopleIdentityIdRouteRouteChildren: PrivateRouteInternalPeopleIdentityIdRouteRouteChildren =
  {
    PrivateRouteInternalPeopleIdentityIdCandidateRouteRoute:
      PrivateRouteInternalPeopleIdentityIdCandidateRouteRouteWithChildren,
    PrivateRouteInternalPeopleIdentityIdIndexRouteRoute:
      PrivateRouteInternalPeopleIdentityIdIndexRouteRoute,
    PrivateRouteInternalPeopleIdentityIdAccountsIndexRouteRoute:
      PrivateRouteInternalPeopleIdentityIdAccountsIndexRouteRoute,
    PrivateRouteInternalPeopleIdentityIdEmailsIndexRouteRoute:
      PrivateRouteInternalPeopleIdentityIdEmailsIndexRouteRoute,
  };

const PrivateRouteInternalPeopleIdentityIdRouteRouteWithChildren =
  PrivateRouteInternalPeopleIdentityIdRouteRoute._addFileChildren(
    PrivateRouteInternalPeopleIdentityIdRouteRouteChildren,
  );

interface PrivateRouteInternalRouteRouteChildren {
  PrivateRouteInternalAdminRouteRoute: typeof PrivateRouteInternalAdminRouteRouteWithChildren;
  PrivateRouteInternalEventsRouteRoute: typeof PrivateRouteInternalEventsRouteRouteWithChildren;
  PrivateRouteInternalPipelinesRouteRoute: typeof PrivateRouteInternalPipelinesRouteRouteWithChildren;
  PrivateRouteInternalTasksRouteRoute: typeof PrivateRouteInternalTasksRouteRouteWithChildren;
  PrivateRouteInternalTrendingRouteRoute: typeof PrivateRouteInternalTrendingRouteRouteWithChildren;
  PrivateRouteInternalCandidatesCandidateIdRouteRoute: typeof PrivateRouteInternalCandidatesCandidateIdRouteRouteWithChildren;
  PrivateRouteInternalPeopleIdentityIdRouteRoute: typeof PrivateRouteInternalPeopleIdentityIdRouteRouteWithChildren;
  PrivateRouteInternalPipelinesNewRouteRoute: typeof PrivateRouteInternalPipelinesNewRouteRoute;
  PrivateRouteInternalCompaniesIndexRouteRoute: typeof PrivateRouteInternalCompaniesIndexRouteRoute;
  PrivateRouteInternalExperimentsIndexRouteRoute: typeof PrivateRouteInternalExperimentsIndexRouteRoute;
  PrivateRouteInternalHomeIndexRouteRoute: typeof PrivateRouteInternalHomeIndexRouteRoute;
  PrivateRouteInternalIntroductionsIndexRouteRoute: typeof PrivateRouteInternalIntroductionsIndexRouteRoute;
  PrivateRouteInternalPeersIndexRouteRoute: typeof PrivateRouteInternalPeersIndexRouteRoute;
  PrivateRouteInternalPeopleIndexRouteRoute: typeof PrivateRouteInternalPeopleIndexRouteRoute;
  PrivateRouteInternalPerformanceIndexRouteRoute: typeof PrivateRouteInternalPerformanceIndexRouteRoute;
  PrivateRouteInternalPipelineSubmissionsIndexRouteRoute: typeof PrivateRouteInternalPipelineSubmissionsIndexRouteRoute;
  PrivateRouteInternalSearchSubmissionsIndexRouteRoute: typeof PrivateRouteInternalSearchSubmissionsIndexRouteRoute;
  PrivateRouteInternalSearchesIndexRouteRoute: typeof PrivateRouteInternalSearchesIndexRouteRoute;
  PrivateRouteInternalToolsIndexRouteRoute: typeof PrivateRouteInternalToolsIndexRouteRoute;
  PrivateRouteInternalCandidatesNewIndexRouteRoute: typeof PrivateRouteInternalCandidatesNewIndexRouteRoute;
  PrivateRouteInternalIntroductionSubmissionsSubmissionIdIndexRouteRoute: typeof PrivateRouteInternalIntroductionSubmissionsSubmissionIdIndexRouteRoute;
  PrivateRouteInternalPeersNewIndexRouteRoute: typeof PrivateRouteInternalPeersNewIndexRouteRoute;
  PrivateRouteInternalPipelineSubmissionsSubmissionIdIndexRouteRoute: typeof PrivateRouteInternalPipelineSubmissionsSubmissionIdIndexRouteRoute;
  PrivateRouteInternalToolsAiCandidateDiscoveryIndexRouteRoute: typeof PrivateRouteInternalToolsAiCandidateDiscoveryIndexRouteRoute;
  PrivateRouteInternalToolsEmailTemplatesIndexRouteRoute: typeof PrivateRouteInternalToolsEmailTemplatesIndexRouteRoute;
  PrivateRouteInternalToolsMarketSearchesIndexRouteRoute: typeof PrivateRouteInternalToolsMarketSearchesIndexRouteRoute;
  PrivateRouteInternalToolsMergePeopleIndexRouteRoute: typeof PrivateRouteInternalToolsMergePeopleIndexRouteRoute;
  PrivateRouteInternalToolsMoveTeamIndexRouteRoute: typeof PrivateRouteInternalToolsMoveTeamIndexRouteRoute;
  PrivateRouteInternalToolsPathwayActivityDefaultsIndexRouteRoute: typeof PrivateRouteInternalToolsPathwayActivityDefaultsIndexRouteRoute;
  PrivateRouteInternalCompaniesCompanyIdPeopleIndexRouteRoute: typeof PrivateRouteInternalCompaniesCompanyIdPeopleIndexRouteRoute;
  PrivateRouteInternalCompaniesCompanyIdSettingsIndexRouteRoute: typeof PrivateRouteInternalCompaniesCompanyIdSettingsIndexRouteRoute;
  PrivateRouteInternalTeamsTeamIdSearchesSearchIdSubmissionsSubmissionIdIndexRouteRoute: typeof PrivateRouteInternalTeamsTeamIdSearchesSearchIdSubmissionsSubmissionIdIndexRouteRoute;
}

const PrivateRouteInternalRouteRouteChildren: PrivateRouteInternalRouteRouteChildren =
  {
    PrivateRouteInternalAdminRouteRoute:
      PrivateRouteInternalAdminRouteRouteWithChildren,
    PrivateRouteInternalEventsRouteRoute:
      PrivateRouteInternalEventsRouteRouteWithChildren,
    PrivateRouteInternalPipelinesRouteRoute:
      PrivateRouteInternalPipelinesRouteRouteWithChildren,
    PrivateRouteInternalTasksRouteRoute:
      PrivateRouteInternalTasksRouteRouteWithChildren,
    PrivateRouteInternalTrendingRouteRoute:
      PrivateRouteInternalTrendingRouteRouteWithChildren,
    PrivateRouteInternalCandidatesCandidateIdRouteRoute:
      PrivateRouteInternalCandidatesCandidateIdRouteRouteWithChildren,
    PrivateRouteInternalPeopleIdentityIdRouteRoute:
      PrivateRouteInternalPeopleIdentityIdRouteRouteWithChildren,
    PrivateRouteInternalPipelinesNewRouteRoute:
      PrivateRouteInternalPipelinesNewRouteRoute,
    PrivateRouteInternalCompaniesIndexRouteRoute:
      PrivateRouteInternalCompaniesIndexRouteRoute,
    PrivateRouteInternalExperimentsIndexRouteRoute:
      PrivateRouteInternalExperimentsIndexRouteRoute,
    PrivateRouteInternalHomeIndexRouteRoute:
      PrivateRouteInternalHomeIndexRouteRoute,
    PrivateRouteInternalIntroductionsIndexRouteRoute:
      PrivateRouteInternalIntroductionsIndexRouteRoute,
    PrivateRouteInternalPeersIndexRouteRoute:
      PrivateRouteInternalPeersIndexRouteRoute,
    PrivateRouteInternalPeopleIndexRouteRoute:
      PrivateRouteInternalPeopleIndexRouteRoute,
    PrivateRouteInternalPerformanceIndexRouteRoute:
      PrivateRouteInternalPerformanceIndexRouteRoute,
    PrivateRouteInternalPipelineSubmissionsIndexRouteRoute:
      PrivateRouteInternalPipelineSubmissionsIndexRouteRoute,
    PrivateRouteInternalSearchSubmissionsIndexRouteRoute:
      PrivateRouteInternalSearchSubmissionsIndexRouteRoute,
    PrivateRouteInternalSearchesIndexRouteRoute:
      PrivateRouteInternalSearchesIndexRouteRoute,
    PrivateRouteInternalToolsIndexRouteRoute:
      PrivateRouteInternalToolsIndexRouteRoute,
    PrivateRouteInternalCandidatesNewIndexRouteRoute:
      PrivateRouteInternalCandidatesNewIndexRouteRoute,
    PrivateRouteInternalIntroductionSubmissionsSubmissionIdIndexRouteRoute:
      PrivateRouteInternalIntroductionSubmissionsSubmissionIdIndexRouteRoute,
    PrivateRouteInternalPeersNewIndexRouteRoute:
      PrivateRouteInternalPeersNewIndexRouteRoute,
    PrivateRouteInternalPipelineSubmissionsSubmissionIdIndexRouteRoute:
      PrivateRouteInternalPipelineSubmissionsSubmissionIdIndexRouteRoute,
    PrivateRouteInternalToolsAiCandidateDiscoveryIndexRouteRoute:
      PrivateRouteInternalToolsAiCandidateDiscoveryIndexRouteRoute,
    PrivateRouteInternalToolsEmailTemplatesIndexRouteRoute:
      PrivateRouteInternalToolsEmailTemplatesIndexRouteRoute,
    PrivateRouteInternalToolsMarketSearchesIndexRouteRoute:
      PrivateRouteInternalToolsMarketSearchesIndexRouteRoute,
    PrivateRouteInternalToolsMergePeopleIndexRouteRoute:
      PrivateRouteInternalToolsMergePeopleIndexRouteRoute,
    PrivateRouteInternalToolsMoveTeamIndexRouteRoute:
      PrivateRouteInternalToolsMoveTeamIndexRouteRoute,
    PrivateRouteInternalToolsPathwayActivityDefaultsIndexRouteRoute:
      PrivateRouteInternalToolsPathwayActivityDefaultsIndexRouteRoute,
    PrivateRouteInternalCompaniesCompanyIdPeopleIndexRouteRoute:
      PrivateRouteInternalCompaniesCompanyIdPeopleIndexRouteRoute,
    PrivateRouteInternalCompaniesCompanyIdSettingsIndexRouteRoute:
      PrivateRouteInternalCompaniesCompanyIdSettingsIndexRouteRoute,
    PrivateRouteInternalTeamsTeamIdSearchesSearchIdSubmissionsSubmissionIdIndexRouteRoute:
      PrivateRouteInternalTeamsTeamIdSearchesSearchIdSubmissionsSubmissionIdIndexRouteRoute,
  };

const PrivateRouteInternalRouteRouteWithChildren =
  PrivateRouteInternalRouteRoute._addFileChildren(
    PrivateRouteInternalRouteRouteChildren,
  );

interface PrivateRouteProfileRouteRouteChildren {
  PrivateRouteProfileIndexRouteRoute: typeof PrivateRouteProfileIndexRouteRoute;
  PrivateRouteProfileTeamsIndexRouteRoute: typeof PrivateRouteProfileTeamsIndexRouteRoute;
}

const PrivateRouteProfileRouteRouteChildren: PrivateRouteProfileRouteRouteChildren =
  {
    PrivateRouteProfileIndexRouteRoute: PrivateRouteProfileIndexRouteRoute,
    PrivateRouteProfileTeamsIndexRouteRoute:
      PrivateRouteProfileTeamsIndexRouteRoute,
  };

const PrivateRouteProfileRouteRouteWithChildren =
  PrivateRouteProfileRouteRoute._addFileChildren(
    PrivateRouteProfileRouteRouteChildren,
  );

interface PrivateRouteTeamsTeamIdCandidatesCandidateIdRouteRouteChildren {
  PrivateRouteTeamsTeamIdCandidatesCandidateIdTabIdRouteRoute: typeof PrivateRouteTeamsTeamIdCandidatesCandidateIdTabIdRouteRoute;
  PrivateRouteTeamsTeamIdCandidatesCandidateIdIndexRouteRoute: typeof PrivateRouteTeamsTeamIdCandidatesCandidateIdIndexRouteRoute;
  PrivateRouteTeamsTeamIdCandidatesCandidateIdActivityIndexRouteRoute: typeof PrivateRouteTeamsTeamIdCandidatesCandidateIdActivityIndexRouteRoute;
  PrivateRouteTeamsTeamIdCandidatesCandidateIdPipelinesIndexRouteRoute: typeof PrivateRouteTeamsTeamIdCandidatesCandidateIdPipelinesIndexRouteRoute;
}

const PrivateRouteTeamsTeamIdCandidatesCandidateIdRouteRouteChildren: PrivateRouteTeamsTeamIdCandidatesCandidateIdRouteRouteChildren =
  {
    PrivateRouteTeamsTeamIdCandidatesCandidateIdTabIdRouteRoute:
      PrivateRouteTeamsTeamIdCandidatesCandidateIdTabIdRouteRoute,
    PrivateRouteTeamsTeamIdCandidatesCandidateIdIndexRouteRoute:
      PrivateRouteTeamsTeamIdCandidatesCandidateIdIndexRouteRoute,
    PrivateRouteTeamsTeamIdCandidatesCandidateIdActivityIndexRouteRoute:
      PrivateRouteTeamsTeamIdCandidatesCandidateIdActivityIndexRouteRoute,
    PrivateRouteTeamsTeamIdCandidatesCandidateIdPipelinesIndexRouteRoute:
      PrivateRouteTeamsTeamIdCandidatesCandidateIdPipelinesIndexRouteRoute,
  };

const PrivateRouteTeamsTeamIdCandidatesCandidateIdRouteRouteWithChildren =
  PrivateRouteTeamsTeamIdCandidatesCandidateIdRouteRoute._addFileChildren(
    PrivateRouteTeamsTeamIdCandidatesCandidateIdRouteRouteChildren,
  );

interface PrivateRouteTeamsTeamIdCandidatesRouteRouteChildren {
  PrivateRouteTeamsTeamIdCandidatesCandidateIdRouteRoute: typeof PrivateRouteTeamsTeamIdCandidatesCandidateIdRouteRouteWithChildren;
}

const PrivateRouteTeamsTeamIdCandidatesRouteRouteChildren: PrivateRouteTeamsTeamIdCandidatesRouteRouteChildren =
  {
    PrivateRouteTeamsTeamIdCandidatesCandidateIdRouteRoute:
      PrivateRouteTeamsTeamIdCandidatesCandidateIdRouteRouteWithChildren,
  };

const PrivateRouteTeamsTeamIdCandidatesRouteRouteWithChildren =
  PrivateRouteTeamsTeamIdCandidatesRouteRoute._addFileChildren(
    PrivateRouteTeamsTeamIdCandidatesRouteRouteChildren,
  );

interface PrivateRouteTeamsTeamIdTrendingLazyRouteChildren {
  PrivateRouteTeamsTeamIdTrendingIndexRoute: typeof PrivateRouteTeamsTeamIdTrendingIndexRoute;
  PrivateRouteTeamsTeamIdTrendingRecommendationIdIndexRouteRoute: typeof PrivateRouteTeamsTeamIdTrendingRecommendationIdIndexRouteRoute;
}

const PrivateRouteTeamsTeamIdTrendingLazyRouteChildren: PrivateRouteTeamsTeamIdTrendingLazyRouteChildren =
  {
    PrivateRouteTeamsTeamIdTrendingIndexRoute:
      PrivateRouteTeamsTeamIdTrendingIndexRoute,
    PrivateRouteTeamsTeamIdTrendingRecommendationIdIndexRouteRoute:
      PrivateRouteTeamsTeamIdTrendingRecommendationIdIndexRouteRoute,
  };

const PrivateRouteTeamsTeamIdTrendingLazyRouteWithChildren =
  PrivateRouteTeamsTeamIdTrendingLazyRoute._addFileChildren(
    PrivateRouteTeamsTeamIdTrendingLazyRouteChildren,
  );

interface PrivateRouteTeamsTeamIdPipelinesPipelineIdInternalRecommendationsRouteRouteChildren {
  PrivateRouteTeamsTeamIdPipelinesPipelineIdInternalRecommendationsIndexRouteRoute: typeof PrivateRouteTeamsTeamIdPipelinesPipelineIdInternalRecommendationsIndexRouteRoute;
  PrivateRouteTeamsTeamIdPipelinesPipelineIdInternalRecommendationsRecommendationIdIndexRouteRoute: typeof PrivateRouteTeamsTeamIdPipelinesPipelineIdInternalRecommendationsRecommendationIdIndexRouteRoute;
}

const PrivateRouteTeamsTeamIdPipelinesPipelineIdInternalRecommendationsRouteRouteChildren: PrivateRouteTeamsTeamIdPipelinesPipelineIdInternalRecommendationsRouteRouteChildren =
  {
    PrivateRouteTeamsTeamIdPipelinesPipelineIdInternalRecommendationsIndexRouteRoute:
      PrivateRouteTeamsTeamIdPipelinesPipelineIdInternalRecommendationsIndexRouteRoute,
    PrivateRouteTeamsTeamIdPipelinesPipelineIdInternalRecommendationsRecommendationIdIndexRouteRoute:
      PrivateRouteTeamsTeamIdPipelinesPipelineIdInternalRecommendationsRecommendationIdIndexRouteRoute,
  };

const PrivateRouteTeamsTeamIdPipelinesPipelineIdInternalRecommendationsRouteRouteWithChildren =
  PrivateRouteTeamsTeamIdPipelinesPipelineIdInternalRecommendationsRouteRoute._addFileChildren(
    PrivateRouteTeamsTeamIdPipelinesPipelineIdInternalRecommendationsRouteRouteChildren,
  );

interface PrivateRouteTeamsTeamIdPipelinesPipelineIdInternalLazyRouteChildren {
  PrivateRouteTeamsTeamIdPipelinesPipelineIdInternalIndexRouteRoute: typeof PrivateRouteTeamsTeamIdPipelinesPipelineIdInternalIndexRouteRoute;
  PrivateRouteTeamsTeamIdPipelinesPipelineIdInternalRecommendationsRouteRoute: typeof PrivateRouteTeamsTeamIdPipelinesPipelineIdInternalRecommendationsRouteRouteWithChildren;
}

const PrivateRouteTeamsTeamIdPipelinesPipelineIdInternalLazyRouteChildren: PrivateRouteTeamsTeamIdPipelinesPipelineIdInternalLazyRouteChildren =
  {
    PrivateRouteTeamsTeamIdPipelinesPipelineIdInternalIndexRouteRoute:
      PrivateRouteTeamsTeamIdPipelinesPipelineIdInternalIndexRouteRoute,
    PrivateRouteTeamsTeamIdPipelinesPipelineIdInternalRecommendationsRouteRoute:
      PrivateRouteTeamsTeamIdPipelinesPipelineIdInternalRecommendationsRouteRouteWithChildren,
  };

const PrivateRouteTeamsTeamIdPipelinesPipelineIdInternalLazyRouteWithChildren =
  PrivateRouteTeamsTeamIdPipelinesPipelineIdInternalLazyRoute._addFileChildren(
    PrivateRouteTeamsTeamIdPipelinesPipelineIdInternalLazyRouteChildren,
  );

interface PrivateRouteTeamsTeamIdPipelinesPipelineIdLazyRouteChildren {
  PrivateRouteTeamsTeamIdPipelinesPipelineIdInternalLazyRoute: typeof PrivateRouteTeamsTeamIdPipelinesPipelineIdInternalLazyRouteWithChildren;
  PrivateRouteTeamsTeamIdPipelinesPipelineIdIntroductionsCandidateIdIndexRouteRoute: typeof PrivateRouteTeamsTeamIdPipelinesPipelineIdIntroductionsCandidateIdIndexRouteRoute;
}

const PrivateRouteTeamsTeamIdPipelinesPipelineIdLazyRouteChildren: PrivateRouteTeamsTeamIdPipelinesPipelineIdLazyRouteChildren =
  {
    PrivateRouteTeamsTeamIdPipelinesPipelineIdInternalLazyRoute:
      PrivateRouteTeamsTeamIdPipelinesPipelineIdInternalLazyRouteWithChildren,
    PrivateRouteTeamsTeamIdPipelinesPipelineIdIntroductionsCandidateIdIndexRouteRoute:
      PrivateRouteTeamsTeamIdPipelinesPipelineIdIntroductionsCandidateIdIndexRouteRoute,
  };

const PrivateRouteTeamsTeamIdPipelinesPipelineIdLazyRouteWithChildren =
  PrivateRouteTeamsTeamIdPipelinesPipelineIdLazyRoute._addFileChildren(
    PrivateRouteTeamsTeamIdPipelinesPipelineIdLazyRouteChildren,
  );

interface PrivateRouteTeamsTeamIdRouteRouteChildren {
  PrivateRouteTeamsTeamIdCandidatesRouteRoute: typeof PrivateRouteTeamsTeamIdCandidatesRouteRouteWithChildren;
  PrivateRouteTeamsTeamIdNetworkRouteRoute: typeof PrivateRouteTeamsTeamIdNetworkRouteRoute;
  PrivateRouteTeamsTeamIdTrendingLazyRoute: typeof PrivateRouteTeamsTeamIdTrendingLazyRouteWithChildren;
  PrivateRouteTeamsTeamIdPipelinesNewRouteRoute: typeof PrivateRouteTeamsTeamIdPipelinesNewRouteRoute;
  PrivateRouteTeamsTeamIdPipelinesPipelineIdLazyRoute: typeof PrivateRouteTeamsTeamIdPipelinesPipelineIdLazyRouteWithChildren;
  PrivateRouteTeamsTeamIdHomeIndexRouteRoute: typeof PrivateRouteTeamsTeamIdHomeIndexRouteRoute;
  PrivateRouteTeamsTeamIdIntroductionsIndexRouteRoute: typeof PrivateRouteTeamsTeamIdIntroductionsIndexRouteRoute;
  PrivateRouteTeamsTeamIdPipelinesIndexRouteRoute: typeof PrivateRouteTeamsTeamIdPipelinesIndexRouteRoute;
  PrivateRouteTeamsTeamIdSearchesIndexRouteRoute: typeof PrivateRouteTeamsTeamIdSearchesIndexRouteRoute;
  PrivateRouteTeamsTeamIdSettingsIndexRouteRoute: typeof PrivateRouteTeamsTeamIdSettingsIndexRouteRoute;
  PrivateRouteTeamsTeamIdPipelinesPipelineIdEditRouteRoute: typeof PrivateRouteTeamsTeamIdPipelinesPipelineIdEditRouteRoute;
  PrivateRouteTeamsTeamIdIntroductionsCandidateIdIndexRouteRoute: typeof PrivateRouteTeamsTeamIdIntroductionsCandidateIdIndexRouteRoute;
  PrivateRouteTeamsTeamIdSearchesSearchIdIndexRouteRoute: typeof PrivateRouteTeamsTeamIdSearchesSearchIdIndexRouteRoute;
  PrivateRouteTeamsTeamIdPipelinesPipelineIdRecommendationsNewRouteRoute: typeof PrivateRouteTeamsTeamIdPipelinesPipelineIdRecommendationsNewRouteRoute;
  PrivateRouteTeamsTeamIdPipelinesPipelineIdSubmissionsSubmissionIdIndexRouteRoute: typeof PrivateRouteTeamsTeamIdPipelinesPipelineIdSubmissionsSubmissionIdIndexRouteRoute;
  PrivateRouteTeamsTeamIdSearchesSearchIdCandidatesCandidateIdIndexRouteRoute: typeof PrivateRouteTeamsTeamIdSearchesSearchIdCandidatesCandidateIdIndexRouteRoute;
}

const PrivateRouteTeamsTeamIdRouteRouteChildren: PrivateRouteTeamsTeamIdRouteRouteChildren =
  {
    PrivateRouteTeamsTeamIdCandidatesRouteRoute:
      PrivateRouteTeamsTeamIdCandidatesRouteRouteWithChildren,
    PrivateRouteTeamsTeamIdNetworkRouteRoute:
      PrivateRouteTeamsTeamIdNetworkRouteRoute,
    PrivateRouteTeamsTeamIdTrendingLazyRoute:
      PrivateRouteTeamsTeamIdTrendingLazyRouteWithChildren,
    PrivateRouteTeamsTeamIdPipelinesNewRouteRoute:
      PrivateRouteTeamsTeamIdPipelinesNewRouteRoute,
    PrivateRouteTeamsTeamIdPipelinesPipelineIdLazyRoute:
      PrivateRouteTeamsTeamIdPipelinesPipelineIdLazyRouteWithChildren,
    PrivateRouteTeamsTeamIdHomeIndexRouteRoute:
      PrivateRouteTeamsTeamIdHomeIndexRouteRoute,
    PrivateRouteTeamsTeamIdIntroductionsIndexRouteRoute:
      PrivateRouteTeamsTeamIdIntroductionsIndexRouteRoute,
    PrivateRouteTeamsTeamIdPipelinesIndexRouteRoute:
      PrivateRouteTeamsTeamIdPipelinesIndexRouteRoute,
    PrivateRouteTeamsTeamIdSearchesIndexRouteRoute:
      PrivateRouteTeamsTeamIdSearchesIndexRouteRoute,
    PrivateRouteTeamsTeamIdSettingsIndexRouteRoute:
      PrivateRouteTeamsTeamIdSettingsIndexRouteRoute,
    PrivateRouteTeamsTeamIdPipelinesPipelineIdEditRouteRoute:
      PrivateRouteTeamsTeamIdPipelinesPipelineIdEditRouteRoute,
    PrivateRouteTeamsTeamIdIntroductionsCandidateIdIndexRouteRoute:
      PrivateRouteTeamsTeamIdIntroductionsCandidateIdIndexRouteRoute,
    PrivateRouteTeamsTeamIdSearchesSearchIdIndexRouteRoute:
      PrivateRouteTeamsTeamIdSearchesSearchIdIndexRouteRoute,
    PrivateRouteTeamsTeamIdPipelinesPipelineIdRecommendationsNewRouteRoute:
      PrivateRouteTeamsTeamIdPipelinesPipelineIdRecommendationsNewRouteRoute,
    PrivateRouteTeamsTeamIdPipelinesPipelineIdSubmissionsSubmissionIdIndexRouteRoute:
      PrivateRouteTeamsTeamIdPipelinesPipelineIdSubmissionsSubmissionIdIndexRouteRoute,
    PrivateRouteTeamsTeamIdSearchesSearchIdCandidatesCandidateIdIndexRouteRoute:
      PrivateRouteTeamsTeamIdSearchesSearchIdCandidatesCandidateIdIndexRouteRoute,
  };

const PrivateRouteTeamsTeamIdRouteRouteWithChildren =
  PrivateRouteTeamsTeamIdRouteRoute._addFileChildren(
    PrivateRouteTeamsTeamIdRouteRouteChildren,
  );

interface PrivateRouteUsersUserIdPeopleRouteRouteChildren {
  PrivateRouteUsersUserIdPeopleCandidateIdRouteRoute: typeof PrivateRouteUsersUserIdPeopleCandidateIdRouteRoute;
}

const PrivateRouteUsersUserIdPeopleRouteRouteChildren: PrivateRouteUsersUserIdPeopleRouteRouteChildren =
  {
    PrivateRouteUsersUserIdPeopleCandidateIdRouteRoute:
      PrivateRouteUsersUserIdPeopleCandidateIdRouteRoute,
  };

const PrivateRouteUsersUserIdPeopleRouteRouteWithChildren =
  PrivateRouteUsersUserIdPeopleRouteRoute._addFileChildren(
    PrivateRouteUsersUserIdPeopleRouteRouteChildren,
  );

interface PrivateRouteUsersUserIdTrendingRouteRouteChildren {
  PrivateRouteUsersUserIdTrendingIndexRoute: typeof PrivateRouteUsersUserIdTrendingIndexRoute;
  PrivateRouteUsersUserIdTrendingRecommendationIdIndexRouteRoute: typeof PrivateRouteUsersUserIdTrendingRecommendationIdIndexRouteRoute;
}

const PrivateRouteUsersUserIdTrendingRouteRouteChildren: PrivateRouteUsersUserIdTrendingRouteRouteChildren =
  {
    PrivateRouteUsersUserIdTrendingIndexRoute:
      PrivateRouteUsersUserIdTrendingIndexRoute,
    PrivateRouteUsersUserIdTrendingRecommendationIdIndexRouteRoute:
      PrivateRouteUsersUserIdTrendingRecommendationIdIndexRouteRoute,
  };

const PrivateRouteUsersUserIdTrendingRouteRouteWithChildren =
  PrivateRouteUsersUserIdTrendingRouteRoute._addFileChildren(
    PrivateRouteUsersUserIdTrendingRouteRouteChildren,
  );

interface PrivateRouteUsersUserIdRouteRouteChildren {
  PrivateRouteUsersUserIdPeopleRouteRoute: typeof PrivateRouteUsersUserIdPeopleRouteRouteWithChildren;
  PrivateRouteUsersUserIdTrendingRouteRoute: typeof PrivateRouteUsersUserIdTrendingRouteRouteWithChildren;
  PrivateRouteUsersUserIdIndexRouteRoute: typeof PrivateRouteUsersUserIdIndexRouteRoute;
  PrivateRouteUsersUserIdPipelinesNewRouteRoute: typeof PrivateRouteUsersUserIdPipelinesNewRouteRoute;
  PrivateRouteUsersUserIdEventsIndexRouteRoute: typeof PrivateRouteUsersUserIdEventsIndexRouteRoute;
  PrivateRouteUsersUserIdPipelinesIndexRouteRoute: typeof PrivateRouteUsersUserIdPipelinesIndexRouteRoute;
  PrivateRouteUsersUserIdSettingsIndexRouteRoute: typeof PrivateRouteUsersUserIdSettingsIndexRouteRoute;
  PrivateRouteUsersUserIdPipelinesPipelineIdEditRouteRoute: typeof PrivateRouteUsersUserIdPipelinesPipelineIdEditRouteRoute;
  PrivateRouteUsersUserIdEventsEventIdIndexRouteRoute: typeof PrivateRouteUsersUserIdEventsEventIdIndexRouteRoute;
  PrivateRouteUsersUserIdPipelinesPipelineIdIndexRouteRoute: typeof PrivateRouteUsersUserIdPipelinesPipelineIdIndexRouteRoute;
  PrivateRouteUsersUserIdPipelinesPipelineIdRecommendationsNewRouteRoute: typeof PrivateRouteUsersUserIdPipelinesPipelineIdRecommendationsNewRouteRoute;
  PrivateRouteUsersUserIdPipelinesPipelineIdRecommendationsRecommendationIdIndexRouteRoute: typeof PrivateRouteUsersUserIdPipelinesPipelineIdRecommendationsRecommendationIdIndexRouteRoute;
}

const PrivateRouteUsersUserIdRouteRouteChildren: PrivateRouteUsersUserIdRouteRouteChildren =
  {
    PrivateRouteUsersUserIdPeopleRouteRoute:
      PrivateRouteUsersUserIdPeopleRouteRouteWithChildren,
    PrivateRouteUsersUserIdTrendingRouteRoute:
      PrivateRouteUsersUserIdTrendingRouteRouteWithChildren,
    PrivateRouteUsersUserIdIndexRouteRoute:
      PrivateRouteUsersUserIdIndexRouteRoute,
    PrivateRouteUsersUserIdPipelinesNewRouteRoute:
      PrivateRouteUsersUserIdPipelinesNewRouteRoute,
    PrivateRouteUsersUserIdEventsIndexRouteRoute:
      PrivateRouteUsersUserIdEventsIndexRouteRoute,
    PrivateRouteUsersUserIdPipelinesIndexRouteRoute:
      PrivateRouteUsersUserIdPipelinesIndexRouteRoute,
    PrivateRouteUsersUserIdSettingsIndexRouteRoute:
      PrivateRouteUsersUserIdSettingsIndexRouteRoute,
    PrivateRouteUsersUserIdPipelinesPipelineIdEditRouteRoute:
      PrivateRouteUsersUserIdPipelinesPipelineIdEditRouteRoute,
    PrivateRouteUsersUserIdEventsEventIdIndexRouteRoute:
      PrivateRouteUsersUserIdEventsEventIdIndexRouteRoute,
    PrivateRouteUsersUserIdPipelinesPipelineIdIndexRouteRoute:
      PrivateRouteUsersUserIdPipelinesPipelineIdIndexRouteRoute,
    PrivateRouteUsersUserIdPipelinesPipelineIdRecommendationsNewRouteRoute:
      PrivateRouteUsersUserIdPipelinesPipelineIdRecommendationsNewRouteRoute,
    PrivateRouteUsersUserIdPipelinesPipelineIdRecommendationsRecommendationIdIndexRouteRoute:
      PrivateRouteUsersUserIdPipelinesPipelineIdRecommendationsRecommendationIdIndexRouteRoute,
  };

const PrivateRouteUsersUserIdRouteRouteWithChildren =
  PrivateRouteUsersUserIdRouteRoute._addFileChildren(
    PrivateRouteUsersUserIdRouteRouteChildren,
  );

interface PrivateRouteRouteRouteChildren {
  PrivateRouteSplatRouteRoute: typeof PrivateRouteSplatRouteRoute;
  PrivateRouteInternalRouteRoute: typeof PrivateRouteInternalRouteRouteWithChildren;
  PrivateRouteProfileRouteRoute: typeof PrivateRouteProfileRouteRouteWithChildren;
  PrivateRouteTeamsTeamIdRouteRoute: typeof PrivateRouteTeamsTeamIdRouteRouteWithChildren;
  PrivateRouteUsersUserIdRouteRoute: typeof PrivateRouteUsersUserIdRouteRouteWithChildren;
  PrivateRouteUsersIndexRouteRoute: typeof PrivateRouteUsersIndexRouteRoute;
  PrivateRouteUsersNewIndexRouteRoute: typeof PrivateRouteUsersNewIndexRouteRoute;
}

const PrivateRouteRouteRouteChildren: PrivateRouteRouteRouteChildren = {
  PrivateRouteSplatRouteRoute: PrivateRouteSplatRouteRoute,
  PrivateRouteInternalRouteRoute: PrivateRouteInternalRouteRouteWithChildren,
  PrivateRouteProfileRouteRoute: PrivateRouteProfileRouteRouteWithChildren,
  PrivateRouteTeamsTeamIdRouteRoute:
    PrivateRouteTeamsTeamIdRouteRouteWithChildren,
  PrivateRouteUsersUserIdRouteRoute:
    PrivateRouteUsersUserIdRouteRouteWithChildren,
  PrivateRouteUsersIndexRouteRoute: PrivateRouteUsersIndexRouteRoute,
  PrivateRouteUsersNewIndexRouteRoute: PrivateRouteUsersNewIndexRouteRoute,
};

const PrivateRouteRouteRouteWithChildren =
  PrivateRouteRouteRoute._addFileChildren(PrivateRouteRouteRouteChildren);

interface PrivateAuthLazyRouteChildren {
  PrivateAuthSetPasswordRouteRoute: typeof PrivateAuthSetPasswordRouteRoute;
  PrivateAuthSignupIndexRouteRoute: typeof PrivateAuthSignupIndexRouteRoute;
}

const PrivateAuthLazyRouteChildren: PrivateAuthLazyRouteChildren = {
  PrivateAuthSetPasswordRouteRoute: PrivateAuthSetPasswordRouteRoute,
  PrivateAuthSignupIndexRouteRoute: PrivateAuthSignupIndexRouteRoute,
};

const PrivateAuthLazyRouteWithChildren = PrivateAuthLazyRoute._addFileChildren(
  PrivateAuthLazyRouteChildren,
);

interface PrivateRouteRouteChildren {
  PrivateRouteRouteRoute: typeof PrivateRouteRouteRouteWithChildren;
  PrivateAuthLazyRoute: typeof PrivateAuthLazyRouteWithChildren;
  PrivateIndexRouteRoute: typeof PrivateIndexRouteRoute;
  PrivateTeamsIndexRouteRoute: typeof PrivateTeamsIndexRouteRoute;
  PrivateTeamsTeamIdIndexRouteRoute: typeof PrivateTeamsTeamIdIndexRouteRoute;
}

const PrivateRouteRouteChildren: PrivateRouteRouteChildren = {
  PrivateRouteRouteRoute: PrivateRouteRouteRouteWithChildren,
  PrivateAuthLazyRoute: PrivateAuthLazyRouteWithChildren,
  PrivateIndexRouteRoute: PrivateIndexRouteRoute,
  PrivateTeamsIndexRouteRoute: PrivateTeamsIndexRouteRoute,
  PrivateTeamsTeamIdIndexRouteRoute: PrivateTeamsTeamIdIndexRouteRoute,
};

const PrivateRouteRouteWithChildren = PrivateRouteRoute._addFileChildren(
  PrivateRouteRouteChildren,
);

interface EventsRouteRouteChildren {
  EventsRsvpRouteRoute: typeof EventsRsvpRouteRoute;
}

const EventsRouteRouteChildren: EventsRouteRouteChildren = {
  EventsRsvpRouteRoute: EventsRsvpRouteRoute,
};

const EventsRouteRouteWithChildren = EventsRouteRoute._addFileChildren(
  EventsRouteRouteChildren,
);

const rootRouteChildren: RootRouteChildren = {
  LayoutAuthRouteRoute: LayoutAuthRouteRouteWithChildren,
  PrivateRouteRoute: PrivateRouteRouteWithChildren,
  EventsRouteRoute: EventsRouteRouteWithChildren,
  RegistrationRouteRoute: RegistrationRouteRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
